// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.upload-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
}

.upload-dialog {
  width: 90%;
  max-width: 1400px;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: auto;
  z-index: 10000;
}

.quick-create-dialog {
  max-height: 95vh;
  max-height: 95dvh;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.quick-create-dialog.ai-review-mode {
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35), 0 0 0 1px rgba(124, 58, 237, 0.12);
}
.quick-create-dialog.ai-review-mode::before {
  content: "";
  display: block;
  height: 3px;
  background: linear-gradient(90deg, #5ea1d8 0%, #7c3aed 50%, #5ea1d8 100%);
  flex-shrink: 0;
}
.quick-create-dialog.mobile-shell {
  width: 100%;
  max-width: 100%;
  height: 100vh;
  height: 100dvh;
  max-height: 100dvh;
  border-radius: 0;
  padding-bottom: env(safe-area-inset-bottom, 0);
}

@media (min-width: 769px) and (max-width: 1024px) {
  .quick-create-dialog {
    width: 96%;
    max-width: 100%;
    max-height: 92dvh;
  }
  .smart-create-header {
    padding: 16px 20px;
  }
}
.upload-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: #fff;
  color: #111827;
  border-bottom: 1px solid #e4e8f0;
  flex-shrink: 0;
}

.smart-create-header {
  gap: 12px;
  position: relative;
  z-index: 2;
}
.smart-create-header .header-left {
  align-items: flex-start;
  min-width: 0;
  flex: 1;
}
.smart-create-header .header-copy {
  min-width: 0;
  flex: 1;
}
.smart-create-header .header-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}
.smart-create-header .title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.25;
  color: #111827;
}
.smart-create-header .header-phase-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #5b21b6;
  background: linear-gradient(135deg, #eef6fc 0%, #ede9fe 100%);
  border: 1px solid #c7d2fe;
  white-space: nowrap;
  flex-shrink: 0;
}
.smart-create-header .header-subtitle {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: #6b7280;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.smart-create-header .icon-circle {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  flex-shrink: 0;
}
.smart-create-header .icon-button {
  border-radius: 10px;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.icon-circle {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-circle mat-icon {
  color: #5ea1d8;
  font-size: 24px;
}

.header-copy p {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}
.header-copy span {
  font-size: 14px;
  color: #6b7280;
}

.smart-create-header .header-copy p,
.smart-create-header .header-copy span {
  margin: 0;
}

.icon-button {
  border: none;
  background: #f3f4f6;
  color: inherit;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.icon-button mat-icon {
  font-size: 22px;
}
.icon-button:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

.quick-create-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
}

.stage-banner,
.pieces-ai-banner,
.ai-policy-banner,
.smart-create-header,
.quick-create-footer {
  flex-shrink: 0;
}

.quick-section {
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid #e4e8f0;
}
.quick-section:last-child {
  border-bottom: none;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #111827;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.section-hint {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 16px 0;
  font-style: italic;
}

.upload-all-section .upload-all-area {
  margin-bottom: 16px;
}
.upload-all-section .upload-all-placeholder {
  width: 100%;
  min-height: 200px;
  border: 2px dashed #5ea1d8;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #f0f7ff;
  padding: 32px;
}
.upload-all-section .upload-all-placeholder:hover {
  border-color: #4a8fc4;
  background: #e8f4fd;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.2);
}
.upload-all-section .upload-all-placeholder mat-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #5ea1d8;
  margin-bottom: 16px;
}
.upload-all-section .upload-all-placeholder p {
  margin: 0 0 8px 0;
  color: #111827;
  font-size: 18px;
  font-weight: 600;
}
.upload-all-section .upload-all-placeholder .upload-hint {
  font-size: 14px;
  color: #6b7280;
  font-style: italic;
}

.cover-section .cover-upload-area {
  position: relative;
  margin-bottom: 16px;
}
.cover-section .cover-drop-zone {
  min-height: 200px;
  position: relative;
  border-radius: 12px;
  transition: all 0.3s ease;
}
.cover-section .cover-drop-zone.cdk-drop-list-dragging {
  background: linear-gradient(135deg, rgba(94, 161, 216, 0.1) 0%, rgba(94, 161, 216, 0.05) 100%);
  border: 3px dashed #5ea1d8;
  animation: dropZonePulse 2s ease-in-out infinite;
  box-shadow: inset 0 0 20px rgba(94, 161, 216, 0.1);
}
.cover-section .cover-drop-zone.has-cover {
  border: none;
  background: transparent;
}
@keyframes dropZonePulse {
  0%, 100% {
    border-color: #5ea1d8;
    box-shadow: inset 0 0 20px rgba(94, 161, 216, 0.1);
  }
  50% {
    border-color: #4a8fc4;
    box-shadow: inset 0 0 30px rgba(94, 161, 216, 0.15);
  }
}
.cover-section .cover-preview {
  position: relative;
  width: 100%;
  max-height: 400px;
  border-radius: 12px;
  overflow: visible;
  background: #f3f4f6;
  cursor: move;
  border: 3px solid transparent;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  will-change: transform, box-shadow;
}
.cover-section .cover-preview.has-video {
  max-height: 500px;
}
.cover-section .cover-preview.cdk-drag-dragging {
  opacity: 0.4;
  transform: scale(0.95);
  filter: blur(2px);
  z-index: 1;
}
.cover-section .cover-preview.cdk-drag-preview {
  opacity: 1 !important;
  transform: scale(1.15) rotate(5deg) !important;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.3), 0 0 0 6px rgba(94, 161, 216, 0.6), 0 0 0 12px rgba(94, 161, 216, 0.4), 0 0 0 18px rgba(94, 161, 216, 0.2), 0 30px 80px rgba(0, 0, 0, 0.4), 0 20px 50px rgba(94, 161, 216, 0.6), inset 0 0 0 3px rgba(255, 255, 255, 0.9) !important;
  border: 5px solid #5ea1d8 !important;
  outline: 3px solid rgba(0, 0, 0, 0.2) !important;
  outline-offset: 2px !important;
  z-index: 10000 !important;
  cursor: grabbing !important;
  animation: dragPreviewPulse 1s ease-in-out infinite !important;
  pointer-events: none !important;
  filter: drop-shadow(0 0 20px rgba(94, 161, 216, 0.8)) !important;
}
.cover-section .cover-preview.cdk-drag-preview::before {
  content: "";
  position: absolute;
  top: -20px;
  left: -20px;
  right: -20px;
  bottom: -20px;
  background: radial-gradient(circle, rgba(94, 161, 216, 0.5) 0%, rgba(94, 161, 216, 0.3) 40%, rgba(0, 0, 0, 0.1) 70%, transparent 100%);
  border-radius: 25px;
  z-index: -1;
  animation: dragGlow 1.5s ease-in-out infinite;
  pointer-events: none;
  box-shadow: 0 0 40px rgba(94, 161, 216, 0.6);
}
.cover-section .cover-preview.cdk-drag-preview::after {
  content: "";
  position: absolute;
  top: -25px;
  left: -25px;
  right: -25px;
  bottom: -25px;
  background: radial-gradient(circle, rgba(0, 0, 0, 0.15) 0%, transparent 60%);
  border-radius: 30px;
  z-index: -2;
  pointer-events: none;
}
.cover-section .cover-preview:hover:not(.cdk-drag-dragging) {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  border-color: rgba(94, 161, 216, 0.5);
}
.cover-section .cover-preview .drag-handle {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(94, 161, 216, 0.95);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  z-index: 11;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}
.cover-section .cover-preview .drag-handle:active {
  cursor: grabbing;
  transform: scale(0.9) rotate(90deg);
}
.cover-section .cover-preview .drag-handle:hover {
  background: rgb(94, 161, 216);
  transform: scale(1.15) rotate(15deg);
  box-shadow: 0 5px 15px rgba(94, 161, 216, 0.5);
}
.cover-section .cover-preview .drag-handle mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}
.cover-section .cover-preview .cover-image,
.cover-section .cover-preview .cover-video {
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: cover;
  display: block;
}
.cover-section .cover-preview .cover-video {
  max-height: 500px;
}
.cover-section .cover-preview .cover-media-shell {
  position: relative;
  display: block;
  width: 100%;
  line-height: 0;
}
.cover-section .cover-preview .preview-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(94, 161, 216, 0.85);
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  z-index: 12;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
  padding: 0;
}
.cover-section .cover-preview .preview-btn:hover {
  background: #5ea1d8;
  transform: translate(-50%, -50%) scale(1.08);
}
.cover-section .cover-preview .preview-btn mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.cover-section .cover-upload-placeholder {
  width: 100%;
  min-height: 300px;
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #f9fafb;
}
.cover-section .cover-upload-placeholder.drop-zone-active {
  border: 2px dashed #5ea1d8;
}
.cover-section .cover-upload-placeholder:hover {
  border-color: #5ea1d8;
  background: #f3f4f6;
}
.cover-section .cover-upload-placeholder.cdk-drop-list-dragging {
  border-color: #5ea1d8;
  background: #f0f7ff;
}
.cover-section .cover-upload-placeholder mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #9ca3af;
  margin-bottom: 12px;
}
.cover-section .cover-upload-placeholder p {
  margin: 0;
  color: #6b7280;
  font-size: 16px;
}
.cover-section .cover-upload-placeholder .drop-hint {
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
  margin-top: 4px;
}

.remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
  z-index: 10;
}
.remove-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}
.remove-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.add-caption-btn {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s ease;
  z-index: 10;
}
.add-caption-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}

.upload-progress {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.upload-progress mat-progress-bar {
  flex: 1;
}
.upload-progress span {
  font-size: 14px;
  color: #6b7280;
  min-width: 40px;
}

.upload-progress-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 5;
}
.upload-progress-overlay mat-progress-bar {
  flex: 1;
}
.upload-progress-overlay span {
  color: white;
  font-size: 12px;
  min-width: 35px;
}

.cover-details-display {
  margin-top: 16px;
  padding: 16px;
  background: #f9fafb;
  border-radius: 8px;
  position: relative;
}
.cover-details-display .detail-item {
  margin-bottom: 8px;
  font-size: 14px;
  color: #374151;
  line-height: 1.5;
}
.cover-details-display .detail-item strong {
  color: #111827;
  margin-right: 8px;
}
.cover-details-display .edit-caption-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #5ea1d8;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.2s ease;
}
.cover-details-display .edit-caption-btn:hover {
  background: #4a8fc4;
}
.cover-details-display .edit-caption-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.add-caption-section-btn {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #5ea1d8;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;
}
.add-caption-section-btn:hover {
  background: #4a8fc4;
}
.add-caption-section-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.full-width {
  width: 100%;
}

.steps-section .upload-steps-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #5ea1d8;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;
}
.steps-section .upload-steps-btn:hover {
  background: #4a8fc4;
}
.steps-section .upload-steps-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.steps-section .steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 16px;
  transition: all 0.3s ease;
}
.steps-section .steps-grid.cdk-drop-list-dragging {
  background: rgba(94, 161, 216, 0.02);
  border-radius: 12px;
  padding: 4px;
  margin: 12px -4px;
}
@media (max-width: 768px) {
  .steps-section .steps-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
}
.steps-section .step-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 12px;
  overflow: visible;
  cursor: move;
  background: #f3f4f6;
  border: 3px solid transparent;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  transform: scale(1);
  will-change: transform, box-shadow;
}
.steps-section .step-item.cdk-drag-dragging {
  opacity: 0.4;
  transform: scale(0.92);
  filter: blur(2px);
  z-index: 1;
}
.steps-section .step-item.cdk-drag-preview {
  opacity: 0.85 !important;
  transform: scale(1.18) rotate(5deg) !important;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.5), 0 0 0 8px rgba(94, 161, 216, 0.7), 0 0 0 14px rgba(94, 161, 216, 0.5), 0 0 0 20px rgba(94, 161, 216, 0.3), 0 35px 90px rgba(0, 0, 0, 0.5), 0 25px 60px rgba(94, 161, 216, 0.7), inset 0 0 0 3px rgba(255, 255, 255, 0.9) !important;
  border: 5px solid #5ea1d8 !important;
  outline: 4px solid rgba(0, 0, 0, 0.4) !important;
  outline-offset: 2px !important;
  z-index: 10000 !important;
  cursor: grabbing !important;
  animation: dragPreviewPulse 1s ease-in-out infinite !important;
  background: linear-gradient(135deg, rgba(243, 244, 246, 0.95) 0%, rgba(229, 231, 235, 0.95) 100%) !important;
  -webkit-backdrop-filter: blur(8px) !important;
          backdrop-filter: blur(8px) !important;
  pointer-events: none !important;
  filter: drop-shadow(0 0 25px rgba(94, 161, 216, 0.9)) drop-shadow(0 0 15px rgba(0, 0, 0, 0.3)) !important;
}
.steps-section .step-item.cdk-drag-preview::after {
  content: "";
  position: absolute;
  top: -30px;
  left: -30px;
  right: -30px;
  bottom: -30px;
  background: radial-gradient(circle, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.15) 50%, transparent 80%);
  border-radius: 35px;
  z-index: -3;
  pointer-events: none;
  animation: dragBackdropPulse 1.5s ease-in-out infinite;
}
.steps-section .step-item.cdk-drag-preview .selected-badge {
  display: flex !important;
  opacity: 1 !important;
  z-index: 25 !important;
}
.steps-section .step-item.cdk-drag-preview::before {
  content: "";
  position: absolute;
  top: -20px;
  left: -20px;
  right: -20px;
  bottom: -20px;
  background: radial-gradient(circle, rgba(94, 161, 216, 0.5) 0%, rgba(94, 161, 216, 0.3) 40%, rgba(0, 0, 0, 0.1) 70%, transparent 100%);
  border-radius: 25px;
  z-index: -1;
  animation: dragGlow 1.5s ease-in-out infinite;
  pointer-events: none;
  box-shadow: 0 0 40px rgba(94, 161, 216, 0.6);
}
.steps-section .step-item.cdk-drag-preview::after {
  content: "";
  position: absolute;
  top: -25px;
  left: -25px;
  right: -25px;
  bottom: -25px;
  background: radial-gradient(circle, rgba(0, 0, 0, 0.15) 0%, transparent 60%);
  border-radius: 30px;
  z-index: -2;
  pointer-events: none;
}
.steps-section .step-item.cdk-drag-preview .dragging-badge,
.steps-section .step-item.cdk-drag-preview .selected-dragging-badge {
  display: flex !important;
  animation: badgeDragPulse 0.8s ease-in-out infinite !important;
  z-index: 25 !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4), 0 0 0 2px rgba(255, 255, 255, 0.8) !important;
}
.steps-section .step-item.cdk-drag-preview .step-number-badge {
  background: rgb(94, 161, 216) !important;
  transform: scale(1.25) !important;
  font-size: 13px !important;
  padding: 6px 12px !important;
  font-weight: 700 !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4), 0 0 0 2px rgba(255, 255, 255, 0.8), 0 6px 20px rgba(94, 161, 216, 0.7) !important;
  border: 2px solid rgba(255, 255, 255, 0.9) !important;
}
.steps-section .step-item.cdk-drag-preview .drag-handle {
  background: rgb(94, 161, 216) !important;
  transform: scale(1.4) rotate(45deg) !important;
  box-shadow: 0 0 0 3px rgb(255, 255, 255), 0 0 0 6px rgba(94, 161, 216, 0.8), 0 12px 30px rgba(0, 0, 0, 0.5), 0 8px 20px rgba(94, 161, 216, 0.9) !important;
  z-index: 26 !important;
  border: 2px solid rgba(255, 255, 255, 0.9) !important;
}
.steps-section .step-item.cdk-drag-preview .step-preview {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: inset 0 0 0 2px rgba(94, 161, 216, 0.4) !important;
  border: 2px solid rgba(0, 0, 0, 0.1) !important;
}
.steps-section .step-item.cdk-drag-preview .step-preview img,
.steps-section .step-item.cdk-drag-preview .step-preview video {
  opacity: 0.9 !important;
  filter: contrast(1.1) brightness(0.95) !important;
}
.steps-section .step-item.cdk-drag-preview .step-preview::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(94, 161, 216, 0.25) 0%, transparent 50%);
  border-radius: 12px;
  z-index: 2;
  pointer-events: none;
}
.steps-section .step-item.cdk-drag-preview.selected.cdk-drag-preview .step-preview {
  border: 3px solid rgba(94, 161, 216, 0.5) !important;
  box-shadow: inset 0 0 0 3px rgba(94, 161, 216, 0.3) !important;
}
.steps-section .step-item.cdk-drag-preview.selected.cdk-drag-preview .step-preview img,
.steps-section .step-item.cdk-drag-preview.selected.cdk-drag-preview .step-preview video {
  opacity: 0.95 !important;
  filter: contrast(1.15) brightness(0.98) !important;
}
.steps-section .step-item.cdk-drag-preview.selected.cdk-drag-preview .step-preview::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(94, 161, 216, 0.2) 0%, transparent 50%);
  border-radius: 12px;
  z-index: 1;
  pointer-events: none;
}
.steps-section .step-item.selected.cdk-drag-preview {
  opacity: 0.9 !important;
  box-shadow: 0 0 0 6px rgba(94, 161, 216, 0.2), 0 0 0 10px rgba(94, 161, 216, 0.3), 0 0 0 4px rgba(0, 0, 0, 0.5), 0 0 0 10px rgba(94, 161, 216, 0.7), 0 0 0 16px rgba(94, 161, 216, 0.5), 0 0 0 24px rgba(94, 161, 216, 0.3), 0 40px 100px rgba(0, 0, 0, 0.6), 0 30px 70px rgba(94, 161, 216, 0.8), 0 8px 24px rgba(94, 161, 216, 0.3), inset 0 0 0 4px rgba(255, 255, 255, 0.95), inset 0 0 0 2px rgba(255, 255, 255, 0.1) !important;
  border: 4px solid #5ea1d8 !important;
  outline: 5px solid rgba(0, 0, 0, 0.4) !important;
  outline-offset: 3px !important;
  transform: scale(1.25) rotate(7deg) !important;
  filter: drop-shadow(0 0 30px rgba(94, 161, 216, 0.9)) drop-shadow(0 0 20px rgba(255, 107, 107, 0.6)) drop-shadow(0 0 10px rgba(0, 0, 0, 0.4)) !important;
  animation: dragPreviewPulse 1s ease-in-out infinite, selectedGlow 2.5s ease-in-out infinite !important;
  background: linear-gradient(135deg, rgba(243, 244, 246, 0.98) 0%, rgba(229, 231, 235, 0.98) 100%) !important;
  -webkit-backdrop-filter: blur(10px) !important;
          backdrop-filter: blur(10px) !important;
}
.steps-section .step-item.selected.cdk-drag-preview::before {
  background: radial-gradient(circle, rgba(94, 161, 216, 0.6) 0%, rgba(255, 107, 107, 0.3) 40%, rgba(0, 0, 0, 0.2) 70%, transparent 100%);
  box-shadow: 0 0 60px rgba(94, 161, 216, 0.9), 0 0 40px rgba(255, 107, 107, 0.5);
}
.steps-section .step-item.selected.cdk-drag-preview::after {
  content: "";
  position: absolute;
  top: -35px;
  left: -35px;
  right: -35px;
  bottom: -35px;
  background: radial-gradient(circle, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.1) 70%, transparent 90%);
  border-radius: 40px;
  z-index: -3;
  pointer-events: none;
  animation: dragBackdropPulse 1.5s ease-in-out infinite;
}
.steps-section .step-item.selected.cdk-drag-preview .selected-badge {
  display: flex !important;
  opacity: 1 !important;
  z-index: 25 !important;
  transform: scale(1.15) !important;
  box-shadow: 0 6px 20px rgba(94, 161, 216, 0.7), 0 0 0 3px rgba(255, 255, 255, 0.9) !important;
}
.steps-section .step-item.selected.cdk-drag-preview .step-preview::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(94, 161, 216, 0.15) 0%, transparent 50%);
  border-radius: 12px;
  z-index: 1;
  pointer-events: none;
}
.steps-section .step-item.selected.cdk-drag-preview .drag-handle {
  background: rgb(94, 161, 216) !important;
  box-shadow: 0 0 0 3px rgb(255, 255, 255), 0 0 0 6px rgba(94, 161, 216, 0.8), 0 12px 30px rgba(0, 0, 0, 0.5), 0 8px 20px rgba(94, 161, 216, 0.9), 0 0 0 2px rgba(255, 255, 255, 0.6) !important;
}
.steps-section .step-item.selected.cdk-drag-preview .step-number-badge {
  background: rgb(94, 161, 216) !important;
  transform: scale(1.2) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4), 0 0 0 2px rgba(255, 255, 255, 0.8), 0 6px 20px rgba(94, 161, 216, 0.7), 0 0 0 2px rgba(255, 255, 255, 0.6) !important;
}
.steps-section .step-item.selected.cdk-drag-preview .selected-dragging-badge {
  display: none !important;
}
.steps-section .step-item .selected-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #5ea1d8 0%, #4a8fc4 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  z-index: 20;
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.4);
  animation: badgeAppear 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  pointer-events: none;
  opacity: 1;
  transition: opacity 0.2s ease;
}
.steps-section .step-item .selected-badge mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  animation: checkPulse 2s ease-in-out infinite;
}
.steps-section .step-item .selected-badge span {
  white-space: nowrap;
}
.steps-section .step-item .dragging-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  display: none;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  z-index: 20;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.5);
  animation: badgeAppear 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), badgeDragPulse 1s ease-in-out infinite;
  pointer-events: none;
}
.steps-section .step-item .dragging-badge mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  animation: dragIconSpin 1s linear infinite;
}
.steps-section .step-item .dragging-badge span {
  white-space: nowrap;
}
.steps-section .step-item .selected-dragging-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  background: linear-gradient(135deg, #5ea1d8 0%, #4a8fc4 50%, #ff6b6b 100%);
  color: white;
  padding: 7px 14px;
  border-radius: 22px;
  display: none;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  z-index: 21;
  box-shadow: 0 6px 20px rgba(94, 161, 216, 0.6), 0 0 0 2px rgba(255, 255, 255, 0.3);
  animation: badgeAppear 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), badgeDragPulse 0.8s ease-in-out infinite;
  pointer-events: none;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.steps-section .step-item .selected-dragging-badge mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  animation: dragIconSpin 0.8s linear infinite;
}
.steps-section .step-item .selected-dragging-badge span {
  white-space: nowrap;
}
.steps-section .step-item.cdk-drag-dragging .selected-badge {
  display: none;
}
.steps-section .step-item.cdk-drag-preview.selected .selected-badge {
  display: flex !important;
}
.steps-section .step-item.cdk-drag-dragging:not(.selected) .dragging-badge, .steps-section .step-item.cdk-drag-preview:not(.selected) .dragging-badge {
  display: flex;
}
.steps-section .step-item.cdk-drag-dragging.selected .selected-dragging-badge, .steps-section .step-item.cdk-drag-preview.selected .selected-dragging-badge {
  display: flex;
}
.steps-section .step-item .step-number-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  z-index: 12;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  transition: all 0.3s ease;
  pointer-events: none;
}
.steps-section .step-item .drag-handle {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(94, 161, 216, 0.95);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  z-index: 13;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}
.steps-section .step-item .drag-handle:active {
  cursor: grabbing;
  transform: scale(0.9) rotate(90deg);
}
.steps-section .step-item .drag-handle:hover {
  background: rgb(94, 161, 216);
  transform: scale(1.15) rotate(15deg);
  box-shadow: 0 5px 15px rgba(94, 161, 216, 0.5);
}
.steps-section .step-item .drag-handle mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  transition: transform 0.3s ease;
}
.steps-section .step-item.selected {
  border: 4px solid #5ea1d8;
  box-shadow: 0 0 0 6px rgba(94, 161, 216, 0.2), 0 8px 24px rgba(94, 161, 216, 0.3), inset 0 0 0 2px rgba(255, 255, 255, 0.1);
  transform: scale(1.05);
  animation: selectedGlow 2.5s ease-in-out infinite;
  z-index: 10;
}
.steps-section .step-item.selected .drag-handle {
  background: rgb(94, 161, 216);
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.6), 0 6px 16px rgba(94, 161, 216, 0.6);
  transform: scale(1.1);
}
.steps-section .step-item.selected .step-number-badge {
  background: rgba(94, 161, 216, 0.95);
  transform: scale(1.1);
}
.steps-section .step-item.selected .step-preview::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(94, 161, 216, 0.1) 0%, transparent 50%);
  border-radius: 12px;
  z-index: 1;
  pointer-events: none;
}
.steps-section .step-item:hover:not(.cdk-drag-dragging):not(.selected) {
  transform: translateY(-6px) scale(1.03);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  border-color: rgba(94, 161, 216, 0.6);
}
.steps-section .step-item:hover:not(.cdk-drag-dragging):not(.selected) .drag-handle {
  transform: scale(1.1);
}
.steps-grid:has(.cdk-drag-dragging) .steps-section .step-item:not(.cdk-drag-dragging) {
  transition: all 0.3s ease;
  opacity: 0.6;
  filter: blur(1px);
}
.steps-section .step-item.cdk-drag-placeholder {
  opacity: 0.3;
  background: rgba(94, 161, 216, 0.1);
  border: 3px dashed #5ea1d8;
  transform: scale(0.9);
}
.steps-section .step-item .step-preview {
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
}
.steps-section .step-item .step-preview img,
.steps-section .step-item .step-preview video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.steps-section .step-item .step-preview .step-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0);
  transition: background 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.steps-section .step-item .step-preview .step-overlay:hover {
  background: rgba(0, 0, 0, 0.3);
}
@keyframes selectedGlow {
  0%, 100% {
    box-shadow: 0 0 0 6px rgba(94, 161, 216, 0.2), 0 8px 24px rgba(94, 161, 216, 0.3), inset 0 0 0 2px rgba(255, 255, 255, 0.1);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(94, 161, 216, 0.3), 0 12px 32px rgba(94, 161, 216, 0.4), inset 0 0 0 2px rgba(255, 255, 255, 0.15);
  }
}
@keyframes dragPulse {
  0%, 100% {
    box-shadow: 0 12px 32px rgba(94, 161, 216, 0.5), 0 0 0 4px rgba(94, 161, 216, 0.2);
  }
  50% {
    box-shadow: 0 16px 40px rgba(94, 161, 216, 0.6), 0 0 0 6px rgba(94, 161, 216, 0.3);
  }
}
@keyframes badgeAppear {
  0% {
    transform: scale(0) rotate(-180deg);
    opacity: 0;
  }
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
}
@keyframes checkPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
}
@keyframes badgeDragPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 4px 12px rgba(94, 161, 216, 0.4);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 6px 18px rgba(94, 161, 216, 0.6);
  }
}
@keyframes dragIconSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dragPreviewPulse {
  0%, 100% {
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.3), 0 0 0 6px rgba(94, 161, 216, 0.6), 0 0 0 12px rgba(94, 161, 216, 0.4), 0 0 0 18px rgba(94, 161, 216, 0.2), 0 30px 80px rgba(0, 0, 0, 0.4), 0 20px 50px rgba(94, 161, 216, 0.6), inset 0 0 0 3px rgba(255, 255, 255, 0.9);
    filter: drop-shadow(0 0 20px rgba(94, 161, 216, 0.8));
  }
  50% {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.4), 0 0 0 8px rgba(94, 161, 216, 0.7), 0 0 0 14px rgba(94, 161, 216, 0.5), 0 0 0 22px rgba(94, 161, 216, 0.3), 0 35px 90px rgba(0, 0, 0, 0.5), 0 25px 60px rgba(94, 161, 216, 0.7), inset 0 0 0 4px rgba(255, 255, 255, 0.95);
    filter: drop-shadow(0 0 25px rgba(94, 161, 216, 0.9));
  }
}
@keyframes dragGlow {
  0%, 100% {
    opacity: 0.7;
    transform: scale(1);
    box-shadow: 0 0 40px rgba(94, 161, 216, 0.6);
  }
  50% {
    opacity: 0.9;
    transform: scale(1.08);
    box-shadow: 0 0 60px rgba(94, 161, 216, 0.8), 0 0 30px rgba(0, 0, 0, 0.2);
  }
}
@keyframes dragBackdropPulse {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}
.steps-section .step-details-display {
  margin-top: 24px;
  padding: 20px;
  background: #f9fafb;
  border-radius: 12px;
  position: relative;
}
.steps-section .step-details-display .step-info h4 {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
}
.steps-section .step-details-display .step-info .detail-item {
  margin-bottom: 8px;
  font-size: 14px;
  color: #374151;
  line-height: 1.5;
}
.steps-section .step-details-display .step-info .detail-item strong {
  color: #111827;
  margin-right: 8px;
}
.steps-section .step-details-display .step-info .detail-item em {
  color: #9ca3af;
  font-style: italic;
}
.steps-section .step-details-display .step-actions {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 12px;
}
.steps-section .step-details-display .edit-caption-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #5ea1d8;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s ease;
}
.steps-section .step-details-display .edit-caption-btn:hover {
  background: #4a8fc4;
}
.steps-section .step-details-display .edit-caption-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.steps-section .step-details-display .delete-step-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;
}
.steps-section .step-details-display .delete-step-btn:hover {
  background: #dc2626;
}
.steps-section .step-details-display .delete-step-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.steps-section .edit-caption-btn-overlay {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
  z-index: 10;
}
.steps-section .edit-caption-btn-overlay:hover {
  background: rgba(0, 0, 0, 0.8);
}
.steps-section .edit-caption-btn-overlay mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.items-section .items-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.items-section .section-subtitle {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px 0;
  color: #111827;
}
.items-section .upload-hint {
  font-size: 12px;
  color: #6b7280;
  margin: 0 0 8px 0;
}
.items-section .upload-multiple-section {
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
  border: 2px dashed #d1d5db;
  text-align: center;
}
.items-section .upload-multiple-section .upload-icon-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #5ea1d8;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;
  margin-top: 6px;
}
.items-section .upload-multiple-section .upload-icon-btn:hover {
  background: #4a8fc4;
}
.items-section .upload-multiple-section .upload-icon-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.items-section .pending-images-section {
  margin-top: 16px;
}
.items-section .pending-images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
  margin-top: 12px;
}
@media (max-width: 768px) {
  .items-section .pending-images-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 8px;
  }
}
.items-section .pending-image-card {
  position: relative;
}
.items-section .pending-image-preview {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
  transition: all 0.2s ease;
}
.items-section .pending-image-preview.clickable {
  cursor: pointer;
}
.items-section .pending-image-preview.clickable:hover {
  border-color: #5ea1d8;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);
}
.items-section .pending-image-preview.clickable:hover .image-overlay {
  opacity: 1;
}
.items-section .pending-image-preview.uploading {
  border-color: #d1d5db;
}
.items-section .pending-image-preview .pending-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.items-section .pending-image-preview .image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(94, 161, 216, 0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 2;
}
.items-section .pending-image-preview .image-overlay .edit-icon {
  color: white;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.items-section .pending-image-preview .image-overlay .edit-text {
  color: white;
  font-size: 12px;
  font-weight: 500;
}
.items-section .pending-image-preview .upload-progress-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  z-index: 3;
}
.items-section .pending-image-preview .upload-progress-overlay mat-progress-bar {
  width: 100%;
}
.items-section .pending-image-preview .upload-progress-overlay .progress-text {
  color: white;
  font-size: 12px;
  font-weight: 500;
}
.items-section .pending-image-preview .remove-pending-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(239, 68, 68, 0.9);
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 10;
  padding: 0;
}
.items-section .pending-image-preview .remove-pending-btn:hover {
  background: rgb(239, 68, 68);
  transform: scale(1.1);
}
.items-section .pending-image-preview .remove-pending-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}
.items-section .legacy-upload-section {
  padding: 16px;
  background: #f9fafb;
  border-radius: 8px;
}
.items-section .form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}
.items-section .form-row .flex-2 {
  grid-column: span 2;
}
.items-section .item-image-upload {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.items-section .item-image-upload label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}
.items-section .item-image-upload .upload-icon-btn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
  position: relative;
  overflow: hidden;
}
.items-section .item-image-upload .upload-icon-btn:hover {
  background: #e5e7eb;
}
.items-section .item-image-upload .upload-icon-btn mat-icon {
  color: #5ea1d8;
  font-size: 24px;
}
.items-section .item-image-upload .upload-icon-btn input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.items-section .item-image-upload .item-preview {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}
.items-section .add-item-btn {
  align-self: flex-start;
  padding: 10px 20px;
  background: #5ea1d8;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;
}
.items-section .add-item-btn:hover:not(:disabled) {
  background: #4a8fc4;
}
.items-section .add-item-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.items-section .items-list {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.items-section .item-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
}
.items-section .item-card .item-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.items-section .item-card .item-info strong {
  font-size: 14px;
  color: #111827;
}
.items-section .item-card .item-info span {
  font-size: 12px;
  color: #6b7280;
}
.items-section .item-card .remove-item-btn {
  background: transparent;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.items-section .item-card .remove-item-btn:hover {
  background: #fee2e2;
  border-radius: 4px;
}

.faqs-section .faqs-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.faqs-section .add-faq-btn {
  align-self: flex-start;
  padding: 10px 20px;
  background: #5ea1d8;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.2s ease;
}
.faqs-section .add-faq-btn:hover:not(:disabled) {
  background: #4a8fc4;
}
.faqs-section .add-faq-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.faqs-section .faqs-list {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.faqs-section .faq-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  border-left: 4px solid #5ea1d8;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}
.faqs-section .faq-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.faqs-section .faq-card .faq-info {
  flex: 1;
}
.faqs-section .faq-card .faq-info strong {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 10px;
  line-height: 1.4;
}
.faqs-section .faq-card .faq-info p {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.6;
}
.faqs-section .faq-card .faq-info span {
  display: inline-block;
  font-size: 12px;
  color: #6b7280;
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 500;
}
.faqs-section .faq-card .remove-faq-btn {
  background: transparent;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  border-radius: 6px;
  transition: background 0.2s ease;
}
.faqs-section .faq-card .remove-faq-btn:hover {
  background: #fee2e2;
  background: #fee2e2;
  border-radius: 4px;
}

.price-section .price-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.price-section .price-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
}
.price-section .price-toggle-row label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}
.price-section .creator-paid-only-notice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: rgba(94, 161, 216, 0.1);
  border: 1px solid rgba(94, 161, 216, 0.28);
}
.price-section .creator-paid-only-notice .notice-title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}
.price-section .creator-paid-only-notice .notice-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  flex: 0 0 18px;
  width: 18px !important;
  height: 18px !important;
  font-size: 18px !important;
  line-height: 18px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
  color: #5ea1d8;
  transform: translateY(1px);
}
.price-section .creator-paid-only-notice .notice-lead {
  margin: 0;
  min-width: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #334155;
}
.price-section .creator-paid-only-notice .notice-detail {
  margin: 0;
  padding-left: 26px;
  font-size: 14px;
  line-height: 20px;
  color: #334155;
}
.price-section .creator-paid-only-notice .upgrade-free-link {
  display: inline-block;
  margin-top: 0.35rem;
  margin-left: 26px;
  border: none;
  background: none;
  padding: 0;
  color: #5ea1d8;
  font-weight: 700;
  font-size: 0.85rem;
  line-height: 1.3;
  cursor: pointer;
  text-decoration: underline;
}

.viewer-features-panel {
  margin-top: 8px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}
.viewer-features-panel .section-title {
  margin-bottom: 6px;
}
.viewer-features-panel .viewer-features-hint {
  margin: 0 0 14px;
  font-size: 13px;
  line-height: 1.45;
  color: #64748b;
}
.viewer-features-panel .viewer-features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 10px 16px;
}
.viewer-features-panel .viewer-features-grid mat-slide-toggle {
  font-size: 13px;
}

.stage-banner {
  padding: 1px 10px 1px;
  background: #fff;
  border-bottom: 1px solid #edf1f7;
  flex-shrink: 0;
}

.journey-progress {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 16px 0 0;
  margin-top: 12px;
  flex-shrink: 0;
  overflow-x: hidden;
  flex-wrap: nowrap;
  width: 100%;
  position: relative;
}

.journey-step {
  background: transparent;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0;
  min-width: auto;
  flex-shrink: 0;
  cursor: pointer;
  color: #9ca3af;
  transition: color 0.2s ease;
  white-space: nowrap;
  align-self: center;
}
.journey-step:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: auto;
}

.journey-step.active {
  color: #5ea1d8;
}
.journey-step.active .step-label {
  border-color: #5ea1d8;
  background: rgba(94, 161, 216, 0.1);
  color: #5ea1d8;
}

.journey-step.complete {
  color: #16a34a;
}
.journey-step.complete .step-label {
  border-color: #16a34a;
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

.step-label {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 2px solid currentColor;
  border-radius: 999px;
  transition: all 0.2s ease;
}
.step-label .step-count {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 12px;
  flex-shrink: 0;
}
.step-label .label-text {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.step-label .label-check {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #16a34a;
}
.step-label.complete {
  border-color: #16a34a;
  background: rgba(22, 163, 74, 0.1);
  color: #16a34a;
}

.step-connector {
  flex: 1;
  min-width: 20px;
  height: 2px;
  background: #e5e7eb;
  flex-shrink: 0;
  align-self: center;
  margin: 0;
  position: relative;
  z-index: 0;
  top: -10px;
}
.step-connector.fill {
  background: #16a34a;
}

@media (max-width: 768px) {
  .journey-progress {
    overflow-x: auto !important;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    padding-top: 8px;
    margin-top: 8px;
    touch-action: pan-x;
  }
  .journey-progress::-webkit-scrollbar {
    display: none;
  }
  .journey-step {
    flex: 0 0 auto;
    padding-right: 8px;
    touch-action: pan-x !important;
  }
  .step-label {
    font-size: 12px;
    letter-spacing: 0.02em;
  }
}
/* Strict no-white surfaces for all quick-create tabs in dark mode */
:host-context(body.theme-dark) .upload-dialog,
:host-context(body.theme-dark) .quick-create-dialog {
  background: #0f172a !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-group,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-header,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-wrapper,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-content,
:host-context(body.theme-dark) .upload-dialog [role=tabpanel],
:host-context(body.theme-dark) .upload-dialog .quick-create-body,
:host-context(body.theme-dark) .upload-dialog .quick-section,
:host-context(body.theme-dark) .upload-dialog .upload-all-placeholder,
:host-context(body.theme-dark) .upload-dialog .cover-upload-placeholder,
:host-context(body.theme-dark) .upload-dialog .cover-preview,
:host-context(body.theme-dark) .upload-dialog .step-preview,
:host-context(body.theme-dark) .upload-dialog .pending-image-preview,
:host-context(body.theme-dark) .upload-dialog .item-card,
:host-context(body.theme-dark) .upload-dialog .faq-card,
:host-context(body.theme-dark) .upload-dialog .step-details-display,
:host-context(body.theme-dark) .upload-dialog .cover-details-display,
:host-context(body.theme-dark) .upload-dialog .flow-main-grid,
:host-context(body.theme-dark) .upload-dialog .flow-main-content,
:host-context(body.theme-dark) .upload-dialog .flow-sidebar.summary-preview-sidebar,
:host-context(body.theme-dark) .upload-dialog .step-navigation,
:host-context(body.theme-dark) .upload-dialog .step-panel-body,
:host-context(body.theme-dark) .upload-dialog .quick-create-footer {
  background: #111827 !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog textarea,
:host-context(body.theme-dark) .upload-dialog .ql-container,
:host-context(body.theme-dark) .upload-dialog .ql-editor,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-form-field-focus-overlay,
:host-context(body.theme-dark) .upload-dialog ::ng-deep .mat-mdc-form-field-focus-overlay {
  background: #111827 !important;
  color: #f9fafb !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="background: #fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background: #ffffff"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#ffffff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#fff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #ffffff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#ffffff"],
:host-context(body.theme-dark) .upload-dialog [style*="background: white"],
:host-context(body.theme-dark) .upload-dialog [style*="background:white"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color: white"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:white"] {
  background: #111827 !important;
  background-color: #111827 !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="color: #333"],
:host-context(body.theme-dark) .upload-dialog [style*="color:#333"],
:host-context(body.theme-dark) .upload-dialog [style*="color: #666"],
:host-context(body.theme-dark) .upload-dialog [style*="color:#666"] {
  color: #f3f4f6 !important;
}

/* Final page-scoped dark-mode hardening (Quick Create Flow) */
:host-context(body.theme-dark) .upload-dialog,
:host-context(body.theme-dark) .quick-create-dialog {
  background: #0f172a !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .upload-header,
:host-context(body.theme-dark) .upload-dialog .stage-banner,
:host-context(body.theme-dark) .upload-dialog .quick-create-body,
:host-context(body.theme-dark) .upload-dialog .quick-section,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-group,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-header,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-wrapper,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-tab-body-content,
:host-context(body.theme-dark) .upload-dialog [role=tabpanel],
:host-context(body.theme-dark) .upload-dialog .flow-main-grid,
:host-context(body.theme-dark) .upload-dialog .flow-main-content,
:host-context(body.theme-dark) .upload-dialog .flow-sidebar.summary-preview-sidebar,
:host-context(body.theme-dark) .upload-dialog .step-navigation,
:host-context(body.theme-dark) .upload-dialog .step-panel-body,
:host-context(body.theme-dark) .upload-dialog .flow-title-sticky,
:host-context(body.theme-dark) .upload-dialog .flow-info-panel,
:host-context(body.theme-dark) .upload-dialog .description-section,
:host-context(body.theme-dark) .upload-dialog .video-metadata,
:host-context(body.theme-dark) .upload-dialog .channel-info-section,
:host-context(body.theme-dark) .upload-dialog .quick-create-footer,
:host-context(body.theme-dark) .upload-dialog .upload-all-placeholder,
:host-context(body.theme-dark) .upload-dialog .cover-upload-placeholder,
:host-context(body.theme-dark) .upload-dialog .cover-preview,
:host-context(body.theme-dark) .upload-dialog .step-preview,
:host-context(body.theme-dark) .upload-dialog .pending-image-preview,
:host-context(body.theme-dark) .upload-dialog .item-card,
:host-context(body.theme-dark) .upload-dialog .faq-card,
:host-context(body.theme-dark) .upload-dialog .step-details-display,
:host-context(body.theme-dark) .upload-dialog .cover-details-display {
  background: #111827 !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .upload-dialog textarea,
:host-context(body.theme-dark) .upload-dialog input,
:host-context(body.theme-dark) .upload-dialog select,
:host-context(body.theme-dark) .upload-dialog .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field--outlined,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field--filled,
:host-context(body.theme-dark) .upload-dialog .ql-container,
:host-context(body.theme-dark) .upload-dialog .ql-toolbar,
:host-context(body.theme-dark) .upload-dialog .ql-editor {
  background: #111827 !important;
  color: #f9fafb !important;
}

/* Dark mode readability fixes for Quick Create Flow */
:host-context(body.theme-dark) .upload-dialog,
:host-context(body.theme-dark) .quick-create-dialog {
  background: #0f172a !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .upload-header,
:host-context(body.theme-dark) .stage-banner,
:host-context(body.theme-dark) .quick-create-body,
:host-context(body.theme-dark) .quick-section,
:host-context(body.theme-dark) .flow-main-grid,
:host-context(body.theme-dark) .flow-main-content,
:host-context(body.theme-dark) .flow-sidebar.summary-preview-sidebar,
:host-context(body.theme-dark) .step-navigation,
:host-context(body.theme-dark) .step-panel-body,
:host-context(body.theme-dark) .flow-title-sticky,
:host-context(body.theme-dark) .flow-info-panel,
:host-context(body.theme-dark) .video-metadata,
:host-context(body.theme-dark) .channel-info-section,
:host-context(body.theme-dark) .description-section,
:host-context(body.theme-dark) .quick-create-footer {
  background: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog h1,
:host-context(body.theme-dark) .upload-dialog h2,
:host-context(body.theme-dark) .upload-dialog h3,
:host-context(body.theme-dark) .upload-dialog h4,
:host-context(body.theme-dark) .upload-dialog h5,
:host-context(body.theme-dark) .upload-dialog h6,
:host-context(body.theme-dark) .upload-dialog p,
:host-context(body.theme-dark) .upload-dialog span,
:host-context(body.theme-dark) .upload-dialog label,
:host-context(body.theme-dark) .upload-dialog li,
:host-context(body.theme-dark) .upload-dialog strong,
:host-context(body.theme-dark) .upload-dialog .step-title-text,
:host-context(body.theme-dark) .upload-dialog .step-description,
:host-context(body.theme-dark) .upload-dialog .video-title,
:host-context(body.theme-dark) .upload-dialog .video-title-sticky,
:host-context(body.theme-dark) .upload-dialog .channel-name,
:host-context(body.theme-dark) .upload-dialog .channel-meta {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field--outlined,
:host-context(body.theme-dark) .upload-dialog .mdc-text-field--filled,
:host-context(body.theme-dark) .upload-dialog input,
:host-context(body.theme-dark) .upload-dialog textarea,
:host-context(body.theme-dark) .upload-dialog select {
  background: #111827 !important;
  color: #f9fafb !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background: #f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#f0f7ff"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color: #e3f2fd"],
:host-context(body.theme-dark) .upload-dialog [style*="background: #e3f2fd"],
:host-context(body.theme-dark) .upload-dialog [style*="background-color:#e3f2fd"],
:host-context(body.theme-dark) .upload-dialog [style*="background:#e3f2fd"] {
  background: rgba(30, 41, 59, 0.75) !important;
  background-color: rgba(30, 41, 59, 0.75) !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="color: #333"],
:host-context(body.theme-dark) .upload-dialog [style*="color:#333"],
:host-context(body.theme-dark) .upload-dialog [style*="color: #666"],
:host-context(body.theme-dark) .upload-dialog [style*="color:#666"] {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .price-section .price-toggle-row,
:host-context(body.theme-dark) .price-section .price-toggle-row {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .price-section .price-toggle-row label,
:host-context(body.theme-dark) .price-section .price-toggle-row label {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .icon-circle,
:host-context(body.theme-dark) .icon-circle {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .upload-dialog .icon-circle mat-icon,
:host-context(body.theme-dark) .icon-circle mat-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .icon-button,
:host-context(body.theme-dark) .icon-button {
  background: #1f2937 !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .icon-button:hover,
:host-context(body.theme-dark) .icon-button:hover {
  background: #334155 !important;
}

/* Dark mode – Items section surfaces */
:host-context(body.theme-dark) .upload-dialog .items-section .legacy-upload-section,
:host-context(body.theme-dark) .items-section .legacy-upload-section {
  background: #1e293b !important;
  border-radius: 8px;
}
:host-context(body.theme-dark) .upload-dialog .items-section .item-image-upload label,
:host-context(body.theme-dark) .items-section .item-image-upload label {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .items-section .item-image-upload .upload-icon-btn,
:host-context(body.theme-dark) .items-section .item-image-upload .upload-icon-btn {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .items-section .item-image-upload .upload-icon-btn:hover,
:host-context(body.theme-dark) .items-section .item-image-upload .upload-icon-btn:hover {
  background: #475569 !important;
}
:host-context(body.theme-dark) .upload-dialog .items-section .item-image-upload .upload-icon-btn mat-icon,
:host-context(body.theme-dark) .items-section .item-image-upload .upload-icon-btn mat-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog .items-section .section-subtitle,
:host-context(body.theme-dark) .items-section .section-subtitle {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .items-section .upload-hint,
:host-context(body.theme-dark) .items-section .upload-hint {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .items-section .upload-multiple-section,
:host-context(body.theme-dark) .items-section .upload-multiple-section {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.4) !important;
}
:host-context(body.theme-dark) .upload-dialog .items-section .item-card .item-info strong,
:host-context(body.theme-dark) .items-section .item-card .item-info strong {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .items-section .item-card .item-info span,
:host-context(body.theme-dark) .items-section .item-card .item-info span {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .items-section .item-card .remove-item-btn:hover,
:host-context(body.theme-dark) .items-section .item-card .remove-item-btn:hover {
  background: rgba(239, 68, 68, 0.15) !important;
}

.flow-layout-container {
  width: 100%;
  padding: 0;
  margin: 0;
}
.flow-layout-container .flow-main-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 402px;
  gap: 24px;
  max-width: 100%;
  margin: 0;
  padding: 16px 24px;
  background: #f6f7f9;
}
@media (min-width: 1920px) {
  .flow-layout-container .flow-main-grid {
    max-width: 1920px;
    margin: 0 auto;
    padding: 24px 48px;
  }
}
@media (max-width: 1024px) {
  .flow-layout-container .flow-main-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
    background: transparent;
  }
}
@media (max-width: 768px) {
  .flow-layout-container .flow-main-grid {
    padding: 12px;
    gap: 12px;
  }
}

.flow-main-content {
  min-width: 0;
}
.flow-main-content .flow-title-sticky {
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media (max-width: 1024px) {
  .flow-main-content .flow-title-sticky {
    border-radius: 0;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
    border-bottom: 1px solid #e0e0e0;
    padding: 16px 0 8px 0;
    margin-bottom: 8px;
  }
}
.flow-main-content .flow-title-sticky .video-title-sticky {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  color: #0f0f0f;
  margin: 4px;
  font-family: "Raleway", sans-serif;
  flex: 1;
  min-width: 0;
}
.flow-main-content .flow-info-panel {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}
@media (max-width: 1024px) {
  .flow-main-content .flow-info-panel {
    background: #f9f9f9;
    border-radius: 8px;
  }
}
.flow-main-content .flow-info-panel::-webkit-scrollbar {
  height: 6px;
}
.flow-main-content .flow-info-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.flow-main-content .flow-info-panel::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}
.flow-main-content .flow-info-panel::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.flow-main-content .flow-info-panel .info-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Raleway", sans-serif;
  color: #0f0f0f;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 4px 12px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.flow-main-content .flow-info-panel .info-badge:hover {
  background: #f5f5f5;
  border-color: #5ea1d8;
}
.flow-main-content .flow-info-panel .info-badge.active {
  background: #5ea1d8;
  color: #fff;
  border-color: #5ea1d8;
}
.flow-main-content .flow-info-panel .info-badge.active .info-icon,
.flow-main-content .flow-info-panel .info-badge.active .info-label,
.flow-main-content .flow-info-panel .info-badge.active .info-step-title {
  color: #fff;
}
.flow-main-content .flow-info-panel .info-badge .info-icon {
  font-size: 14px;
  flex-shrink: 0;
  line-height: 1;
}
.flow-main-content .flow-info-panel .info-badge .info-label {
  font-family: "Raleway", sans-serif;
  flex-shrink: 0;
  font-size: 13px;
}
.flow-main-content .flow-info-panel .info-badge .info-step-title {
  font-size: 11px;
  color: #606060;
  margin-left: 4px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Raleway", sans-serif;
}
@media (max-width: 768px) {
  .flow-main-content .flow-info-panel .info-badge .info-step-title {
    display: none;
  }
}
@media (max-width: 768px) {
  .flow-main-content .flow-info-panel {
    gap: 6px;
    padding: 10px 12px;
  }
  .flow-main-content .flow-info-panel .info-badge {
    font-size: 12px;
    padding: 3px 10px;
    font-family: "Raleway", sans-serif;
  }
  .flow-main-content .flow-info-panel .info-badge .info-icon {
    font-size: 12px;
  }
}
.flow-main-content .video-player-section {
  background: #000;
  border-radius: 12px;
  overflow: visible;
  margin-bottom: 16px;
  position: relative;
}
.flow-main-content .video-player-section .img-wrap {
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  background: #000;
}
.flow-main-content .video-player-section .img-wrap.has-video-content {
  padding-bottom: 0;
  height: auto;
  min-height: 200px;
  aspect-ratio: 16/9;
  overflow: visible;
}
.flow-main-content .video-player-section .img-wrap.has-video-content .video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 200px;
  aspect-ratio: 16/9;
}
.flow-main-content .video-player-section .img-wrap.has-video-content .main-video-player {
  position: relative;
  top: auto;
  left: auto;
  width: 100%;
  height: 100%;
  min-height: 200px;
  display: block;
  object-fit: contain;
  background: #000;
}
.flow-main-content .video-player-section .img-wrap img,
.flow-main-content .video-player-section .img-wrap video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
.flow-main-content .video-player-section .img-wrap .video-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
}
.flow-main-content .video-player-section .img-wrap .main-video-player {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: contain;
  background: #000;
}
.flow-main-content .video-player-section .img-wrap .media-missing-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  text-align: center;
  color: #e5e7eb;
  background: #111827;
}
.flow-main-content .video-player-section .img-wrap .media-missing-placeholder mat-icon {
  font-size: 36px;
  width: 36px;
  height: 36px;
  color: #94a3b8;
}
.flow-main-content .video-player-section .img-wrap .media-missing-placeholder p {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  max-width: 280px;
}
.flow-main-content .video-player-section .step-clip-limit-toggle {
  padding: 12px 16px;
  background: #fff;
  border-top: 1px solid #e4e8f0;
}
.flow-main-content .video-player-section .item {
  padding: 20px;
  background: #fff;
  width: 100%;
  min-height: 400px;
}
.flow-main-content .video-player-section .item .item-table .example-list .example-box {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-bottom: 1px solid #e4e8f0;
}
.flow-main-content .video-player-section .item .item-table .example-list .example-box .item-value {
  flex: 1;
  color: #374151;
}
.flow-main-content .video-player-section .clickarrow {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  pointer-events: none;
}
.flow-main-content .video-player-section .clickarrow .owl-prev,
.flow-main-content .video-player-section .clickarrow .owl-next {
  pointer-events: all;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
  font-size: 26px;
  font-weight: bold;
  padding: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  margin: 0;
}
.flow-main-content .video-player-section .clickarrow .owl-prev:hover:not(:disabled),
.flow-main-content .video-player-section .clickarrow .owl-next:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.8);
  transform: translateY(-1px);
}
.flow-main-content .video-player-section .clickarrow .owl-prev:disabled, .flow-main-content .video-player-section .clickarrow .owl-prev[hidden],
.flow-main-content .video-player-section .clickarrow .owl-next:disabled,
.flow-main-content .video-player-section .clickarrow .owl-next[hidden] {
  display: none;
}
.flow-main-content .video-player-section .clickarrow .owl-prev span,
.flow-main-content .video-player-section .clickarrow .owl-next span {
  font-size: 30px;
  line-height: 1;
  font-weight: bold;
}
.flow-main-content .video-player-section .clickarrow .owl-prev {
  margin-right: auto;
  margin-left: 0;
}
.flow-main-content .video-player-section .clickarrow .owl-next {
  margin-left: auto;
  margin-right: 0;
}
.flow-main-content .summary-details-section {
  margin-top: 16px;
}
.flow-main-content .summary-details-section .summary-description .summary-title {
  font-size: 20px;
  font-weight: 600;
  color: #0f0f0f;
  margin: 0 0 12px 0;
  font-family: "Raleway", sans-serif;
}
.flow-main-content .summary-details-section .summary-description .summary-info-pills {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.flow-main-content .summary-details-section .summary-description .summary-info-pills .summary-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #111827;
  font-size: 13px;
  font-weight: 500;
}
.flow-main-content .summary-details-section .summary-description .summary-text {
  font-size: 14px;
  line-height: 1.6;
  color: #374151;
  margin: 0;
  font-family: "Raleway", sans-serif;
}

.video-metadata {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
.video-metadata .review-action-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.video-metadata .review-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  border-radius: 8px;
  background: #5ea1d8;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.video-metadata .review-action-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.video-metadata .review-action-btn--secondary {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #e5e7eb;
}
@media (max-width: 1024px) {
  .video-metadata {
    padding: 16px 0;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    border-bottom: 1px solid #e0e0e0;
  }
}
.video-metadata .step-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
}
.video-metadata .step-header .step-header-main {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
}
.video-metadata .step-header .s-num {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #065fd4;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
}
.video-metadata .step-header .video-title {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #0f0f0f;
  margin: 0;
  flex: 1;
  min-width: 0;
}
.video-metadata .video-actions-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.video-metadata .video-actions-bar::-webkit-scrollbar {
  height: 6px;
}
.video-metadata .video-actions-bar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
.video-metadata .video-actions-bar::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}
.video-metadata .video-actions-bar .action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  width: max-content;
}
.video-metadata .video-actions-bar .action-buttons .action-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 18px;
  cursor: pointer;
  transition: background 0.2s;
  background: #f2f2f2;
  flex: 0 0 auto;
}
.video-metadata .video-actions-bar .action-buttons .action-item:hover:not(.disabled) {
  background: #e5e5e5;
}
.video-metadata .video-actions-bar .action-buttons .action-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.video-metadata .video-actions-bar .action-buttons .action-item mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.video-metadata .video-actions-bar .action-buttons .action-item span {
  font-size: 14px;
  color: #0f0f0f;
}

.channel-info-section {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1024px) {
  .channel-info-section {
    padding: 16px 0;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    border-bottom: 1px solid #e0e0e0;
  }
}
.channel-info-section .channel-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
.channel-info-section .channel-header .channel-avatar {
  flex-shrink: 0;
}
.channel-info-section .channel-header .channel-avatar img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}
@media (max-width: 768px) {
  .channel-info-section .channel-header .channel-avatar img {
    width: 40px;
    height: 40px;
  }
}
.channel-info-section .channel-header .channel-avatar .material-icons {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #606060;
  cursor: pointer;
}
@media (max-width: 768px) {
  .channel-info-section .channel-header .channel-avatar .material-icons {
    font-size: 40px;
    width: 40px;
    height: 40px;
  }
}
.channel-info-section .channel-header .channel-details {
  flex: 1;
  min-width: 0;
}
.channel-info-section .channel-header .channel-details .channel-name {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  cursor: pointer;
  margin-bottom: 4px;
}
.channel-info-section .channel-header .channel-details .channel-name:hover {
  color: #606060;
}
.channel-info-section .channel-header .channel-details .channel-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 14px;
  color: #606060;
}
.channel-info-section .channel-header .channel-details .channel-meta mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.channel-info-section .channel-header .channel-details .channel-meta .price-tag {
  font-weight: 600;
  color: #d32f2f;
}

.description-section {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
}
@media (max-width: 1024px) {
  .description-section {
    background: #f9f9f9;
    border-radius: 12px;
    box-shadow: none;
  }
}
.description-section .description-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: -16px !important;
  position: relative;
}
.description-section .description-header h3 {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}
.description-section .description-header h3 .duration-timer {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #606060;
  white-space: nowrap;
  margin-left: auto;
}
.description-section .description-header h3 .duration-timer mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  margin: 0;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .description-section .description-header h3 .duration-timer {
    font-size: 13px;
  }
  .description-section .description-header h3 .duration-timer mat-icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
}
.description-section .description-content {
  font-size: 14px;
  line-height: 20px;
  color: #0f0f0f;
  max-height: 60px;
  overflow: hidden;
  transition: max-height 0.3s ease;
}
.description-section .description-content.expanded {
  max-height: none;
}

.flow-sidebar.summary-preview-sidebar {
  width: 402px;
  min-width: 402px;
  max-width: 402px;
  position: relative;
  z-index: 10;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .flow-sidebar.summary-preview-sidebar {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
}
.flow-sidebar.summary-preview-sidebar .step-navigation {
  margin-bottom: 24px;
  flex: 0 0 auto;
  min-height: 0;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll {
  max-height: calc((100vw - 48px - 402px - 24px) * 0.5625 + 80px);
  overflow-y: auto;
  overflow-x: hidden;
  display: block;
  width: 100%;
  padding-right: 8px;
}
@media (min-width: 1920px) {
  .flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll {
    max-height: 866.375px;
  }
}
@media (max-width: 1024px) {
  .flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll {
    max-height: calc((100vw - 32px) * 0.5625);
  }
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll::-webkit-scrollbar {
  width: 8px;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-scroll::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .steps-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  align-items: stretch;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn {
  padding-block: 1em;
  padding-inline: 1.125em;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #0f0f0f;
  text-align: left;
  transition: all 0.2s;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  height: auto;
  min-height: auto;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn .step-text-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 auto;
  min-width: 0;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn:hover:not(.active) {
  background: #f9f9f9;
  border-color: #c0c0c0;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn.active {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  transition: none !important;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn.active .step-number,
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn.active .step-title-text {
  color: #ffffff !important;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn.active:hover {
  background: #5ea1d8 !important;
  border: none !important;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn .step-number {
  font-size: 13px;
  font-weight: 600;
  font-family: "Raleway", sans-serif;
  flex-shrink: 0;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-btn .step-title-text {
  font-size: 13px;
  font-weight: 400;
  font-family: "Raleway", sans-serif;
  line-height: 1.4;
  word-wrap: break-word;
  overflow: visible;
  text-overflow: clip;
  display: block;
  flex: 1 1 auto;
  white-space: normal;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-panel {
  display: block;
  width: 100%;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-panel .step-btn {
  width: 100%;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-panel.active .step-btn {
  background: #5ea1d8 !important;
  color: #ffffff !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  transition: none !important;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-panel.active .step-btn .step-number,
.flow-sidebar.summary-preview-sidebar .step-navigation .step-panel.active .step-btn .step-title-text {
  color: #ffffff !important;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-panel.active .step-btn:hover {
  background: #5ea1d8 !important;
  border: none !important;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-panel-body {
  border: 1px solid #e0e0e0;
  border-top: 0;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background: #ffffff;
  padding: 12px;
  margin-top: 0;
  width: 100%;
  box-sizing: border-box;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-panel.active .step-panel-body {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-description {
  font-size: 13px;
  font-weight: 400;
  font-family: "Open Sans", sans-serif;
  line-height: 1.4;
}
.flow-sidebar.summary-preview-sidebar .step-navigation .step-description :where(p, span, div) {
  margin: 0;
}

@media (max-width: 1024px) {
  .flow-main-grid {
    grid-template-columns: 1fr !important;
  }
  .flow-sidebar.summary-preview-sidebar {
    position: relative;
    top: 0;
    margin-top: 24px;
  }
}
@media (max-width: 768px) {
  .video-metadata .step-header .step-header-main {
    flex-direction: column;
    align-items: flex-start;
  }
  .video-metadata .step-header .s-num {
    width: 28px;
    height: 28px;
    font-size: 12px;
  }
  .video-metadata .step-header .video-title {
    font-size: 18px;
  }
  .video-metadata .video-actions-bar .action-buttons .action-item {
    padding: 6px 12px;
    font-size: 12px;
  }
  .video-metadata .video-actions-bar .action-buttons .action-item span {
    display: none;
  }
  .channel-info-section .channel-header .channel-avatar .material-icons {
    font-size: 40px;
    width: 40px;
    height: 40px;
  }
  .channel-info-section .channel-header .channel-details .channel-name {
    font-size: 14px;
  }
  .channel-info-section .channel-header .channel-details .channel-meta {
    font-size: 12px;
  }
  .description-section {
    padding: 12px;
  }
  .description-section.mobile-instructions-collapsed {
    padding: 8px 12px;
    margin-bottom: 8px;
  }
  .description-section .description-header h3 {
    font-size: 14px;
  }
  .description-section .description-content {
    font-size: 13px;
  }
  .description-section .mobile-instructions-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fff;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    color: #0f0f0f;
  }
  .description-section .mobile-instructions-toggle mat-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
    color: #5ea1d8;
  }
  .description-section .mobile-instructions-toggle .toggle-chevron {
    margin-left: auto;
    color: #606060;
  }
}
.quick-create-footer {
  padding: 20px 24px;
  border-top: 1px solid #e4e8f0;
  background: white;
  display: flex !important; /* Override global \`footer { display: none }\` at ≤992px */
  justify-content: flex-end;
  gap: 12px;
}
.quick-create-footer .footer-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.quick-create-footer .footer-actions .approval-hint {
  font-size: 13px;
  color: #6b7280;
}
.quick-create-footer .footer-actions .btn-primary,
.quick-create-footer .footer-actions .btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}
.quick-create-footer .footer-actions .btn-primary:disabled,
.quick-create-footer .footer-actions .btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.quick-create-footer .footer-actions .btn-primary {
  background: #5ea1d8;
  color: white;
}
.quick-create-footer .footer-actions .btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
.quick-create-footer .footer-actions .btn-secondary {
  background: #f3f4f6;
  color: #374151;
}
.quick-create-footer .footer-actions .btn-secondary:hover:not(:disabled) {
  background: #e5e7eb;
}
@media (max-width: 768px) {
  .quick-create-footer {
    padding: 12px 16px;
    flex-direction: row;
    justify-content: stretch;
  }
  .quick-create-footer .footer-actions {
    flex-direction: row;
    width: 100%;
    gap: 8px;
  }
  .quick-create-footer .footer-actions button {
    flex: 1;
    min-width: 0;
    width: auto;
    padding: 10px 8px;
    font-size: 13px;
    white-space: nowrap;
  }
}

.actions-section .action-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 16px;
}
@media (max-width: 768px) {
  .actions-section .action-buttons {
    flex-direction: column-reverse;
  }
  .actions-section .action-buttons button {
    width: 100%;
  }
}
.actions-section .btn-primary,
.actions-section .btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}
.actions-section .btn-primary {
  background: #5ea1d8;
  color: white;
}
.actions-section .btn-primary:hover {
  background: #4a8fc4;
}
.actions-section .btn-secondary {
  background: #f3f4f6;
  color: #374151;
}
.actions-section .btn-secondary:hover {
  background: #e5e7eb;
}

@media (max-width: 768px) {
  .quick-create-dialog {
    width: 100%;
    max-width: 100%;
    height: 100vh;
    height: 100dvh;
    max-height: 100dvh;
    border-radius: 0;
  }
  .smart-create-header {
    padding: 12px 16px;
    padding-top: calc(12px + env(safe-area-inset-top, 0));
    align-items: flex-start;
  }
  .smart-create-header .icon-circle {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }
  .smart-create-header .icon-circle mat-icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
  }
  .smart-create-header .title {
    font-size: 15px;
  }
  .smart-create-header .header-phase-badge {
    font-size: 10px;
    padding: 3px 8px;
  }
  .smart-create-header .header-subtitle {
    font-size: 13px;
    -webkit-line-clamp: 3;
  }
  .smart-create-header .icon-button {
    width: 36px;
    height: 36px;
  }
  .smart-create-header .icon-button mat-icon {
    font-size: 20px;
  }
  .stage-banner {
    padding: 0 12px;
  }
  .quick-create-body {
    padding: 16px;
    padding-bottom: calc(16px + env(safe-area-inset-bottom, 0));
  }
  .quick-create-footer {
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0));
  }
  .steps-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  .form-row {
    grid-template-columns: 1fr !important;
  }
  .form-row .flex-2 {
    grid-column: span 1 !important;
  }
}
/* Dark mode – buttons, chips, step nav, action pills (Quick Create Flow) */
:host-context(body.theme-dark) .upload-dialog .info-badge,
:host-context(body.theme-dark) .info-badge {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .info-badge:hover,
:host-context(body.theme-dark) .info-badge:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .info-badge .info-step-title,
:host-context(body.theme-dark) .info-badge .info-step-title {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item,
:host-context(body.theme-dark) .action-item {
  background: #1e293b !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item:hover:not(.disabled),
:host-context(body.theme-dark) .action-item:hover:not(.disabled) {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item span,
:host-context(body.theme-dark) .action-item span {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .action-item mat-icon,
:host-context(body.theme-dark) .action-item mat-icon {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .step-btn,
:host-context(body.theme-dark) .step-btn {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .step-btn .step-number,
:host-context(body.theme-dark) .upload-dialog .step-btn .step-title-text,
:host-context(body.theme-dark) .step-btn .step-number,
:host-context(body.theme-dark) .step-btn .step-title-text {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .step-btn:hover:not(.active),
:host-context(body.theme-dark) .step-btn:hover:not(.active) {
  background: #334155 !important;
  border-color: rgba(148, 163, 184, 0.5) !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-pill,
:host-context(body.theme-dark) .summary-pill {
  background: #1e293b !important;
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .summary-text,
:host-context(body.theme-dark) .summary-text {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .upload-dialog .quick-create-footer,
:host-context(body.theme-dark) .quick-create-footer {
  background: #111827 !important;
  border-top-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-dialog .quick-create-footer .btn-secondary,
:host-context(body.theme-dark) .quick-create-footer .btn-secondary {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .quick-create-footer .btn-secondary:hover:not(:disabled),
:host-context(body.theme-dark) .quick-create-footer .btn-secondary:hover:not(:disabled) {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-dialog .channel-info-section,
:host-context(body.theme-dark) .channel-info-section {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .video-metadata .review-action-btn {
  background: #5ea1d8 !important;
  color: #fff !important;
}
:host-context(body.theme-dark) .video-metadata .review-action-btn--secondary {
  background: #1e293b !important;
  color: #f3f4f6 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .upload-dialog .step-connector,
:host-context(body.theme-dark) .step-connector {
  background: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .upload-dialog .journey-step:not(.active):not(.complete),
:host-context(body.theme-dark) .journey-step:not(.active):not(.complete) {
  color: #64748b !important;
}

/* Dark mode – Added Items list, FAQ list, info-color fixes (Quick Create Flow) */
:host-context(body.theme-dark) {
  /* ── Item cards: distinct visible box ──────────────────────────────── */
  /* ── FAQ cards: fix white bg + inner chip + body text ──────────────── */
  /* ── Inline #1d67a3 blue text (info banners, metadata) ─────────────── */
  /* ── strong tags with inline #1d67a3 color ─────────────────────────── */
  /* ── mat-icon inside inline-colored info banners ────────────────────── */
}
:host-context(body.theme-dark) .upload-dialog .item-card,
:host-context(body.theme-dark) .items-section .item-card {
  background: #1e293b !important;
  border: 1px solid rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .upload-dialog .item-card .remove-item-btn:hover,
:host-context(body.theme-dark) .items-section .item-card .remove-item-btn:hover {
  background: rgba(239, 68, 68, 0.15) !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-card,
:host-context(body.theme-dark) .faqs-section .faq-card {
  background: #1e293b !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
  border-left-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-card .faq-info span,
:host-context(body.theme-dark) .faqs-section .faq-card .faq-info span {
  background: #0f172a !important;
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-card .faq-info p,
:host-context(body.theme-dark) .faqs-section .faq-card .faq-info p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-card .faq-info strong,
:host-context(body.theme-dark) .faqs-section .faq-card .faq-info strong {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-dialog .faq-card .remove-faq-btn:hover,
:host-context(body.theme-dark) .faqs-section .faq-card .remove-faq-btn:hover {
  background: rgba(239, 68, 68, 0.15) !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="color: #1d67a3"],
:host-context(body.theme-dark) .upload-dialog [style*="color:#1d67a3"] {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog strong[style*="color: #1d67a3"],
:host-context(body.theme-dark) .upload-dialog strong[style*="color:#1d67a3"] {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-dialog [style*="color: #1d67a3"] mat-icon,
:host-context(body.theme-dark) .upload-dialog [style*="color:#1d67a3"] mat-icon {
  color: #7ab8e8 !important;
}

.duration-input-group {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
}
.duration-input-group .duration-unit-field {
  width: 120px;
  flex-shrink: 0;
}
.duration-input-group .duration-value-field {
  flex: 1;
}

.ai-processing-overlay {
  position: fixed;
  inset: 0;
  z-index: 10001;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.ai-processing-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px 40px;
  max-width: 420px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}
.ai-processing-card h3 {
  margin: 12px 0 8px;
  font-size: 20px;
  font-weight: 600;
}
.ai-processing-card p {
  margin: 0 0 20px;
  color: #6b7280;
  font-size: 14px;
}

.ai-spin-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #5ea1d8;
  animation: ai-pulse 1.5s ease-in-out infinite;
}

@keyframes ai-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.05);
  }
}
.ai-progress-bar {
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}

.ai-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #5ea1d8, #3d7eb8);
  transition: width 0.4s ease;
}

.ai-progress-text {
  font-size: 13px;
  color: #6b7280;
  font-weight: 600;
}

.ai-icon-header {
  background: linear-gradient(135deg, #eef6fc, #ede9fe) !important;
}
.ai-icon-header mat-icon {
  color: #7c3aed !important;
}

.pieces-ai-fallback-banner {
  margin: 0 24px 12px;
  border-radius: 12px;
  border: 1px solid #fcd34d;
  background: #fffbeb;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
}
.pieces-ai-fallback-banner > mat-icon {
  color: #d97706;
  flex-shrink: 0;
  margin-top: 2px;
}
.pieces-ai-fallback-banner .pieces-ai-fallback-title {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 700;
  color: #92400e;
}
.pieces-ai-fallback-banner .pieces-ai-fallback-text {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #78350f;
}
.pieces-ai-fallback-banner .pieces-ai-generate-btn {
  margin-left: auto;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .pieces-ai-fallback-banner {
    margin: 0 12px 10px;
    flex-wrap: wrap;
  }
  .pieces-ai-fallback-banner .pieces-ai-generate-btn {
    margin-left: 0;
    width: 100%;
  }
}

.pieces-ai-banner {
  margin: 0 24px 12px;
  border-radius: 12px;
  border: 1px solid #c7d2fe;
  background: linear-gradient(135deg, #f8fbff 0%, #f5f3ff 100%);
  overflow: hidden;
}
@media (max-width: 768px) {
  .pieces-ai-banner {
    margin: 0 12px 10px;
  }
}

.pieces-ai-banner-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  min-height: 56px;
}
.pieces-ai-banner-toolbar .pieces-ai-banner-title {
  margin: 0;
  font-size: 13px;
  line-height: 1.35;
}

.pieces-ai-banner-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.pieces-ai-summary-icon {
  color: #7c3aed;
  flex-shrink: 0;
}

.pieces-ai-banner-details {
  padding: 0 12px 12px;
  max-height: min(38vh, 320px);
  overflow-y: auto;
  border-top: 1px solid rgba(199, 210, 254, 0.7);
}

.pieces-ai-banner-copy--inline {
  min-width: 0;
}

.pieces-ai-banner-text--inline {
  margin-bottom: 0 !important;
  font-size: 12px !important;
}

.pieces-ai-banner-toggle-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid #c7d2fe;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  flex-shrink: 0;
  margin: 0 !important;
}
.pieces-ai-banner-toggle-btn mat-icon {
  color: #7c3aed;
  font-size: 20px;
  width: 20px;
  height: 20px;
}

/* Chevron rotation for expand/collapse panels */
.pieces-ai-chevron {
  transition: transform 0.3s ease;
}
.pieces-ai-chevron.expanded {
  transform: rotate(180deg);
}

/* Step preview button - centered eye icon overlay on step thumbnails */
.step-preview-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(94, 161, 216, 0.85);
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 15;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}
.step-preview-btn:hover {
  background: #5ea1d8;
  transform: translate(-50%, -50%) scale(1.1);
}
.step-preview-btn mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.pieces-ai-banner-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.pieces-ai-banner-icon mat-icon {
  color: #7c3aed;
}

.pieces-ai-banner-copy {
  flex: 1;
  min-width: 200px;
}

.pieces-ai-banner-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: #312e81;
}

.pieces-ai-banner-text {
  margin: 0 0 10px;
  font-size: 13px;
  color: #4b5563;
  line-height: 1.45;
}

.pieces-ai-audio-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  margin-bottom: 12px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.5;
  color: #92400e;
}

.pieces-ai-consent-section {
  margin-top: 4px;
}
.pieces-ai-consent-section.consent-highlight {
  margin-top: 10px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #f59e0b;
  background: #fffbeb;
  animation: pieces-ai-consent-pulse 1.2s ease-in-out 2;
}

@keyframes pieces-ai-consent-pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.2);
  }
}
.pieces-ai-consent {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  font-size: 12px;
  color: #374151;
  margin-bottom: 8px;
  cursor: pointer;
}
.pieces-ai-consent input {
  margin-top: 2px;
  flex-shrink: 0;
}
.pieces-ai-consent a {
  color: #2563eb;
  font-weight: 600;
  text-decoration: underline;
}

.pieces-ai-notes {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 13px;
  resize: vertical;
  min-height: 52px;
}

.pieces-ai-reference-doc {
  margin-bottom: 10px;
}

.pieces-ai-doc-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #312e81;
  margin-bottom: 6px;
}

.pieces-ai-doc-picker {
  position: relative;
  border: 1px dashed #c7d2fe;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}
.pieces-ai-doc-picker input[type=file] {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}

.pieces-ai-doc-copy,
.pieces-ai-doc-selected {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  font-size: 12px;
  color: #4b5563;
}
.pieces-ai-doc-copy mat-icon,
.pieces-ai-doc-selected mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #7c3aed;
  flex-shrink: 0;
}
.pieces-ai-doc-copy span,
.pieces-ai-doc-selected span {
  flex: 1;
  min-width: 0;
  word-break: break-word;
}

.pieces-ai-doc-selected {
  background: #f5f3ff;
}

.pieces-ai-doc-clear {
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: relative;
  z-index: 2;
}
.pieces-ai-doc-clear mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: inherit;
}

.pieces-ai-doc-hint {
  margin: 6px 0 0;
  font-size: 11px;
  color: #6b7280;
  line-height: 1.4;
}

.pieces-ai-doc-support {
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #e5e7eb;
}

.pieces-ai-generate-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 10px;
  padding: 8px 12px;
  background: #5ea1d8;
  color: #fff;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
}
.pieces-ai-generate-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pieces-ai-generate-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
@media (max-width: 768px) {
  .pieces-ai-generate-btn {
    padding: 8px 10px;
  }
  .pieces-ai-generate-btn .pieces-ai-generate-label {
    display: none;
  }
}

.upload-all-placeholder.pieces-mode {
  border-color: #c7d2fe;
  background: #fafaff;
}

.ai-policy-banner {
  margin: 0 24px 10px;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  background: #f0f7ff;
  flex-shrink: 0;
  overflow: hidden;
}
.ai-policy-banner.collapsed {
  border-color: #dbeafe;
}
.ai-policy-banner.expanded .ai-policy-details {
  border-top: 1px solid rgba(219, 234, 254, 0.9);
}
@media (max-width: 768px) {
  .ai-policy-banner {
    margin: 0 12px 10px;
  }
}

.ai-policy-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  min-height: 48px;
}

.ai-policy-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  text-align: left;
}
.ai-policy-summary .ai-policy-title {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #1e40af;
  line-height: 1.3;
}

.ai-policy-summary-hint {
  margin-left: auto;
  font-size: 11px;
  color: #6b7280;
  white-space: nowrap;
  flex-shrink: 0;
}
@media (max-width: 480px) {
  .ai-policy-summary-hint {
    display: none;
  }
}

.ai-policy-details {
  padding: 0 12px 12px 44px;
  max-height: min(32vh, 240px);
  overflow-y: auto;
}

.ai-policy-chevron {
  color: #1d4ed8;
  transition: transform 0.25s ease;
}
.ai-policy-chevron.expanded {
  transform: rotate(180deg);
}

.ai-policy-toggle-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  flex-shrink: 0;
}

.ai-policy-icon {
  color: #1d4ed8;
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.ai-policy-copy {
  flex: 1;
  min-width: 0;
}

.ai-policy-title {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 600;
  color: #1e40af;
}

.ai-policy-list {
  margin: 0;
  padding-left: 18px;
  font-size: 12px;
  color: #374151;
  line-height: 1.45;
}
.ai-policy-list li + li {
  margin-top: 4px;
}

.ai-policy-links {
  margin: 8px 0 0;
  font-size: 12px;
}
.ai-policy-links a {
  color: #2563eb;
  font-weight: 600;
  text-decoration: underline;
}

.ai-policy-sep {
  margin: 0 6px;
  color: #9ca3af;
}

/* Dark mode – Smart Create AI surfaces (added after base light styles) */
:host-context(body.theme-dark) .upload-header {
  background: #111827 !important;
  color: #f3f4f6 !important;
  border-bottom-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .upload-header .header-copy p,
:host-context(body.theme-dark) .upload-header .header-copy .title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-header .header-copy span,
:host-context(body.theme-dark) .upload-header .header-copy .header-subtitle {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-header .header-phase-badge {
  color: #e9d5ff !important;
  background: linear-gradient(135deg, #1e293b 0%, #312e81 100%) !important;
  border-color: rgba(167, 139, 250, 0.35) !important;
}
:host-context(body.theme-dark) .section-title {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .section-hint {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-all-placeholder {
  background: #1e293b !important;
  border-color: rgba(94, 161, 216, 0.5) !important;
}
:host-context(body.theme-dark) .upload-all-placeholder:hover {
  background: #334155 !important;
}
:host-context(body.theme-dark) .upload-all-placeholder p {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .upload-all-placeholder .upload-hint {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .upload-all-placeholder mat-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .upload-all-placeholder.pieces-mode {
  background: #1e293b !important;
  border-color: rgba(167, 139, 250, 0.45) !important;
}
:host-context(body.theme-dark) .journey-step {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .journey-step.active {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .journey-step.active .step-label {
  background: rgba(94, 161, 216, 0.15) !important;
  border-color: #5ea1d8 !important;
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .journey-step.complete {
  color: #4ade80 !important;
}
:host-context(body.theme-dark) .journey-step.complete .step-label {
  background: rgba(74, 222, 128, 0.12) !important;
  border-color: #4ade80 !important;
  color: #4ade80 !important;
}
:host-context(body.theme-dark) .step-label.complete {
  background: rgba(74, 222, 128, 0.12) !important;
  border-color: #4ade80 !important;
  color: #4ade80 !important;
}
:host-context(body.theme-dark) .ai-processing-card {
  background: #111827 !important;
  color: #f3f4f6 !important;
  border: 1px solid rgba(148, 163, 184, 0.28);
}
:host-context(body.theme-dark) .ai-processing-card h3 {
  color: #f3f4f6 !important;
}
:host-context(body.theme-dark) .ai-processing-card p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .ai-progress-bar {
  background: #334155 !important;
}
:host-context(body.theme-dark) .ai-progress-text {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .ai-icon-header {
  background: linear-gradient(135deg, #1e293b, #312e81) !important;
}
:host-context(body.theme-dark) .ai-icon-header mat-icon {
  color: #a78bfa !important;
}
:host-context(body.theme-dark) .pieces-ai-banner {
  background: linear-gradient(135deg, #1e293b 0%, #312e81 100%) !important;
  border-color: rgba(167, 139, 250, 0.35) !important;
}
:host-context(body.theme-dark) .pieces-ai-banner-details {
  border-top-color: rgba(167, 139, 250, 0.25) !important;
}
:host-context(body.theme-dark) .pieces-ai-banner-toggle-btn {
  background: #1e293b !important;
  border-color: rgba(167, 139, 250, 0.35) !important;
  margin: 0 !important;
}
:host-context(body.theme-dark) .pieces-ai-banner-toggle-btn mat-icon {
  color: #a78bfa !important;
}
:host-context(body.theme-dark) .pieces-ai-banner-icon {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .pieces-ai-banner-icon mat-icon {
  color: #a78bfa !important;
}
:host-context(body.theme-dark) .pieces-ai-banner-title {
  color: #e9d5ff !important;
}
:host-context(body.theme-dark) .pieces-ai-banner-text {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .pieces-ai-consent {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .pieces-ai-consent a {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .pieces-ai-consent-section.consent-highlight {
  background: rgba(120, 53, 15, 0.35) !important;
  border-color: rgba(245, 158, 11, 0.55) !important;
}
:host-context(body.theme-dark) .pieces-ai-notes {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
  color: #f9fafb !important;
}
:host-context(body.theme-dark) .pieces-ai-notes::placeholder {
  color: #64748b;
}
:host-context(body.theme-dark) .pieces-ai-doc-label {
  color: #e9d5ff !important;
}
:host-context(body.theme-dark) .pieces-ai-doc-picker {
  border-color: rgba(167, 139, 250, 0.35) !important;
  background: #111827 !important;
}
:host-context(body.theme-dark) .pieces-ai-doc-copy,
:host-context(body.theme-dark) .pieces-ai-doc-selected {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .pieces-ai-doc-copy mat-icon,
:host-context(body.theme-dark) .pieces-ai-doc-selected mat-icon {
  color: #a78bfa !important;
}
:host-context(body.theme-dark) .pieces-ai-doc-selected {
  background: #1e293b !important;
}
:host-context(body.theme-dark) .pieces-ai-doc-hint {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .pieces-ai-doc-support {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .pieces-ai-audio-warning {
  background: rgba(120, 53, 15, 0.35) !important;
  border-color: rgba(245, 158, 11, 0.55) !important;
  color: #fde68a !important;
}
:host-context(body.theme-dark) .pieces-ai-audio-warning mat-icon {
  color: #fbbf24 !important;
}
:host-context(body.theme-dark) .pieces-ai-audio-warning strong {
  color: #fde68a !important;
}
:host-context(body.theme-dark) .ai-policy-banner {
  background: rgba(30, 58, 95, 0.65) !important;
  border-color: rgba(94, 161, 216, 0.35) !important;
}
:host-context(body.theme-dark) .ai-policy-toolbar {
  background: transparent;
}
:host-context(body.theme-dark) .ai-policy-summary .ai-policy-title {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .ai-policy-summary-hint {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .ai-policy-details {
  border-top-color: rgba(94, 161, 216, 0.25) !important;
}
:host-context(body.theme-dark) .ai-policy-toggle-btn {
  background: #1e293b !important;
  border-color: rgba(94, 161, 216, 0.35) !important;
}
:host-context(body.theme-dark) .ai-policy-chevron {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .ai-policy-icon {
  color: #7ab8e8 !important;
}
:host-context(body.theme-dark) .ai-policy-title {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .ai-policy-list {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .ai-policy-links a {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .ai-policy-sep {
  color: #64748b !important;
}
:host-context(body.theme-dark) .media-size-recommendation {
  background: rgba(30, 58, 95, 0.55) !important;
  border-left-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .media-size-recommendation strong,
:host-context(body.theme-dark) .media-size-recommendation div {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .media-size-recommendation mat-icon {
  color: #7ab8e8 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/quick-create-flow/quick-create-flow.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAEF;;AACA;EACE,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AAEF;;AACA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAEF;AAAE;EACE,gFACE;AACN;AAEI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,yEAAA;EACA,cAAA;AAAN;AAIE;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AAFJ;;AAMA;EACE;IACE,UAAA;IACA,eAAA;IACA,iBAAA;EAHF;EAMA;IACE,kBAAA;EAJF;AACF;AAOA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,cAAA;AALF;;AAQA;EACE,SAAA;EACA,kBAAA;EACA,UAAA;AALF;AAOE;EACE,uBAAA;EACA,YAAA;EACA,OAAA;AALJ;AAQE;EACE,YAAA;EACA,OAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AAPJ;AAUE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;AARJ;AAWE;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AATJ;AAYE;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAVJ;AAaE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAXJ;AAcE;EACE,mBAAA;EACA,cAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAbF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAbF;AAcE;EACE,cAAA;EACA,eAAA;AAZJ;;AAiBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAdJ;AAgBE;EACE,eAAA;EACA,cAAA;AAdJ;;AAmBE;;EAEE,SAAA;AAhBJ;;AAoBA;EACE,YAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qDAAA;AAjBF;AAkBE;EACE,eAAA;AAhBJ;AAkBE;EACE,mBAAA;EACA,2BAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,iCAAA;AAjBF;;AAoBA;;;;;EAKE,cAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AAjBF;AAmBE;EACE,mBAAA;AAjBJ;;AAqBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAlBF;;AAuBE;EACE,mBAAA;AApBJ;AAuBE;EACE,WAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AArBJ;AAuBI;EACE,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,8CAAA;AArBN;AAwBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAtBN;AAyBI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAvBN;AA0BI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAxBN;;AA+BE;EACE,kBAAA;EACA,mBAAA;AA5BJ;AA+BE;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AA7BJ;AA+BI;EACE,8FAAA;EACA,0BAAA;EACA,gDAAA;EACA,kDAAA;AA7BN;AAgCI;EACE,YAAA;EACA,uBAAA;AA9BN;AAkCE;EACE;IACE,qBAAA;IACA,kDAAA;EAhCJ;EAkCE;IACE,qBAAA;IACA,mDAAA;EAhCJ;AACF;AAmCA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;EACA,sDAAA;EACA,kCAAA;AAjCF;AAmCE;EACE,iBAAA;AAjCJ;AAoCE;EACE,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;AAlCJ;AAqCE;EACE,qBAAA;EACA,8CAAA;EAEA,6QACE;EAOF,oCAAA;EACA,gDAAA;EACA,8BAAA;EACA,yBAAA;EACA,2BAAA;EACA,8DAAA;EACA,+BAAA;EACA,gEAAA;AA3CJ;AA6CI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sIAAA;EACA,mBAAA;EACA,WAAA;EACA,6CAAA;EACA,oBAAA;EACA,4CAAA;AA3CN;AA8CI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,4EAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;AA5CN;AAgDE;EACE,2BAAA;EACA,0CAAA;EACA,qCAAA;AA9CJ;AAiDE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,sDAAA;EACA,0CAAA;EACA,kCAAA;UAAA,0BAAA;AA/CJ;AAiDI;EACE,gBAAA;EACA,mCAAA;AA/CN;AAkDI;EACE,6BAAA;EACA,oCAAA;EACA,8CAAA;AAhDN;AAmDI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;AAjDN;AAqDE;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AAnDJ;AAsDE;EACE,iBAAA;AApDJ;AAuDE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;AArDJ;AAwDE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qDAAA;EACA,WAAA;EACA,0CAAA;EACA,UAAA;AAtDJ;AAwDI;EACE,mBAAA;EACA,4CAAA;AAtDN;AAyDI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvDN;AA4DE;EACE,WAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AA1DJ;AA4DI;EACE,0BAAA;AA1DN;AA6DI;EACE,qBAAA;EACA,mBAAA;AA3DN;AA8DI;EACE,qBAAA;EACA,mBAAA;AA5DN;AA+DI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AA7DN;AAgEI;EACE,SAAA;EACA,cAAA;EACA,eAAA;AA9DN;AAiEI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AA/DN;;AAoEA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;EACA,WAAA;AAjEF;AAmEE;EACE,8BAAA;AAjEJ;AAoEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAlEJ;;AAsEA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,iBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;EACA,WAAA;AAnEF;AAqEE;EACE,8BAAA;AAnEJ;;AAuEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AApEF;AAsEE;EACE,OAAA;AApEJ;AAuEE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AArEJ;;AAyEA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;AAtEF;AAwEE;EACE,OAAA;AAtEJ;AAyEE;EACE,YAAA;EACA,eAAA;EACA,eAAA;AAvEJ;;AA2EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAxEF;AA0EE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAxEJ;AA0EI;EACE,cAAA;EACA,iBAAA;AAxEN;AA4EE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AA1EJ;AA4EI;EACE,mBAAA;AA1EN;AA6EI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3EN;;AAgFA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AA7EF;AA+EE;EACE,mBAAA;AA7EJ;AAgFE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA9EJ;;AAkFA;EACE,WAAA;AA/EF;;AAoFE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAjFJ;AAmFI;EACE,mBAAA;AAjFN;AAoFI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAlFN;AAsFE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;AApFJ;AAuFI;EACE,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AArFN;AAwFI;EAfF;IAgBI,qCAAA;IACA,SAAA;EArFJ;AACF;AAwFE;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,sDAAA;EACA,mBAAA;EACA,kCAAA;AAtFJ;AAwFE;EACE,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;AAtFJ;AAyFE;EACE,wBAAA;EACA,8CAAA;EAEA,6QACE;EAOF,oCAAA;EACA,gDAAA;EACA,8BAAA;EACA,yBAAA;EACA,2BAAA;EACA,8DAAA;EAEA,4GAAA;EACA,6CAAA;UAAA,qCAAA;EACA,+BAAA;EACA,yGAAA;AAhGJ;AAmGI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qGAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,sDAAA;AAjGN;AAqGI;EACE,wBAAA;EACA,qBAAA;EACA,sBAAA;AAnGN;AAuGI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sIAAA;EACA,mBAAA;EACA,WAAA;EACA,6CAAA;EACA,oBAAA;EACA,4CAAA;AArGN;AAyGI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,4EAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;AAvGN;AA2GI;;EAEE,wBAAA;EACA,8DAAA;EACA,sBAAA;EACA,wFACE;AA1GR;AA8GI;EACE,wCAAA;EACA,iCAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,4HACE;EAGF,qDAAA;AA/GN;AAkHI;EACE,wCAAA;EACA,8CAAA;EACA,0JACE;EAIF,sBAAA;EACA,qDAAA;AApHN;AAuHI;EACE,mBAAA;EACA,gBAAA;EACA,8DAAA;EAEA,+CAAA;AAtHN;AAwHM;;EAEE,uBAAA;EACA,iDAAA;AAtHR;AAyHM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iFAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;AAvHR;AA4HI;EACE,oDAAA;EACA,8DAAA;AA1HN;AA4HM;;EAEE,wBAAA;EACA,kDAAA;AA1HR;AA6HM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gFAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;AA3HR;AAiIE;EACE,uBAAA;EAEA,qaACE;EAWF,oCAAA;EACA,gDAAA;EACA,8BAAA;EACA,8CAAA;EACA,wJAAA;EACA,sGAAA;EAEA,4GAAA;EACA,8CAAA;UAAA,sCAAA;AA5IJ;AA+II;EACE,uIAAA;EACA,+EAAA;AA7IN;AAiJI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,2HAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,sDAAA;AA/IN;AAmJI;EACE,wBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iCAAA;EACA,6FACE;AAlJR;AAwJM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iFAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;AAtJR;AA2JI;EACE,wCAAA;EACA,8LACE;AA1JR;AAkKI;EACE,wCAAA;EACA,gCAAA;EACA,gKACE;AAjKR;AAuKI;EACE,wBAAA;AArKN;AAyKI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,8CAAA;EACA,6DAAA;EACA,oBAAA;EACA,UAAA;EACA,6BAAA;AAvKN;AAyKM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,6CAAA;AAvKR;AA0KM;EACE,mBAAA;AAxKR;AA4KI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,qGAAA;EACA,oBAAA;AA1KN;AA4KM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;AA1KR;AA6KM;EACE,mBAAA;AA3KR;AA+KI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,0EAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kFACE;EAEF,uGAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;AA/KN;AAiLM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;AA/KR;AAkLM;EACE,mBAAA;AAhLR;AAsLM;EACE,aAAA;AApLR;AA0LM;EACE,wBAAA;AAxLR;AA+LM;EACE,aAAA;AA7LR;AAoMM;EACE,aAAA;AAlMR;AAsMI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kCAAA;UAAA,0BAAA;EACA,yBAAA;EACA,oBAAA;AApMN;AAuMI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,sDAAA;EACA,0CAAA;EACA,kCAAA;UAAA,0BAAA;AArMN;AAuMM;EACE,gBAAA;EACA,mCAAA;AArMR;AAwMM;EACE,6BAAA;EACA,oCAAA;EACA,8CAAA;AAtMR;AAyMM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;AAvMR;AA2MI;EACE,yBAAA;EACA,2HACE;EAGF,sBAAA;EACA,iDAAA;EACA,WAAA;AA5MN;AA8MM;EACE,6BAAA;EACA,kFACE;EAEF,qBAAA;AA9MR;AAiNM;EACE,oCAAA;EACA,qBAAA;AA/MR;AAmNQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gFAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;AAjNV;AAsNI;EACE,uCAAA;EACA,0CAAA;EACA,qCAAA;AApNN;AAsNM;EACE,qBAAA;AApNR;AAyNI;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;AAvNN;AA2NI;EACE,YAAA;EACA,mCAAA;EACA,0BAAA;EACA,qBAAA;AAzNN;AA4NI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA1NN;AA4NM;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AA1NR;AA6NM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4BAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3NR;AA6NQ;EACE,8BAAA;AA3NV;AAiOE;EACE;IACE,2HACE;EAhON;EAoOE;IACE,8HACE;EAnON;AACF;AAwOE;EACE;IACE,kFAAA;EAtOJ;EAwOE;IACE,kFAAA;EAtOJ;AACF;AAyOE;EACE;IACE,mCAAA;IACA,UAAA;EAvOJ;EAyOE;IACE,gCAAA;IACA,UAAA;EAvOJ;AACF;AA0OE;EACE;IACE,mBAAA;EAxOJ;EA0OE;IACE,qBAAA;EAxOJ;AACF;AA2OE;EACE;IACE,mBAAA;IACA,8CAAA;EAzOJ;EA2OE;IACE,qBAAA;IACA,8CAAA;EAzOJ;AACF;AA4OE;EACE;IACE,uBAAA;EA1OJ;EA4OE;IACE,yBAAA;EA1OJ;AACF;AA6OE;EACE;IACE,kQACE;IAOF,qDAAA;EAlPJ;EAoPE;IACE,mQACE;IAOF,qDAAA;EAzPJ;AACF;AA4PE;EACE;IACE,YAAA;IACA,mBAAA;IACA,4CAAA;EA1PJ;EA4PE;IACE,YAAA;IACA,sBAAA;IACA,yEAAA;EA1PJ;AACF;AA6PE;EACE;IACE,YAAA;IACA,mBAAA;EA3PJ;EA6PE;IACE,YAAA;IACA,sBAAA;EA3PJ;AACF;AA8PE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AA5PJ;AA+PM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA7PR;AAgQM;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA9PR;AAgQQ;EACE,cAAA;EACA,iBAAA;AA9PV;AAiQQ;EACE,cAAA;EACA,kBAAA;AA/PV;AAoQI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAlQN;AAqQI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AAnQN;AAqQM;EACE,mBAAA;AAnQR;AAsQM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApQR;AAwQI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAtQN;AAwQM;EACE,mBAAA;AAtQR;AAyQM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvQR;AA4QE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;EACA,WAAA;AA1QJ;AA4QI;EACE,8BAAA;AA1QN;AA6QI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3QN;;AAkRE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA/QJ;AAkRE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAhRJ;AAmRE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAjRJ;AAoRE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;AAlRJ;AAoRI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;AAlRN;AAoRM;EACE,mBAAA;AAlRR;AAqRM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAnRR;AAwRE;EACE,gBAAA;AAtRJ;AAyRE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAvRJ;AAyRI;EANF;IAOI,4DAAA;IACA,QAAA;EAtRJ;AACF;AAyRE;EACE,kBAAA;AAvRJ;AA0RE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,yBAAA;AAxRJ;AA0RI;EACE,eAAA;AAxRN;AA0RM;EACE,qBAAA;EACA,2BAAA;EACA,8CAAA;AAxRR;AA0RQ;EACE,UAAA;AAxRV;AA6RI;EACE,qBAAA;AA3RN;AA8RI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA5RN;AA+RI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;AA7RN;AA+RM;EACE,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA7RR;AAgSM;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AA9RR;AAkSI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,UAAA;AAhSN;AAkSM;EACE,WAAA;AAhSR;AAmSM;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AAjSR;AAqSI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;AAnSN;AAqSM;EACE,4BAAA;EACA,qBAAA;AAnSR;AAsSM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AApSR;AAySE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAvSJ;AA0SE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAxSJ;AA0SI;EACE,mBAAA;AAxSN;AA4SE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA1SJ;AA4SI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA1SN;AA6SI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AA3SN;AA6SM;EACE,mBAAA;AA3SR;AA8SM;EACE,cAAA;EACA,eAAA;AA5SR;AA+SM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AA7SR;AAiTI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA/SN;AAmTE;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAjTJ;AAmTI;EACE,mBAAA;AAjTN;AAoTI;EACE,YAAA;EACA,mBAAA;AAlTN;AAsTE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AApTJ;AAuTE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AArTJ;AAuTI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AArTN;AAuTM;EACE,eAAA;EACA,cAAA;AArTR;AAwTM;EACE,eAAA;EACA,cAAA;AAtTR;AA0TI;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxTN;AA0TM;EACE,mBAAA;EACA,kBAAA;AAxTR;;AAgUE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA7TJ;AAgUE;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AA9TJ;AAgUI;EACE,mBAAA;AA9TN;AAiUI;EACE,YAAA;EACA,mBAAA;AA/TN;AAmUE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAjUJ;AAoUE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,wCAAA;EACA,yBAAA;AAlUJ;AAoUI;EACE,yCAAA;EACA,2BAAA;AAlUN;AAqUI;EACE,OAAA;AAnUN;AAqUM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAnUR;AAsUM;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AApUR;AAuUM;EACE,qBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AArUR;AAyUI;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;AAvUN;AAyUM;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;AAvUR;;AA+UE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA5UJ;AA+UE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AA7UJ;AA+UI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA7UN;AAiVE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;EACA,mCAAA;EACA,0CAAA;AA/UJ;AAiVI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AA/UN;AAkVI;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,0BAAA;AAhVN;AAmVI;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAjVN;AAoVI;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlVN;AAqVI;EACE,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAnVN;;AAwVA;EACE,eAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AArVF;AAuVE;EACE,kBAAA;AArVJ;AAwVE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAtVJ;AAyVE;EACE,aAAA;EACA,4DAAA;EACA,cAAA;AAvVJ;AAyVI;EACE,eAAA;AAvVN;;AA+VA;EACE,qBAAA;EACA,gBAAA;EACA,gCAAA;EACA,cAAA;AA5VF;;AA+VA;EACE,aAAA;EACA,mBAAA;EACA,MAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AA5VF;;AA+VA;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,MAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;AA5VF;AA8VE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AA5VJ;;AAgWA;EACE,cAAA;AA7VF;AA8VE;EACE,qBAAA;EACA,mCAAA;EACA,cAAA;AA5VJ;;AAgWA;EACE,cAAA;AA7VF;AA8VE;EACE,qBAAA;EACA,kCAAA;EACA,cAAA;AA5VJ;;AAgWA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yBAAA;AA7VF;AA+VE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA7VJ;AAgWE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AA9VJ;AAiWE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AA/VJ;AAkWE;EACE,qBAAA;EACA,kCAAA;EACA,cAAA;AAhWJ;;AAoWA;EACE,OAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AAjWF;AAmWE;EACE,mBAAA;AAjWJ;;AAqWA;EACE;IACE,2BAAA;IACA,kBAAA;IACA,iCAAA;IACA,qBAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EAlWF;EAoWE;IACE,aAAA;EAlWJ;EAsWA;IACE,cAAA;IACA,kBAAA;IACA,8BAAA;EApWF;EAuWA;IACE,eAAA;IACA,sBAAA;EArWF;AACF;AAwWA,oEAAA;AAEE;;EAEE,8BAAA;EACA,yBAAA;AAvWJ;AA0WE;;;;;;;;;;;;;;;;;;;;;;;EAuBE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAxWJ;AA2WE;;;;;EAKE,8BAAA;EACA,yBAAA;AAzWJ;AA4WE;;;;;;;;;;;;EAYE,8BAAA;EACA,oCAAA;AA1WJ;AA6WE;;;;EAIE,yBAAA;AA3WJ;;AA+WA,8DAAA;AAEE;;EAEE,8BAAA;EACA,yBAAA;AA7WJ;AAgXE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA8BE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA9WJ;AAiXE;;;;;;;;;;EAUE,8BAAA;EACA,yBAAA;AA/WJ;;AAmXA,sDAAA;AAEE;;EAEE,8BAAA;EACA,yBAAA;AAjXJ;AAoXE;;;;;;;;;;;;;;;EAeE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAlXJ;AAqXE;;;;;;;;;;;;;;;;;EAiBE,yBAAA;AAnXJ;AAsXE;;;;;;;EAOE,8BAAA;EACA,yBAAA;AApXJ;AAuXE;;;;;;;;EAQE,6CAAA;EACA,mDAAA;AArXJ;AAwXE;;;;EAIE,yBAAA;AAtXJ;AAyXE;;EAEE,8BAAA;EACA,kDAAA;AAvXJ;AAyXI;;EACE,yBAAA;AAtXN;AA0XE;;EAEE,8BAAA;AAxXJ;AA0XI;;EACE,yBAAA;AAvXN;AA2XE;;EAEE,8BAAA;EACA,yBAAA;AAzXJ;AA2XI;;EACE,8BAAA;AAxXN;;AA6XA,uCAAA;AAGE;;EAEE,8BAAA;EACA,kBAAA;AA5XJ;AA+XE;;EAEE,yBAAA;AA7XJ;AAgYE;;EAEE,8BAAA;AA9XJ;AAgYI;;EACE,8BAAA;AA7XN;AAgYI;;EACE,yBAAA;AA7XN;AAiYE;;EAEE,yBAAA;AA/XJ;AAkYE;;EAEE,yBAAA;AAhYJ;AAmYE;;EAEE,8BAAA;EACA,iDAAA;AAjYJ;AAoYE;;EAEE,yBAAA;AAlYJ;AAqYE;;EAEE,yBAAA;AAnYJ;AAsYE;;EAEE,8CAAA;AApYJ;;AAyYA;EACE,WAAA;EACA,UAAA;EACA,SAAA;AAtYF;AAwYE;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AAtYJ;AAwYI;EATF;IAUI,iBAAA;IACA,cAAA;IACA,kBAAA;EArYJ;AACF;AAuYI;EAfF;IAgBI,0BAAA;IACA,SAAA;IACA,aAAA;IACA,uBAAA;EApYJ;AACF;AAsYI;EAtBF;IAuBI,aAAA;IACA,SAAA;EAnYJ;AACF;;AAuYA;EACE,YAAA;AApYF;AAsYE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,8BAAA;AApYJ;AAsYI;EAXF;IAYI,gBAAA;IACA,uCAAA;IACA,gCAAA;IACA,qBAAA;IACA,kBAAA;EAnYJ;AACF;AAqYI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kCAAA;EACA,OAAA;EACA,YAAA;AAnYN;AAuYE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EAMA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;AA1YJ;AAkYI;EATF;IAUI,mBAAA;IACA,kBAAA;EA/XJ;AACF;AAsYI;EACE,WAAA;AApYN;AAuYI;EACE,mBAAA;EACA,kBAAA;AArYN;AAwYI;EACE,gBAAA;EACA,kBAAA;AAtYN;AAwYM;EACE,gBAAA;AAtYR;AA0YI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;EAAA,sBAAA;AAxYN;AA0YM;EACE,mBAAA;EACA,qBAAA;AAxYR;AA2YM;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAzYR;AA2YQ;;;EAGE,WAAA;AAzYV;AA6YM;EACE,eAAA;EACA,cAAA;EACA,cAAA;AA3YR;AA8YM;EACE,kCAAA;EACA,cAAA;EACA,eAAA;AA5YR;AA+YM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;AA7YR;AA+YQ;EAVF;IAWI,aAAA;EA5YR;AACF;AAgZI;EApGF;IAqGI,QAAA;IACA,kBAAA;EA7YJ;EA+YI;IACE,eAAA;IACA,iBAAA;IACA,kCAAA;EA7YN;EA+YM;IACE,eAAA;EA7YR;AACF;AAkZE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAhZJ;AAkZI;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AAhZN;AAkZM;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAhZR;AAkZQ;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAhZV;AAmZQ;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAjZV;AAqZM;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAnZR;AAsZM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AApZR;AAuZM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;AArZR;AAwZM;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAtZR;AAwZQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAtZV;AAyZQ;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAvZV;AA4ZI;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;AA1ZN;AA6ZI;EACE,aAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AA3ZN;AA+ZU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gCAAA;AA7ZZ;AA+ZY;EACE,OAAA;EACA,cAAA;AA7Zd;AAoaI;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAlaN;AAoaM;;EAEE,mBAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,0CAAA;EACA,SAAA;AAlaR;AAoaQ;;EACE,8BAAA;EACA,2BAAA;AAjaV;AAoaQ;;;EAEE,aAAA;AAjaV;AAoaQ;;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AAjaV;AAqaM;EACE,kBAAA;EACA,cAAA;AAnaR;AAsaM;EACE,iBAAA;EACA,eAAA;AApaR;AAyaE;EACE,gBAAA;AAvaJ;AA0aM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;AAxaR;AA2aM;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;AAzaR;AA2aQ;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAzaV;AA6aM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,kCAAA;AA3aR;;AAkbA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AA/aF;AAibE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AA/aJ;AAkbE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAhbJ;AAkbI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhbN;AAmbI;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAjbN;AAqbE;EAvCF;IAwCI,eAAA;IACA,uBAAA;IACA,gBAAA;IACA,gBAAA;IACA,gCAAA;EAlbF;AACF;AAobE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AAlbJ;AAobI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AAlbN;AAqbI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAnbN;AAsbI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AApbN;AAwbE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AAtbJ;AAwbI;EACE,WAAA;AAtbN;AAybI;EACE,8BAAA;EACA,kBAAA;AAvbN;AA0bI;EACE,8BAAA;AAxbN;AA2bI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AAzbN;AA2bM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;AAzbR;AA2bQ;EACE,mBAAA;AAzbV;AA4bQ;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AA1bV;AA6bQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3bV;AA8bQ;EACE,eAAA;EACA,cAAA;AA5bV;;AAocA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAjcF;AAmcE;EANF;IAOI,eAAA;IACA,uBAAA;IACA,gBAAA;IACA,gBAAA;IACA,gCAAA;EAhcF;AACF;AAkcE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhcJ;AAkcI;EACE,cAAA;AAhcN;AAkcM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAhcR;AAkcQ;EAPF;IAQI,WAAA;IACA,YAAA;EA/bR;AACF;AAkcM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAhcR;AAkcQ;EAPF;IAQI,eAAA;IACA,WAAA;IACA,YAAA;EA/bR;AACF;AAmcI;EACE,OAAA;EACA,YAAA;AAjcN;AAmcM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAjcR;AAmcQ;EACE,cAAA;AAjcV;AAqcM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAncR;AAqcQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAncV;AAscQ;EACE,gBAAA;EACA,cAAA;AApcV;;AA4cA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AAzcF;AA2cE;EANF;IAOI,mBAAA;IACA,mBAAA;IACA,gBAAA;EAxcF;AACF;AA0cE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;AAxcJ;AA0cI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;AAxcN;AA0cM;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAxcR;AA0cQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AAxcV;AA2cQ;EApBF;IAqBI,eAAA;EAxcR;EA0cQ;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAxcV;AACF;AA8cE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;AA5cJ;AA8cI;EACE,gBAAA;AA5cN;;AAkdA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AA/cF;AAidE;EAVF;IAWI,WAAA;IACA,eAAA;IACA,eAAA;EA9cF;AACF;AAgdE;EACE,mBAAA;EACA,cAAA;EACA,aAAA;AA9cJ;AAgdI;EACE,+DAAA;EAUA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAvdN;AA2cM;EAHF;IAII,qBAAA;EAxcN;AACF;AA0cM;EAPF;IAQI,yCAAA;EAvcN;AACF;AA+cM;EACE,UAAA;AA7cR;AAgdM;EACE,mBAAA;EACA,kBAAA;AA9cR;AAidM;EACE,gBAAA;EACA,kBAAA;AA/cR;AAidQ;EACE,gBAAA;AA/cV;AAodI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;AAldN;AAqdI;EACE,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AAndN;AAqdM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AAndR;AAsdM;EACE,mBAAA;EACA,qBAAA;AApdR;AAudM;EACE,8BAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,2BAAA;AArdR;AAudQ;;EAEE,yBAAA;AArdV;AAwdQ;EACE,8BAAA;EACA,uBAAA;AAtdV;AA0dM;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;AAxdR;AA2dM;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;AAzdR;AA6dI;EACE,cAAA;EACA,WAAA;AA3dN;AA8dI;EACE,WAAA;AA5dN;AA+dI;EACE,8BAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;AA7dN;AA+dM;;EAEE,yBAAA;AA7dR;AAgeM;EACE,8BAAA;EACA,uBAAA;AA9dR;AAkeI;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AAheN;AAmeI;EACE,yBAAA;EACA,0BAAA;AAjeN;AAoeI;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,gBAAA;AAleN;AAoeM;EACE,SAAA;AAleR;;AAyeA;EACE;IACE,qCAAA;EAteF;EAyeA;IACE,kBAAA;IACA,MAAA;IACA,gBAAA;EAveF;AACF;AA0eA;EAGM;IACE,sBAAA;IACA,uBAAA;EA1eN;EA6eI;IACE,WAAA;IACA,YAAA;IACA,eAAA;EA3eN;EA8eI;IACE,eAAA;EA5eN;EAkfM;IACE,iBAAA;IACA,eAAA;EAhfR;EAkfQ;IACE,aAAA;EAhfV;EAyfI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAvfN;EA2fM;IACE,eAAA;EAzfR;EA4fM;IACE,eAAA;EA1fR;EAggBA;IACE,aAAA;EA9fF;EAggBE;IACE,iBAAA;IACA,kBAAA;EA9fJ;EAigBE;IACE,eAAA;EA/fJ;EAkgBE;IACE,eAAA;EAhgBJ;EAmgBE;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,WAAA;IACA,iBAAA;IACA,yBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;EAjgBJ;EAmgBI;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;EAjgBN;EAogBI;IACE,iBAAA;IACA,cAAA;EAlgBN;AACF;AA0gBA;EACE,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,wBAAA,EAAA,yDAAA;EACA,yBAAA;EACA,SAAA;AAxgBF;AA0gBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAxgBJ;AA0gBI;EACE,eAAA;EACA,cAAA;AAxgBN;AA2gBI;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAzgBN;AA2gBM;;EACE,YAAA;EACA,mBAAA;AAxgBR;AA4gBI;EACE,mBAAA;EACA,YAAA;AA1gBN;AA4gBM;EACE,mBAAA;AA1gBR;AA8gBI;EACE,mBAAA;EACA,cAAA;AA5gBN;AA8gBM;EACE,mBAAA;AA5gBR;AAihBE;EArDF;IAsDI,kBAAA;IACA,mBAAA;IACA,wBAAA;EA9gBF;EAghBE;IACE,mBAAA;IACA,WAAA;IACA,QAAA;EA9gBJ;EAghBI;IACE,OAAA;IACA,YAAA;IACA,WAAA;IACA,iBAAA;IACA,eAAA;IACA,mBAAA;EA9gBN;AACF;;AAohBE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;AAjhBJ;AAmhBI;EANF;IAOI,8BAAA;EAhhBJ;EAkhBI;IACE,WAAA;EAhhBN;AACF;AAohBE;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AAlhBJ;AAqhBE;EACE,mBAAA;EACA,YAAA;AAnhBJ;AAqhBI;EACE,mBAAA;AAnhBN;AAuhBE;EACE,mBAAA;EACA,cAAA;AArhBJ;AAuhBI;EACE,mBAAA;AArhBN;;AA2hBA;EACE;IACE,WAAA;IACA,eAAA;IACA,aAAA;IACA,cAAA;IACA,kBAAA;IACA,gBAAA;EAxhBF;EA2hBA;IACE,kBAAA;IACA,qDAAA;IACA,uBAAA;EAzhBF;EA2hBE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EAzhBJ;EA2hBI;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAzhBN;EA6hBE;IACE,eAAA;EA3hBJ;EA8hBE;IACE,eAAA;IACA,gBAAA;EA5hBJ;EA+hBE;IACE,eAAA;IACA,qBAAA;EA7hBJ;EAgiBE;IACE,WAAA;IACA,YAAA;EA9hBJ;EAgiBI;IACE,eAAA;EA9hBN;EAmiBA;IACE,eAAA;EAjiBF;EAoiBA;IACE,aAAA;IACA,2DAAA;EAliBF;EAqiBA;IACE,kBAAA;IACA,2DAAA;EAniBF;EAsiBA;IACE,gDAAA;EApiBF;EAuiBA;IACE,qCAAA;EAriBF;EAuiBE;IACE,8BAAA;EAriBJ;AACF;AAyiBA,2EAAA;AAGE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAziBJ;AA2iBI;;EACE,8BAAA;AAxiBN;AA2iBI;;EACE,yBAAA;AAxiBN;AA4iBE;;EAEE,8BAAA;AA1iBJ;AA4iBI;;EACE,8BAAA;AAziBN;AA4iBI;;EACE,yBAAA;AAziBN;AA4iBI;;EACE,yBAAA;AAziBN;AA8iBE;;EAEE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA5iBJ;AA8iBI;;;;EAEE,yBAAA;AA1iBN;AA6iBI;;EACE,8BAAA;EACA,iDAAA;AA1iBN;AA+iBE;;EAEE,8BAAA;EACA,yBAAA;AA7iBJ;AAgjBE;;EAEE,yBAAA;AA9iBJ;AAkjBE;;EAEE,8BAAA;EACA,sDAAA;AAhjBJ;AAkjBI;;EACE,8BAAA;EACA,yBAAA;EACA,sDAAA;AA/iBN;AAijBM;;EACE,8BAAA;AA9iBR;AAojBE;;EAEE,8BAAA;EACA,kDAAA;AAljBJ;AAqjBE;EACE,8BAAA;EACA,sBAAA;AAnjBJ;AAqjBI;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAnjBN;AAwjBE;;EAEE,+CAAA;AAtjBJ;AA0jBE;;EAEE,yBAAA;AAxjBJ;;AA4jBA,iFAAA;AACA;EACE,yEAAA;EAYA,yEAAA;EA6BA,yEAAA;EAMA,yEAAA;EAMA,0EAAA;AA1mBF;AAsjBE;;EAEE,8BAAA;EACA,qDAAA;AApjBJ;AAujBE;;EAEE,8CAAA;AArjBJ;AAyjBE;;EAEE,8BAAA;EACA,iDAAA;EACA,qCAAA;AAvjBJ;AA0jBE;;EAEE,8BAAA;EACA,yBAAA;AAxjBJ;AA2jBE;;EAEE,yBAAA;AAzjBJ;AA4jBE;;EAEE,yBAAA;AA1jBJ;AA6jBE;;EAEE,8CAAA;AA3jBJ;AA+jBE;;EAEE,yBAAA;AA7jBJ;AAikBE;;EAEE,yBAAA;AA/jBJ;AAmkBE;;EAEE,yBAAA;AAjkBJ;;AAqkBA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;AAlkBF;AAokBE;EACE,YAAA;EACA,cAAA;AAlkBJ;AAqkBE;EACE,OAAA;AAnkBJ;;AAukBA;EACE,eAAA;EACA,QAAA;EACA,cAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AApkBF;;AAukBA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,2CAAA;AApkBF;AAskBE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AApkBJ;AAukBE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AArkBJ;;AAykBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,6CAAA;AAtkBF;;AAykBA;EACE;IAEE,UAAA;IACA,mBAAA;EAvkBF;EAykBA;IACE,YAAA;IACA,sBAAA;EAvkBF;AACF;AA0kBA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAxkBF;;AA2kBA;EACE,YAAA;EACA,oDAAA;EACA,2BAAA;AAxkBF;;AA2kBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAxkBF;;AA2kBA;EACE,gEAAA;AAxkBF;AA0kBE;EACE,yBAAA;AAxkBJ;;AA4kBA;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;AAzkBF;AA2kBE;EACE,cAAA;EACA,cAAA;EACA,eAAA;AAzkBJ;AA4kBE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA1kBJ;AA6kBE;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA3kBJ;AA8kBE;EACE,iBAAA;EACA,cAAA;AA5kBJ;AA+kBE;EAnCF;IAoCI,mBAAA;IACA,eAAA;EA5kBF;EA8kBE;IACE,cAAA;IACA,WAAA;EA5kBJ;AACF;;AAglBA;EACE,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6DAAA;EACA,gBAAA;AA7kBF;AA+kBE;EAPF;IAQI,mBAAA;EA5kBF;AACF;;AA+kBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AA5kBF;AA8kBE;EACE,SAAA;EACA,eAAA;EACA,iBAAA;AA5kBJ;;AAglBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AA7kBF;;AAglBA;EACE,cAAA;EACA,cAAA;AA7kBF;;AAglBA;EACE,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,8CAAA;AA7kBF;;AAglBA;EACE,YAAA;AA7kBF;;AAglBA;EACE,2BAAA;EACA,0BAAA;AA7kBF;;AAglBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AA7kBF;AA+kBE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA7kBJ;;AAilBA,gDAAA;AACA;EACE,+BAAA;AA9kBF;AAglBE;EACE,yBAAA;AA9kBJ;;AAklBA,uEAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,yCAAA;AA/kBF;AAilBE;EACE,mBAAA;EACA,2CAAA;AA/kBJ;AAklBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhlBJ;;AAolBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAjlBF;AAmlBE;EACE,cAAA;AAjlBJ;;AAqlBA;EACE,OAAA;EACA,gBAAA;AAllBF;;AAqlBA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAllBF;;AAqlBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAllBF;;AAqlBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAllBF;;AAqlBA;EACE,eAAA;AAllBF;AAolBE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qDAAA;AAllBJ;;AAslBA;EACE;IAEE,yCAAA;EAplBF;EAslBA;IACE,6CAAA;EAplBF;AACF;AAulBA;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AArlBF;AAulBE;EACE,eAAA;EACA,cAAA;AArlBJ;AAwlBE;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;AAtlBJ;;AA0lBA;EACE,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAvlBF;;AA0lBA;EACE,mBAAA;AAvlBF;;AA0lBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAvlBF;;AA0lBA;EACE,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAvlBF;AAylBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AAvlBJ;;AA2lBA;;EAEE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AAxlBF;AA0lBE;;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAvlBJ;AA0lBE;;EACE,OAAA;EACA,YAAA;EACA,sBAAA;AAvlBJ;;AA2lBA;EACE,mBAAA;AAxlBF;;AA2lBA;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AAxlBF;AA0lBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAxlBJ;;AA4lBA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAzlBF;;AA4lBA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAzlBF;;AA4lBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAzlBF;AA2lBE;EACE,YAAA;EACA,mBAAA;AAzlBJ;AA4lBE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA1lBJ;AA6lBE;EA1BF;IA+BI,iBAAA;EA9lBF;EA0lBE;IACE,aAAA;EAxlBJ;AACF;;AA8lBA;EACE,qBAAA;EACA,mBAAA;AA3lBF;;AA8lBA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA3lBF;AA6lBE;EACE,qBAAA;AA3lBJ;AA+lBI;EACE,8CAAA;AA7lBN;AAimBE;EAlBF;IAmBI,mBAAA;EA9lBF;AACF;;AAimBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AA9lBF;;AAimBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AA9lBF;AAgmBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA9lBJ;;AAkmBA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AA/lBF;AAimBE;EAPF;IAQI,aAAA;EA9lBF;AACF;;AAimBA;EACE,yBAAA;EACA,4BAAA;EACA,gBAAA;AA9lBF;;AAimBA;EACE,cAAA;EACA,gCAAA;AA9lBF;AAgmBE;EACE,yBAAA;AA9lBJ;;AAkmBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA/lBF;;AAkmBA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA/lBF;;AAkmBA;EACE,OAAA;EACA,YAAA;AA/lBF;;AAkmBA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA/lBF;;AAkmBA;EACE,SAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AA/lBF;AAimBE;EACE,eAAA;AA/lBJ;;AAmmBA;EACE,eAAA;EACA,eAAA;AAhmBF;AAkmBE;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;AAhmBJ;;AAomBA;EACE,aAAA;EACA,cAAA;AAjmBF;;AAomBA,yEAAA;AAEE;EACE,8BAAA;EACA,yBAAA;EACA,yDAAA;AAlmBJ;AAomBI;;EAEE,yBAAA;AAlmBN;AAqmBI;;EAEE,yBAAA;AAnmBN;AAsmBI;EACE,yBAAA;EACA,wEAAA;EACA,kDAAA;AApmBN;AAwmBE;EACE,yBAAA;AAtmBJ;AAymBE;EACE,yBAAA;AAvmBJ;AA0mBE;EACE,8BAAA;EACA,gDAAA;AAxmBJ;AA0mBI;EACE,8BAAA;AAxmBN;AA2mBI;EACE,yBAAA;AAzmBN;AA4mBI;EACE,yBAAA;AA1mBN;AA6mBI;EACE,yBAAA;AA3mBN;AA+mBE;EACE,8BAAA;EACA,kDAAA;AA7mBJ;AAgnBE;EACE,yBAAA;AA9mBJ;AAgnBI;EACE,yBAAA;AA9mBN;AAgnBM;EACE,+CAAA;EACA,gCAAA;EACA,yBAAA;AA9mBR;AAknBI;EACE,yBAAA;AAhnBN;AAknBM;EACE,+CAAA;EACA,gCAAA;EACA,yBAAA;AAhnBR;AAqnBE;EACE,+CAAA;EACA,gCAAA;EACA,yBAAA;AAnnBJ;AAsnBE;EACE,8BAAA;EACA,yBAAA;EACA,2CAAA;AApnBJ;AAsnBI;EACE,yBAAA;AApnBN;AAunBI;EACE,yBAAA;AArnBN;AAynBE;EACE,8BAAA;AAvnBJ;AA0nBE;EACE,yBAAA;AAxnBJ;AA2nBE;EACE,gEAAA;AAznBJ;AA2nBI;EACE,yBAAA;AAznBN;AA6nBE;EACE,wEAAA;EACA,kDAAA;AA3nBJ;AA8nBE;EACE,sDAAA;AA5nBJ;AA+nBE;EACE,8BAAA;EACA,kDAAA;EACA,oBAAA;AA7nBJ;AA+nBI;EACE,yBAAA;AA7nBN;AAioBE;EACE,8BAAA;AA/nBJ;AAioBI;EACE,yBAAA;AA/nBN;AAmoBE;EACE,yBAAA;AAjoBJ;AAooBE;EACE,yBAAA;AAloBJ;AAqoBE;EACE,yBAAA;AAnoBJ;AAqoBI;EACE,yBAAA;AAnoBN;AAuoBE;EACE,8CAAA;EACA,iDAAA;AAroBJ;AAwoBE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AAtoBJ;AAwoBI;EACE,cAAA;AAtoBN;AA0oBE;EACE,yBAAA;AAxoBJ;AA2oBE;EACE,kDAAA;EACA,8BAAA;AAzoBJ;AA4oBE;;EAEE,yBAAA;AA1oBJ;AA4oBI;;EACE,yBAAA;AAzoBN;AA6oBE;EACE,8BAAA;AA3oBJ;AA8oBE;EACE,yBAAA;AA5oBJ;AA+oBE;EACE,8BAAA;EACA,kDAAA;AA7oBJ;AAgpBE;EACE,8CAAA;EACA,iDAAA;EACA,yBAAA;AA9oBJ;AAgpBI;EACE,yBAAA;AA9oBN;AAipBI;EACE,yBAAA;AA/oBN;AAmpBE;EACE,6CAAA;EACA,iDAAA;AAjpBJ;AAopBE;EACE,uBAAA;AAlpBJ;AAqpBE;EACE,yBAAA;AAnpBJ;AAspBE;EACE,yBAAA;AAppBJ;AAupBE;EACE,qDAAA;AArpBJ;AAwpBE;EACE,8BAAA;EACA,iDAAA;AAtpBJ;AAypBE;EACE,yBAAA;AAvpBJ;AA0pBE;EACE,yBAAA;AAxpBJ;AA2pBE;EACE,yBAAA;AAzpBJ;AA4pBE;EACE,yBAAA;AA1pBJ;AA6pBE;EACE,yBAAA;AA3pBJ;AA8pBE;EACE,yBAAA;AA5pBJ;AA+pBE;EACE,6CAAA;EACA,qCAAA;AA7pBJ;AA+pBI;;EAEE,yBAAA;AA7pBN;AAgqBI;EACE,yBAAA;AA9pBN","sourcesContent":[".upload-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  overflow: hidden;\n}\n\n.upload-dialog {\n  width: 90%;\n  max-width: 1400px;\n  background: #fff;\n  border-radius: 22px;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: auto;\n  z-index: 10000;\n}\n\n.quick-create-dialog {\n  max-height: 95vh;\n  max-height: 95dvh;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n\n  &.ai-review-mode {\n    box-shadow:\n      0 35px 70px rgba(7, 8, 10, 0.35),\n      0 0 0 1px rgba(124, 58, 237, 0.12);\n\n    &::before {\n      content: \"\";\n      display: block;\n      height: 3px;\n      background: linear-gradient(90deg, #5ea1d8 0%, #7c3aed 50%, #5ea1d8 100%);\n      flex-shrink: 0;\n    }\n  }\n\n  &.mobile-shell {\n    width: 100%;\n    max-width: 100%;\n    height: 100vh;\n    height: 100dvh;\n    max-height: 100dvh;\n    border-radius: 0;\n    padding-bottom: env(safe-area-inset-bottom, 0);\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .quick-create-dialog {\n    width: 96%;\n    max-width: 100%;\n    max-height: 92dvh;\n  }\n\n  .smart-create-header {\n    padding: 16px 20px;\n  }\n}\n\n.upload-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  background: #fff;\n  color: #111827;\n  border-bottom: 1px solid #e4e8f0;\n  flex-shrink: 0;\n}\n\n.smart-create-header {\n  gap: 12px;\n  position: relative;\n  z-index: 2;\n\n  .header-left {\n    align-items: flex-start;\n    min-width: 0;\n    flex: 1;\n  }\n\n  .header-copy {\n    min-width: 0;\n    flex: 1;\n  }\n\n  .header-title-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n    margin-bottom: 4px;\n  }\n\n  .title {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    line-height: 1.25;\n    color: #111827;\n  }\n\n  .header-phase-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 10px;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #5b21b6;\n    background: linear-gradient(135deg, #eef6fc 0%, #ede9fe 100%);\n    border: 1px solid #c7d2fe;\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  .header-subtitle {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.45;\n    color: #6b7280;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  .icon-circle {\n    width: 48px;\n    height: 48px;\n    border-radius: 14px;\n    flex-shrink: 0;\n  }\n\n  .icon-button {\n    border-radius: 10px;\n    flex-shrink: 0;\n  }\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.icon-circle {\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  background: #f3f4f6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  mat-icon {\n    color: #5ea1d8;\n    font-size: 24px;\n  }\n}\n\n.header-copy {\n  p {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n  }\n  span {\n    font-size: 14px;\n    color: #6b7280;\n  }\n}\n\n.smart-create-header .header-copy {\n  p,\n  span {\n    margin: 0;\n  }\n}\n\n.icon-button {\n  border: none;\n  background: #f3f4f6;\n  color: inherit;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n  mat-icon {\n    font-size: 22px;\n  }\n  &:hover {\n    background: #e5e7eb;\n    transform: translateY(-1px);\n  }\n}\n\n.quick-create-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1 1 auto;\n  min-height: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.stage-banner,\n.pieces-ai-banner,\n.ai-policy-banner,\n.smart-create-header,\n.quick-create-footer {\n  flex-shrink: 0;\n}\n\n.quick-section {\n  margin-bottom: 32px;\n  padding-bottom: 32px;\n  border-bottom: 1px solid #e4e8f0;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.section-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n  color: #111827;\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.section-hint {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0 0 16px 0;\n  font-style: italic;\n}\n\n// Upload All Files Section\n.upload-all-section {\n  .upload-all-area {\n    margin-bottom: 16px;\n  }\n\n  .upload-all-placeholder {\n    width: 100%;\n    min-height: 200px;\n    border: 2px dashed #5ea1d8;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    background: #f0f7ff;\n    padding: 32px;\n\n    &:hover {\n      border-color: #4a8fc4;\n      background: #e8f4fd;\n      transform: translateY(-2px);\n      box-shadow: 0 4px 12px rgba(94, 161, 216, 0.2);\n    }\n\n    mat-icon {\n      font-size: 64px;\n      width: 64px;\n      height: 64px;\n      color: #5ea1d8;\n      margin-bottom: 16px;\n    }\n\n    p {\n      margin: 0 0 8px 0;\n      color: #111827;\n      font-size: 18px;\n      font-weight: 600;\n    }\n\n    .upload-hint {\n      font-size: 14px;\n      color: #6b7280;\n      font-style: italic;\n    }\n  }\n}\n\n// Cover Section\n.cover-section {\n  .cover-upload-area {\n    position: relative;\n    margin-bottom: 16px;\n  }\n\n  .cover-drop-zone {\n    min-height: 200px;\n    position: relative;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n\n    &.cdk-drop-list-dragging {\n      background: linear-gradient(135deg, rgba(94, 161, 216, 0.1) 0%, rgba(94, 161, 216, 0.05) 100%);\n      border: 3px dashed #5ea1d8;\n      animation: dropZonePulse 2s ease-in-out infinite;\n      box-shadow: inset 0 0 20px rgba(94, 161, 216, 0.1);\n    }\n\n    &.has-cover {\n      border: none;\n      background: transparent;\n    }\n  }\n\n  @keyframes dropZonePulse {\n    0%, 100% {\n      border-color: #5ea1d8;\n      box-shadow: inset 0 0 20px rgba(94, 161, 216, 0.1);\n    }\n    50% {\n      border-color: #4a8fc4;\n      box-shadow: inset 0 0 30px rgba(94, 161, 216, 0.15);\n    }\n  }\n\n.cover-preview {\n  position: relative;\n  width: 100%;\n  max-height: 400px;\n  border-radius: 12px;\n  overflow: visible;\n  background: #f3f4f6;\n  cursor: move;\n  border: 3px solid transparent;\n  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n  will-change: transform, box-shadow;\n\n  &.has-video {\n    max-height: 500px;\n  }\n\n  &.cdk-drag-dragging {\n    opacity: 0.4;\n    transform: scale(0.95);\n    filter: blur(2px);\n    z-index: 1;\n  }\n\n  &.cdk-drag-preview {\n    opacity: 1 !important;\n    transform: scale(1.15) rotate(5deg) !important;\n    // Enhanced shadows with darker colors for white background visibility\n    box-shadow: \n      0 0 0 2px rgba(0, 0, 0, 0.3),\n      0 0 0 6px rgba(94, 161, 216, 0.6),\n      0 0 0 12px rgba(94, 161, 216, 0.4),\n      0 0 0 18px rgba(94, 161, 216, 0.2),\n      0 30px 80px rgba(0, 0, 0, 0.4),\n      0 20px 50px rgba(94, 161, 216, 0.6),\n      inset 0 0 0 3px rgba(255, 255, 255, 0.9) !important;\n    border: 5px solid #5ea1d8 !important;\n    outline: 3px solid rgba(0, 0, 0, 0.2) !important;\n    outline-offset: 2px !important;\n    z-index: 10000 !important;\n    cursor: grabbing !important;\n    animation: dragPreviewPulse 1s ease-in-out infinite !important;\n    pointer-events: none !important;\n    filter: drop-shadow(0 0 20px rgba(94, 161, 216, 0.8)) !important;\n    \n    &::before {\n      content: '';\n      position: absolute;\n      top: -20px;\n      left: -20px;\n      right: -20px;\n      bottom: -20px;\n      background: radial-gradient(circle, rgba(94, 161, 216, 0.5) 0%, rgba(94, 161, 216, 0.3) 40%, rgba(0, 0, 0, 0.1) 70%, transparent 100%);\n      border-radius: 25px;\n      z-index: -1;\n      animation: dragGlow 1.5s ease-in-out infinite;\n      pointer-events: none;\n      box-shadow: 0 0 40px rgba(94, 161, 216, 0.6);\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: -25px;\n      left: -25px;\n      right: -25px;\n      bottom: -25px;\n      background: radial-gradient(circle, rgba(0, 0, 0, 0.15) 0%, transparent 60%);\n      border-radius: 30px;\n      z-index: -2;\n      pointer-events: none;\n    }\n  }\n\n  &:hover:not(.cdk-drag-dragging) {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n    border-color: rgba(94, 161, 216, 0.5);\n  }\n\n  .drag-handle {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: rgba(94, 161, 216, 0.95);\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: grab;\n    z-index: 11;\n    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);\n    backdrop-filter: blur(4px);\n\n    &:active {\n      cursor: grabbing;\n      transform: scale(0.9) rotate(90deg);\n    }\n\n    &:hover {\n      background: rgba(94, 161, 216, 1);\n      transform: scale(1.15) rotate(15deg);\n      box-shadow: 0 5px 15px rgba(94, 161, 216, 0.5);\n    }\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n      transition: transform 0.3s ease;\n    }\n  }\n\n  .cover-image,\n  .cover-video {\n    width: 100%;\n    height: auto;\n    max-height: 400px;\n    object-fit: cover;\n    display: block;\n  }\n\n  .cover-video {\n    max-height: 500px;\n  }\n\n  .cover-media-shell {\n    position: relative;\n    display: block;\n    width: 100%;\n    line-height: 0;\n  }\n\n  .preview-btn {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: rgba(94, 161, 216, 0.85);\n    color: #fff;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: background 0.2s ease, transform 0.2s ease;\n    z-index: 12;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);\n    padding: 0;\n\n    &:hover {\n      background: #5ea1d8;\n      transform: translate(-50%, -50%) scale(1.08);\n    }\n\n    mat-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\n  .cover-upload-placeholder {\n    width: 100%;\n    min-height: 300px;\n    border: 2px dashed #d1d5db;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    background: #f9fafb;\n\n    &.drop-zone-active {\n      border: 2px dashed #5ea1d8;\n    }\n\n    &:hover {\n      border-color: #5ea1d8;\n      background: #f3f4f6;\n    }\n\n    &.cdk-drop-list-dragging {\n      border-color: #5ea1d8;\n      background: #f0f7ff;\n    }\n\n    mat-icon {\n      font-size: 48px;\n      width: 48px;\n      height: 48px;\n      color: #9ca3af;\n      margin-bottom: 12px;\n    }\n\n    p {\n      margin: 0;\n      color: #6b7280;\n      font-size: 16px;\n    }\n\n    .drop-hint {\n      font-size: 12px;\n      color: #9ca3af;\n      font-style: italic;\n      margin-top: 4px;\n    }\n  }\n}\n\n.remove-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  z-index: 10;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.8);\n  }\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.add-caption-btn {\n  position: absolute;\n  bottom: 12px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 8px 16px;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  border: none;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s ease;\n  z-index: 10;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.8);\n  }\n}\n\n.upload-progress {\n  margin-top: 12px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  mat-progress-bar {\n    flex: 1;\n  }\n\n  span {\n    font-size: 14px;\n    color: #6b7280;\n    min-width: 40px;\n  }\n}\n\n.upload-progress-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.7);\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  z-index: 5;\n\n  mat-progress-bar {\n    flex: 1;\n  }\n\n  span {\n    color: white;\n    font-size: 12px;\n    min-width: 35px;\n  }\n}\n\n.cover-details-display {\n  margin-top: 16px;\n  padding: 16px;\n  background: #f9fafb;\n  border-radius: 8px;\n  position: relative;\n\n  .detail-item {\n    margin-bottom: 8px;\n    font-size: 14px;\n    color: #374151;\n    line-height: 1.5;\n\n    strong {\n      color: #111827;\n      margin-right: 8px;\n    }\n  }\n\n  .edit-caption-btn {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    background: #5ea1d8;\n    color: white;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 13px;\n    transition: background 0.2s ease;\n\n    &:hover {\n      background: #4a8fc4;\n    }\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n  }\n}\n\n.add-caption-section-btn {\n  margin-top: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #5ea1d8;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.2s ease;\n\n  &:hover {\n    background: #4a8fc4;\n  }\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n// Steps Section\n.steps-section {\n  .upload-steps-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 20px;\n    background: #5ea1d8;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background 0.2s ease;\n\n    &:hover {\n      background: #4a8fc4;\n    }\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  .steps-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 20px;\n    margin-top: 16px;\n    transition: all 0.3s ease;\n\n    // Drop zone indicator when dragging\n    &.cdk-drop-list-dragging {\n      background: rgba(94, 161, 216, 0.02);\n      border-radius: 12px;\n      padding: 4px;\n      margin: 12px -4px;\n    }\n\n    @media (max-width: 768px) {\n      grid-template-columns: repeat(3, 1fr);\n      gap: 12px;\n    }\n  }\n\n  .step-item {\n    position: relative;\n    aspect-ratio: 1;\n    border-radius: 12px;\n    overflow: visible;\n    cursor: move;\n    background: #f3f4f6;\n    border: 3px solid transparent;\n    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n    transform: scale(1);\n    will-change: transform, box-shadow;\n\n  &.cdk-drag-dragging {\n    opacity: 0.4;\n    transform: scale(0.92);\n    filter: blur(2px);\n    z-index: 1;\n  }\n\n  &.cdk-drag-preview {\n    opacity: 0.85 !important; // Increased opacity for better visibility\n    transform: scale(1.18) rotate(5deg) !important;\n    // Enhanced shadows with darker colors for white background visibility\n    box-shadow: \n      0 0 0 3px rgba(0, 0, 0, 0.5),\n      0 0 0 8px rgba(94, 161, 216, 0.7),\n      0 0 0 14px rgba(94, 161, 216, 0.5),\n      0 0 0 20px rgba(94, 161, 216, 0.3),\n      0 35px 90px rgba(0, 0, 0, 0.5),\n      0 25px 60px rgba(94, 161, 216, 0.7),\n      inset 0 0 0 3px rgba(255, 255, 255, 0.9) !important;\n    border: 5px solid #5ea1d8 !important;\n    outline: 4px solid rgba(0, 0, 0, 0.4) !important;\n    outline-offset: 2px !important;\n    z-index: 10000 !important;\n    cursor: grabbing !important;\n    animation: dragPreviewPulse 1s ease-in-out infinite !important;\n    // Add semi-transparent dark background for visibility on white\n    background: linear-gradient(135deg, rgba(243, 244, 246, 0.95) 0%, rgba(229, 231, 235, 0.95) 100%) !important;\n    backdrop-filter: blur(8px) !important;\n    pointer-events: none !important;\n    filter: drop-shadow(0 0 25px rgba(94, 161, 216, 0.9)) drop-shadow(0 0 15px rgba(0, 0, 0, 0.3)) !important;\n    \n    // Add dark backdrop overlay for better visibility\n    &::after {\n      content: '';\n      position: absolute;\n      top: -30px;\n      left: -30px;\n      right: -30px;\n      bottom: -30px;\n      background: radial-gradient(circle, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.15) 50%, transparent 80%);\n      border-radius: 35px;\n      z-index: -3;\n      pointer-events: none;\n      animation: dragBackdropPulse 1.5s ease-in-out infinite;\n    }\n    \n    // Show selected badge if this is a selected item\n    .selected-badge {\n      display: flex !important;\n      opacity: 1 !important;\n      z-index: 25 !important;\n    }\n    \n    // Darker, more visible glow effect for white backgrounds\n    &::before {\n      content: '';\n      position: absolute;\n      top: -20px;\n      left: -20px;\n      right: -20px;\n      bottom: -20px;\n      background: radial-gradient(circle, rgba(94, 161, 216, 0.5) 0%, rgba(94, 161, 216, 0.3) 40%, rgba(0, 0, 0, 0.1) 70%, transparent 100%);\n      border-radius: 25px;\n      z-index: -1;\n      animation: dragGlow 1.5s ease-in-out infinite;\n      pointer-events: none;\n      box-shadow: 0 0 40px rgba(94, 161, 216, 0.6);\n    }\n\n    // Additional dark backdrop for contrast\n    &::after {\n      content: '';\n      position: absolute;\n      top: -25px;\n      left: -25px;\n      right: -25px;\n      bottom: -25px;\n      background: radial-gradient(circle, rgba(0, 0, 0, 0.15) 0%, transparent 60%);\n      border-radius: 30px;\n      z-index: -2;\n      pointer-events: none;\n    }\n\n    // Enhanced badges in drag preview\n    .dragging-badge,\n    .selected-dragging-badge {\n      display: flex !important;\n      animation: badgeDragPulse 0.8s ease-in-out infinite !important;\n      z-index: 25 !important;\n      box-shadow: \n        0 4px 16px rgba(0, 0, 0, 0.4),\n        0 0 0 2px rgba(255, 255, 255, 0.8) !important;\n    }\n\n    .step-number-badge {\n      background: rgba(94, 161, 216, 1) !important;\n      transform: scale(1.25) !important;\n      font-size: 13px !important;\n      padding: 6px 12px !important;\n      font-weight: 700 !important;\n      box-shadow: \n        0 4px 16px rgba(0, 0, 0, 0.4),\n        0 0 0 2px rgba(255, 255, 255, 0.8),\n        0 6px 20px rgba(94, 161, 216, 0.7) !important;\n      border: 2px solid rgba(255, 255, 255, 0.9) !important;\n    }\n\n    .drag-handle {\n      background: rgba(94, 161, 216, 1) !important;\n      transform: scale(1.4) rotate(45deg) !important;\n      box-shadow: \n        0 0 0 3px rgba(255, 255, 255, 1),\n        0 0 0 6px rgba(94, 161, 216, 0.8),\n        0 12px 30px rgba(0, 0, 0, 0.5),\n        0 8px 20px rgba(94, 161, 216, 0.9) !important;\n      z-index: 26 !important;\n      border: 2px solid rgba(255, 255, 255, 0.9) !important;\n    }\n\n    .step-preview {\n      border-radius: 12px;\n      overflow: hidden;\n      box-shadow: inset 0 0 0 2px rgba(94, 161, 216, 0.4) !important;\n      // Add subtle dark border for visibility\n      border: 2px solid rgba(0, 0, 0, 0.1) !important;\n      \n      img,\n      video {\n        opacity: 0.9 !important; // Less transparency for better visibility\n        filter: contrast(1.1) brightness(0.95) !important; // Enhance contrast\n      }\n      \n      &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: linear-gradient(135deg, rgba(94, 161, 216, 0.25) 0%, transparent 50%);\n        border-radius: 12px;\n        z-index: 2;\n        pointer-events: none;\n      }\n    }\n    \n    // For selected items, maintain the selected preview overlay\n    &.selected.cdk-drag-preview .step-preview {\n      border: 3px solid rgba(94, 161, 216, 0.5) !important;\n      box-shadow: inset 0 0 0 3px rgba(94, 161, 216, 0.3) !important;\n      \n      img,\n      video {\n        opacity: 0.95 !important;\n        filter: contrast(1.15) brightness(0.98) !important;\n      }\n      \n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: linear-gradient(135deg, rgba(94, 161, 216, 0.2) 0%, transparent 50%);\n        border-radius: 12px;\n        z-index: 1;\n        pointer-events: none;\n      }\n    }\n  }\n\n  // Special styling when selected item is being dragged - maintain selected card UI\n  &.selected.cdk-drag-preview {\n    opacity: 0.9 !important; // Higher opacity for selected items\n    // Maintain selected card styling with enhanced shadows\n    box-shadow: \n      0 0 0 6px rgba(94, 161, 216, 0.2),\n      0 0 0 10px rgba(94, 161, 216, 0.3),\n      0 0 0 4px rgba(0, 0, 0, 0.5),\n      0 0 0 10px rgba(94, 161, 216, 0.7),\n      0 0 0 16px rgba(94, 161, 216, 0.5),\n      0 0 0 24px rgba(94, 161, 216, 0.3),\n      0 40px 100px rgba(0, 0, 0, 0.6),\n      0 30px 70px rgba(94, 161, 216, 0.8),\n      0 8px 24px rgba(94, 161, 216, 0.3),\n      inset 0 0 0 4px rgba(255, 255, 255, 0.95),\n      inset 0 0 0 2px rgba(255, 255, 255, 0.1) !important;\n    border: 4px solid #5ea1d8 !important;\n    outline: 5px solid rgba(0, 0, 0, 0.4) !important;\n    outline-offset: 3px !important;\n    transform: scale(1.25) rotate(7deg) !important;\n    filter: drop-shadow(0 0 30px rgba(94, 161, 216, 0.9)) drop-shadow(0 0 20px rgba(255, 107, 107, 0.6)) drop-shadow(0 0 10px rgba(0, 0, 0, 0.4)) !important;\n    animation: dragPreviewPulse 1s ease-in-out infinite, selectedGlow 2.5s ease-in-out infinite !important;\n    // Darker background for better visibility\n    background: linear-gradient(135deg, rgba(243, 244, 246, 0.98) 0%, rgba(229, 231, 235, 0.98) 100%) !important;\n    backdrop-filter: blur(10px) !important;\n    \n    // Maintain selected card glow effect\n    &::before {\n      background: radial-gradient(circle, rgba(94, 161, 216, 0.6) 0%, rgba(255, 107, 107, 0.3) 40%, rgba(0, 0, 0, 0.2) 70%, transparent 100%);\n      box-shadow: 0 0 60px rgba(94, 161, 216, 0.9), 0 0 40px rgba(255, 107, 107, 0.5);\n    }\n    \n    // Enhanced dark backdrop for selected items\n    &::after {\n      content: '';\n      position: absolute;\n      top: -35px;\n      left: -35px;\n      right: -35px;\n      bottom: -35px;\n      background: radial-gradient(circle, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0.1) 70%, transparent 90%);\n      border-radius: 40px;\n      z-index: -3;\n      pointer-events: none;\n      animation: dragBackdropPulse 1.5s ease-in-out infinite;\n    }\n    \n    // Show selected badge prominently\n    .selected-badge {\n      display: flex !important;\n      opacity: 1 !important;\n      z-index: 25 !important;\n      transform: scale(1.15) !important;\n      box-shadow: \n        0 6px 20px rgba(94, 161, 216, 0.7),\n        0 0 0 3px rgba(255, 255, 255, 0.9) !important;\n    }\n    \n    // Maintain selected card preview overlay\n    .step-preview {\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: linear-gradient(135deg, rgba(94, 161, 216, 0.15) 0%, transparent 50%);\n        border-radius: 12px;\n        z-index: 1;\n        pointer-events: none;\n      }\n    }\n    \n    // Enhanced drag handle for selected items\n    .drag-handle {\n      background: rgba(94, 161, 216, 1) !important;\n      box-shadow: \n        0 0 0 3px rgba(255, 255, 255, 1),\n        0 0 0 6px rgba(94, 161, 216, 0.8),\n        0 12px 30px rgba(0, 0, 0, 0.5),\n        0 8px 20px rgba(94, 161, 216, 0.9),\n        0 0 0 2px rgba(255, 255, 255, 0.6) !important;\n    }\n    \n    // Enhanced step number badge\n    .step-number-badge {\n      background: rgba(94, 161, 216, 1) !important;\n      transform: scale(1.2) !important;\n      box-shadow: \n        0 4px 16px rgba(0, 0, 0, 0.4),\n        0 0 0 2px rgba(255, 255, 255, 0.8),\n        0 6px 20px rgba(94, 161, 216, 0.7),\n        0 0 0 2px rgba(255, 255, 255, 0.6) !important;\n    }\n    \n    .selected-dragging-badge {\n      display: none !important; // Hide dragging badge, show selected badge instead\n    }\n  }\n\n    .selected-badge {\n      position: absolute;\n      top: -8px;\n      right: -8px;\n      background: linear-gradient(135deg, #5ea1d8 0%, #4a8fc4 100%);\n      color: white;\n      padding: 6px 12px;\n      border-radius: 20px;\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      font-size: 12px;\n      font-weight: 600;\n      z-index: 20;\n      box-shadow: 0 4px 12px rgba(94, 161, 216, 0.4);\n      animation: badgeAppear 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n      pointer-events: none;\n      opacity: 1;\n      transition: opacity 0.2s ease;\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n        animation: checkPulse 2s ease-in-out infinite;\n      }\n\n      span {\n        white-space: nowrap;\n      }\n    }\n\n    .dragging-badge {\n      position: absolute;\n      top: -8px;\n      right: -8px;\n      background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);\n      color: white;\n      padding: 6px 12px;\n      border-radius: 20px;\n      display: none; // Hidden by default\n      align-items: center;\n      gap: 6px;\n      font-size: 12px;\n      font-weight: 600;\n      z-index: 20;\n      box-shadow: 0 4px 12px rgba(255, 152, 0, 0.5);\n      animation: badgeAppear 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), badgeDragPulse 1s ease-in-out infinite;\n      pointer-events: none;\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n        animation: dragIconSpin 1s linear infinite;\n      }\n\n      span {\n        white-space: nowrap;\n      }\n    }\n\n    .selected-dragging-badge {\n      position: absolute;\n      top: -10px;\n      right: -10px;\n      background: linear-gradient(135deg, #5ea1d8 0%, #4a8fc4 50%, #ff6b6b 100%);\n      color: white;\n      padding: 7px 14px;\n      border-radius: 22px;\n      display: none; // Hidden by default\n      align-items: center;\n      gap: 6px;\n      font-size: 12px;\n      font-weight: 700;\n      z-index: 21;\n      box-shadow: \n        0 6px 20px rgba(94, 161, 216, 0.6),\n        0 0 0 2px rgba(255, 255, 255, 0.3);\n      animation: badgeAppear 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), badgeDragPulse 0.8s ease-in-out infinite;\n      pointer-events: none;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        animation: dragIconSpin 0.8s linear infinite;\n      }\n\n      span {\n        white-space: nowrap;\n      }\n    }\n\n    // Keep selected badge visible during drag preview (but hide during drag-dragging state)\n    &.cdk-drag-dragging {\n      .selected-badge {\n        display: none;\n      }\n    }\n    \n    // Show selected badge in preview if item is selected\n    &.cdk-drag-preview.selected {\n      .selected-badge {\n        display: flex !important;\n      }\n    }\n\n    // Show dragging badge when dragging (but not selected)\n    &.cdk-drag-dragging:not(.selected),\n    &.cdk-drag-preview:not(.selected) {\n      .dragging-badge {\n        display: flex;\n      }\n    }\n\n    // Show selected-dragging badge when selected item is being dragged\n    &.cdk-drag-dragging.selected,\n    &.cdk-drag-preview.selected {\n      .selected-dragging-badge {\n        display: flex;\n      }\n    }\n\n    .step-number-badge {\n      position: absolute;\n      top: 8px;\n      left: 8px;\n      background: rgba(0, 0, 0, 0.7);\n      color: white;\n      padding: 4px 10px;\n      border-radius: 12px;\n      font-size: 11px;\n      font-weight: 600;\n      z-index: 12;\n      backdrop-filter: blur(4px);\n      transition: all 0.3s ease;\n      pointer-events: none;\n    }\n\n    .drag-handle {\n      position: absolute;\n      top: 4px;\n      right: 4px;\n      width: 32px;\n      height: 32px;\n      border-radius: 50%;\n      background: rgba(94, 161, 216, 0.95);\n      color: white;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: grab;\n      z-index: 13;\n      transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);\n      backdrop-filter: blur(4px);\n\n      &:active {\n        cursor: grabbing;\n        transform: scale(0.9) rotate(90deg);\n      }\n\n      &:hover {\n        background: rgba(94, 161, 216, 1);\n        transform: scale(1.15) rotate(15deg);\n        box-shadow: 0 5px 15px rgba(94, 161, 216, 0.5);\n      }\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n        transition: transform 0.3s ease;\n      }\n    }\n\n    &.selected {\n      border: 4px solid #5ea1d8;\n      box-shadow: \n        0 0 0 6px rgba(94, 161, 216, 0.2),\n        0 8px 24px rgba(94, 161, 216, 0.3),\n        inset 0 0 0 2px rgba(255, 255, 255, 0.1);\n      transform: scale(1.05);\n      animation: selectedGlow 2.5s ease-in-out infinite;\n      z-index: 10;\n\n      .drag-handle {\n        background: rgba(94, 161, 216, 1);\n        box-shadow: \n          0 0 0 3px rgba(255, 255, 255, 0.6),\n          0 6px 16px rgba(94, 161, 216, 0.6);\n        transform: scale(1.1);\n      }\n\n      .step-number-badge {\n        background: rgba(94, 161, 216, 0.95);\n        transform: scale(1.1);\n      }\n\n      .step-preview {\n        &::before {\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          background: linear-gradient(135deg, rgba(94, 161, 216, 0.1) 0%, transparent 50%);\n          border-radius: 12px;\n          z-index: 1;\n          pointer-events: none;\n        }\n      }\n    }\n\n    &:hover:not(.cdk-drag-dragging):not(.selected) {\n      transform: translateY(-6px) scale(1.03);\n      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);\n      border-color: rgba(94, 161, 216, 0.6);\n      \n      .drag-handle {\n        transform: scale(1.1);\n      }\n    }\n\n    // Animate other items when one is being dragged\n    .steps-grid:has(.cdk-drag-dragging) &:not(.cdk-drag-dragging) {\n      transition: all 0.3s ease;\n      opacity: 0.6;\n      filter: blur(1px);\n    }\n\n    // Show placeholder where item was dragged from\n    &.cdk-drag-placeholder {\n      opacity: 0.3;\n      background: rgba(94, 161, 216, 0.1);\n      border: 3px dashed #5ea1d8;\n      transform: scale(0.9);\n    }\n\n    .step-preview {\n      width: 100%;\n      height: 100%;\n      position: relative;\n      border-radius: 12px;\n      overflow: hidden;\n\n      img,\n      video {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        display: block;\n      }\n\n      .step-overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: rgba(0, 0, 0, 0);\n        transition: background 0.2s ease;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &:hover {\n          background: rgba(0, 0, 0, 0.3);\n        }\n      }\n    }\n  }\n\n  @keyframes selectedGlow {\n    0%, 100% {\n      box-shadow: \n        0 0 0 6px rgba(94, 161, 216, 0.2),\n        0 8px 24px rgba(94, 161, 216, 0.3),\n        inset 0 0 0 2px rgba(255, 255, 255, 0.1);\n    }\n    50% {\n      box-shadow: \n        0 0 0 10px rgba(94, 161, 216, 0.3),\n        0 12px 32px rgba(94, 161, 216, 0.4),\n        inset 0 0 0 2px rgba(255, 255, 255, 0.15);\n    }\n  }\n\n  @keyframes dragPulse {\n    0%, 100% {\n      box-shadow: 0 12px 32px rgba(94, 161, 216, 0.5), 0 0 0 4px rgba(94, 161, 216, 0.2);\n    }\n    50% {\n      box-shadow: 0 16px 40px rgba(94, 161, 216, 0.6), 0 0 0 6px rgba(94, 161, 216, 0.3);\n    }\n  }\n\n  @keyframes badgeAppear {\n    0% {\n      transform: scale(0) rotate(-180deg);\n      opacity: 0;\n    }\n    100% {\n      transform: scale(1) rotate(0deg);\n      opacity: 1;\n    }\n  }\n\n  @keyframes checkPulse {\n    0%, 100% {\n      transform: scale(1);\n    }\n    50% {\n      transform: scale(1.2);\n    }\n  }\n\n  @keyframes badgeDragPulse {\n    0%, 100% {\n      transform: scale(1);\n      box-shadow: 0 4px 12px rgba(94, 161, 216, 0.4);\n    }\n    50% {\n      transform: scale(1.1);\n      box-shadow: 0 6px 18px rgba(94, 161, 216, 0.6);\n    }\n  }\n\n  @keyframes dragIconSpin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes dragPreviewPulse {\n    0%, 100% {\n      box-shadow: \n        0 0 0 2px rgba(0, 0, 0, 0.3),\n        0 0 0 6px rgba(94, 161, 216, 0.6),\n        0 0 0 12px rgba(94, 161, 216, 0.4),\n        0 0 0 18px rgba(94, 161, 216, 0.2),\n        0 30px 80px rgba(0, 0, 0, 0.4),\n        0 20px 50px rgba(94, 161, 216, 0.6),\n        inset 0 0 0 3px rgba(255, 255, 255, 0.9);\n      filter: drop-shadow(0 0 20px rgba(94, 161, 216, 0.8));\n    }\n    50% {\n      box-shadow: \n        0 0 0 3px rgba(0, 0, 0, 0.4),\n        0 0 0 8px rgba(94, 161, 216, 0.7),\n        0 0 0 14px rgba(94, 161, 216, 0.5),\n        0 0 0 22px rgba(94, 161, 216, 0.3),\n        0 35px 90px rgba(0, 0, 0, 0.5),\n        0 25px 60px rgba(94, 161, 216, 0.7),\n        inset 0 0 0 4px rgba(255, 255, 255, 0.95);\n      filter: drop-shadow(0 0 25px rgba(94, 161, 216, 0.9));\n    }\n  }\n\n  @keyframes dragGlow {\n    0%, 100% {\n      opacity: 0.7;\n      transform: scale(1);\n      box-shadow: 0 0 40px rgba(94, 161, 216, 0.6);\n    }\n    50% {\n      opacity: 0.9;\n      transform: scale(1.08);\n      box-shadow: 0 0 60px rgba(94, 161, 216, 0.8), 0 0 30px rgba(0, 0, 0, 0.2);\n    }\n  }\n\n  @keyframes dragBackdropPulse {\n    0%, 100% {\n      opacity: 0.6;\n      transform: scale(1);\n    }\n    50% {\n      opacity: 0.8;\n      transform: scale(1.05);\n    }\n  }\n\n  .step-details-display {\n    margin-top: 24px;\n    padding: 20px;\n    background: #f9fafb;\n    border-radius: 12px;\n    position: relative;\n\n    .step-info {\n      h4 {\n        margin: 0 0 12px 0;\n        font-size: 16px;\n        font-weight: 600;\n        color: #111827;\n      }\n\n      .detail-item {\n        margin-bottom: 8px;\n        font-size: 14px;\n        color: #374151;\n        line-height: 1.5;\n\n        strong {\n          color: #111827;\n          margin-right: 8px;\n        }\n\n        em {\n          color: #9ca3af;\n          font-style: italic;\n        }\n      }\n    }\n\n    .step-actions {\n      display: flex;\n      gap: 12px;\n      align-items: center;\n      margin-top: 12px;\n    }\n\n    .edit-caption-btn {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      padding: 8px 16px;\n      background: #5ea1d8;\n      color: white;\n      border: none;\n      border-radius: 6px;\n      cursor: pointer;\n      font-size: 14px;\n      transition: background 0.2s ease;\n\n      &:hover {\n        background: #4a8fc4;\n      }\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n\n    .delete-step-btn {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      padding: 8px 16px;\n      background: #ef4444;\n      color: white;\n      border: none;\n      border-radius: 6px;\n      cursor: pointer;\n      font-size: 14px;\n      font-weight: 500;\n      transition: background 0.2s ease;\n\n      &:hover {\n        background: #dc2626;\n      }\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n  .edit-caption-btn-overlay {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: rgba(0, 0, 0, 0.6);\n    color: white;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: background 0.2s ease;\n    z-index: 10;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.8);\n    }\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n  }\n}\n\n// Items Section\n.items-section {\n  .items-form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .section-subtitle {\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0 0 6px 0;\n    color: #111827;\n  }\n\n  .upload-hint {\n    font-size: 12px;\n    color: #6b7280;\n    margin: 0 0 8px 0;\n  }\n\n  .upload-multiple-section {\n    padding: 12px;\n    background: #f9fafb;\n    border-radius: 8px;\n    border: 2px dashed #d1d5db;\n    text-align: center;\n\n    .upload-icon-btn {\n      display: inline-flex;\n      align-items: center;\n      gap: 8px;\n      padding: 10px 20px;\n      background: #5ea1d8;\n      color: white;\n      border: none;\n      border-radius: 8px;\n      cursor: pointer;\n      font-size: 14px;\n      font-weight: 500;\n      transition: background 0.2s ease;\n      margin-top: 6px;\n\n      &:hover {\n        background: #4a8fc4;\n      }\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n  .pending-images-section {\n    margin-top: 16px;\n  }\n\n  .pending-images-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n    gap: 12px;\n    margin-top: 12px;\n\n    @media (max-width: 768px) {\n      grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n      gap: 8px;\n    }\n  }\n\n  .pending-image-card {\n    position: relative;\n  }\n\n  .pending-image-preview {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 1;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #f3f4f6;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid transparent;\n    transition: all 0.2s ease;\n\n    &.clickable {\n      cursor: pointer;\n\n      &:hover {\n        border-color: #5ea1d8;\n        transform: translateY(-2px);\n        box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);\n\n        .image-overlay {\n          opacity: 1;\n        }\n      }\n    }\n\n    &.uploading {\n      border-color: #d1d5db;\n    }\n\n    .pending-preview-img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    .image-overlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: rgba(94, 161, 216, 0.85);\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 6px;\n      opacity: 0;\n      transition: opacity 0.2s ease;\n      z-index: 2;\n\n      .edit-icon {\n        color: white;\n        font-size: 24px;\n        width: 24px;\n        height: 24px;\n      }\n\n      .edit-text {\n        color: white;\n        font-size: 12px;\n        font-weight: 500;\n      }\n    }\n\n    .upload-progress-overlay {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: rgba(0, 0, 0, 0.7);\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 8px;\n      padding: 12px;\n      z-index: 3;\n\n      mat-progress-bar {\n        width: 100%;\n      }\n\n      .progress-text {\n        color: white;\n        font-size: 12px;\n        font-weight: 500;\n      }\n    }\n\n    .remove-pending-btn {\n      position: absolute;\n      top: 4px;\n      right: 4px;\n      background: rgba(239, 68, 68, 0.9);\n      color: white;\n      border: none;\n      border-radius: 50%;\n      width: 24px;\n      height: 24px;\n      min-width: 24px;\n      min-height: 24px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      z-index: 10;\n      padding: 0;\n\n      &:hover {\n        background: rgba(239, 68, 68, 1);\n        transform: scale(1.1);\n      }\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n        line-height: 16px;\n      }\n    }\n  }\n\n  .legacy-upload-section {\n    padding: 16px;\n    background: #f9fafb;\n    border-radius: 8px;\n  }\n\n  .form-row {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n\n    .flex-2 {\n      grid-column: span 2;\n    }\n  }\n\n  .item-image-upload {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n\n    label {\n      font-size: 14px;\n      font-weight: 500;\n      color: #374151;\n    }\n\n    .upload-icon-btn {\n      width: 60px;\n      height: 60px;\n      border-radius: 50%;\n      background: #f3f4f6;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      transition: background 0.2s ease;\n      position: relative;\n      overflow: hidden;\n\n      &:hover {\n        background: #e5e7eb;\n      }\n\n      mat-icon {\n        color: #5ea1d8;\n        font-size: 24px;\n      }\n\n      input {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        opacity: 0;\n        cursor: pointer;\n      }\n    }\n\n    .item-preview {\n      width: 60px;\n      height: 60px;\n      border-radius: 50%;\n      object-fit: cover;\n    }\n  }\n\n  .add-item-btn {\n    align-self: flex-start;\n    padding: 10px 20px;\n    background: #5ea1d8;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background 0.2s ease;\n\n    &:hover:not(:disabled) {\n      background: #4a8fc4;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  .items-list {\n    margin-top: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .item-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px;\n    background: #f9fafb;\n    border-radius: 8px;\n\n    .item-info {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      strong {\n        font-size: 14px;\n        color: #111827;\n      }\n\n      span {\n        font-size: 12px;\n        color: #6b7280;\n      }\n    }\n\n    .remove-item-btn {\n      background: transparent;\n      border: none;\n      color: #ef4444;\n      cursor: pointer;\n      padding: 4px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      &:hover {\n        background: #fee2e2;\n        border-radius: 4px;\n      }\n    }\n  }\n}\n\n// FAQs Section\n.faqs-section {\n  .faqs-form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .add-faq-btn {\n    align-self: flex-start;\n    padding: 10px 20px;\n    background: #5ea1d8;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background 0.2s ease;\n\n    &:hover:not(:disabled) {\n      background: #4a8fc4;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  .faqs-list {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .faq-card {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    padding: 20px;\n    background: #ffffff;\n    border-radius: 12px;\n    border: 1px solid #e5e7eb;\n    border-left: 4px solid #5ea1d8;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    transition: all 0.2s ease;\n\n    &:hover {\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n      transform: translateY(-2px);\n    }\n\n    .faq-info {\n      flex: 1;\n\n      strong {\n        display: block;\n        font-size: 15px;\n        font-weight: 600;\n        color: #111827;\n        margin-bottom: 10px;\n        line-height: 1.4;\n      }\n\n      p {\n        margin: 0 0 10px 0;\n        font-size: 14px;\n        color: #4b5563;\n        line-height: 1.6;\n      }\n\n      span {\n        display: inline-block;\n        font-size: 12px;\n        color: #6b7280;\n        background: #f3f4f6;\n        padding: 4px 8px;\n        border-radius: 4px;\n        font-weight: 500;\n      }\n    }\n\n    .remove-faq-btn {\n      background: transparent;\n      border: none;\n      color: #ef4444;\n      cursor: pointer;\n      padding: 8px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-left: 12px;\n      border-radius: 6px;\n      transition: background 0.2s ease;\n\n      &:hover {\n        background: #fee2e2;\n        background: #fee2e2;\n        border-radius: 4px;\n      }\n    }\n  }\n}\n\n// Price Section\n.price-section {\n  .price-form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .price-toggle-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px;\n    background: #f9fafb;\n    border-radius: 8px;\n\n    label {\n      font-size: 14px;\n      font-weight: 500;\n      color: #374151;\n    }\n  }\n\n  .creator-paid-only-notice {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    padding: 0.85rem 1rem;\n    border-radius: 10px;\n    background: rgba(94, 161, 216, 0.1);\n    border: 1px solid rgba(94, 161, 216, 0.28);\n\n    .notice-title-row {\n      display: inline-flex;\n      align-items: center;\n      gap: 8px;\n      min-width: 0;\n      max-width: 100%;\n    }\n\n    .notice-icon {\n      display: inline-flex !important;\n      align-items: center;\n      justify-content: center;\n      flex: 0 0 18px;\n      width: 18px !important;\n      height: 18px !important;\n      font-size: 18px !important;\n      line-height: 18px !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      overflow: visible;\n      color: #5ea1d8;\n      transform: translateY(1px);\n    }\n\n    .notice-lead {\n      margin: 0;\n      min-width: 0;\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 20px;\n      color: #334155;\n    }\n\n    .notice-detail {\n      margin: 0;\n      padding-left: 26px;\n      font-size: 14px;\n      line-height: 20px;\n      color: #334155;\n    }\n\n    .upgrade-free-link {\n      display: inline-block;\n      margin-top: 0.35rem;\n      margin-left: 26px;\n      border: none;\n      background: none;\n      padding: 0;\n      color: #5ea1d8;\n      font-weight: 700;\n      font-size: 0.85rem;\n      line-height: 1.3;\n      cursor: pointer;\n      text-decoration: underline;\n    }\n  }\n}\n\n.viewer-features-panel {\n  margin-top: 8px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #f8fafc;\n\n  .section-title {\n    margin-bottom: 6px;\n  }\n\n  .viewer-features-hint {\n    margin: 0 0 14px;\n    font-size: 13px;\n    line-height: 1.45;\n    color: #64748b;\n  }\n\n  .viewer-features-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 10px 16px;\n\n    mat-slide-toggle {\n      font-size: 13px;\n    }\n  }\n}\n\n// Actions Section\n// Tab Navigation\n// Tab Navigation - Matching Create Flow Style\n.stage-banner {\n  padding: 1px 10px 1px;\n  background: #fff;\n  border-bottom: 1px solid #edf1f7;\n  flex-shrink: 0;\n}\n\n.journey-progress {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  padding: 16px 0 0;\n  margin-top: 12px;\n  flex-shrink: 0;\n  overflow-x: hidden;\n  flex-wrap: nowrap;\n  width: 100%;\n  position: relative;\n}\n\n.journey-step {\n  background: transparent;\n  border: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0;\n  min-width: auto;\n  flex-shrink: 0;\n  cursor: pointer;\n  color: #9ca3af;\n  transition: color 0.2s ease;\n  white-space: nowrap;\n  align-self: center;\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    pointer-events: auto;\n  }\n}\n\n.journey-step.active {\n  color: #5ea1d8;\n  .step-label {\n    border-color: #5ea1d8;\n    background: rgba(94, 161, 216, 0.1);\n    color: #5ea1d8;\n  }\n}\n\n.journey-step.complete {\n  color: #16a34a;\n  .step-label {\n    border-color: #16a34a;\n    background: rgba(22, 163, 74, 0.1);\n    color: #16a34a;\n  }\n}\n\n.step-label {\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border: 2px solid currentColor;\n  border-radius: 999px;\n  transition: all 0.2s ease;\n\n  .step-count {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    border: 2px solid currentColor;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    font-size: 12px;\n    flex-shrink: 0;\n  }\n\n  .label-text {\n    font-size: 13px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  .label-check {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: #16a34a;\n  }\n\n  &.complete {\n    border-color: #16a34a;\n    background: rgba(22, 163, 74, 0.1);\n    color: #16a34a;\n  }\n}\n\n.step-connector {\n  flex: 1;\n  min-width: 20px;\n  height: 2px;\n  background: #e5e7eb;\n  flex-shrink: 0;\n  align-self: center;\n  margin: 0;\n  position: relative;\n  z-index: 0;\n  top: -10px;\n\n  &.fill {\n    background: #16a34a;\n  }\n}\n\n@media (max-width: 768px) {\n  .journey-progress {\n    overflow-x: auto !important;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    padding-top: 8px;\n    margin-top: 8px;\n    touch-action: pan-x;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  .journey-step {\n    flex: 0 0 auto;\n    padding-right: 8px;\n    touch-action: pan-x !important;\n  }\n\n  .step-label {\n    font-size: 12px;\n    letter-spacing: 0.02em;\n  }\n}\n\n/* Strict no-white surfaces for all quick-create tabs in dark mode */\n:host-context(body.theme-dark) {\n  .upload-dialog,\n  .quick-create-dialog {\n    background: #0f172a !important;\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .mat-mdc-tab-group,\n  .upload-dialog .mat-mdc-tab-header,\n  .upload-dialog .mat-mdc-tab-body-wrapper,\n  .upload-dialog .mat-mdc-tab-body,\n  .upload-dialog .mat-mdc-tab-body-content,\n  .upload-dialog [role=\"tabpanel\"],\n  .upload-dialog .quick-create-body,\n  .upload-dialog .quick-section,\n  .upload-dialog .upload-all-placeholder,\n  .upload-dialog .cover-upload-placeholder,\n  .upload-dialog .cover-preview,\n  .upload-dialog .step-preview,\n  .upload-dialog .pending-image-preview,\n  .upload-dialog .item-card,\n  .upload-dialog .faq-card,\n  .upload-dialog .step-details-display,\n  .upload-dialog .cover-details-display,\n  .upload-dialog .flow-main-grid,\n  .upload-dialog .flow-main-content,\n  .upload-dialog .flow-sidebar.summary-preview-sidebar,\n  .upload-dialog .step-navigation,\n  .upload-dialog .step-panel-body,\n  .upload-dialog .quick-create-footer {\n    background: #111827 !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog textarea,\n  .upload-dialog .ql-container,\n  .upload-dialog .ql-editor,\n  .upload-dialog .mat-mdc-form-field-focus-overlay,\n  .upload-dialog ::ng-deep .mat-mdc-form-field-focus-overlay {\n    background: #111827 !important;\n    color: #f9fafb !important;\n  }\n\n  .upload-dialog [style*=\"background: #fff\"],\n  .upload-dialog [style*=\"background:#fff\"],\n  .upload-dialog [style*=\"background: #ffffff\"],\n  .upload-dialog [style*=\"background:#ffffff\"],\n  .upload-dialog [style*=\"background-color: #fff\"],\n  .upload-dialog [style*=\"background-color:#fff\"],\n  .upload-dialog [style*=\"background-color: #ffffff\"],\n  .upload-dialog [style*=\"background-color:#ffffff\"],\n  .upload-dialog [style*=\"background: white\"],\n  .upload-dialog [style*=\"background:white\"],\n  .upload-dialog [style*=\"background-color: white\"],\n  .upload-dialog [style*=\"background-color:white\"] {\n    background: #111827 !important;\n    background-color: #111827 !important;\n  }\n\n  .upload-dialog [style*=\"color: #333\"],\n  .upload-dialog [style*=\"color:#333\"],\n  .upload-dialog [style*=\"color: #666\"],\n  .upload-dialog [style*=\"color:#666\"] {\n    color: #f3f4f6 !important;\n  }\n}\n\n/* Final page-scoped dark-mode hardening (Quick Create Flow) */\n:host-context(body.theme-dark) {\n  .upload-dialog,\n  .quick-create-dialog {\n    background: #0f172a !important;\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .upload-header,\n  .upload-dialog .stage-banner,\n  .upload-dialog .quick-create-body,\n  .upload-dialog .quick-section,\n  .upload-dialog .mat-mdc-tab-group,\n  .upload-dialog .mat-mdc-tab-header,\n  .upload-dialog .mat-mdc-tab-body-wrapper,\n  .upload-dialog .mat-mdc-tab-body,\n  .upload-dialog .mat-mdc-tab-body-content,\n  .upload-dialog [role=\"tabpanel\"],\n  .upload-dialog .flow-main-grid,\n  .upload-dialog .flow-main-content,\n  .upload-dialog .flow-sidebar.summary-preview-sidebar,\n  .upload-dialog .step-navigation,\n  .upload-dialog .step-panel-body,\n  .upload-dialog .flow-title-sticky,\n  .upload-dialog .flow-info-panel,\n  .upload-dialog .description-section,\n  .upload-dialog .video-metadata,\n  .upload-dialog .channel-info-section,\n  .upload-dialog .quick-create-footer,\n  .upload-dialog .upload-all-placeholder,\n  .upload-dialog .cover-upload-placeholder,\n  .upload-dialog .cover-preview,\n  .upload-dialog .step-preview,\n  .upload-dialog .pending-image-preview,\n  .upload-dialog .item-card,\n  .upload-dialog .faq-card,\n  .upload-dialog .step-details-display,\n  .upload-dialog .cover-details-display {\n    background: #111827 !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .upload-dialog textarea,\n  .upload-dialog input,\n  .upload-dialog select,\n  .upload-dialog .mat-mdc-text-field-wrapper,\n  .upload-dialog .mdc-text-field,\n  .upload-dialog .mdc-text-field--outlined,\n  .upload-dialog .mdc-text-field--filled,\n  .upload-dialog .ql-container,\n  .upload-dialog .ql-toolbar,\n  .upload-dialog .ql-editor {\n    background: #111827 !important;\n    color: #f9fafb !important;\n  }\n}\n\n/* Dark mode readability fixes for Quick Create Flow */\n:host-context(body.theme-dark) {\n  .upload-dialog,\n  .quick-create-dialog {\n    background: #0f172a !important;\n    color: #e5e7eb !important;\n  }\n\n  .upload-header,\n  .stage-banner,\n  .quick-create-body,\n  .quick-section,\n  .flow-main-grid,\n  .flow-main-content,\n  .flow-sidebar.summary-preview-sidebar,\n  .step-navigation,\n  .step-panel-body,\n  .flow-title-sticky,\n  .flow-info-panel,\n  .video-metadata,\n  .channel-info-section,\n  .description-section,\n  .quick-create-footer {\n    background: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .upload-dialog h1,\n  .upload-dialog h2,\n  .upload-dialog h3,\n  .upload-dialog h4,\n  .upload-dialog h5,\n  .upload-dialog h6,\n  .upload-dialog p,\n  .upload-dialog span,\n  .upload-dialog label,\n  .upload-dialog li,\n  .upload-dialog strong,\n  .upload-dialog .step-title-text,\n  .upload-dialog .step-description,\n  .upload-dialog .video-title,\n  .upload-dialog .video-title-sticky,\n  .upload-dialog .channel-name,\n  .upload-dialog .channel-meta {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .mat-mdc-text-field-wrapper,\n  .upload-dialog .mdc-text-field,\n  .upload-dialog .mdc-text-field--outlined,\n  .upload-dialog .mdc-text-field--filled,\n  .upload-dialog input,\n  .upload-dialog textarea,\n  .upload-dialog select {\n    background: #111827 !important;\n    color: #f9fafb !important;\n  }\n\n  .upload-dialog [style*=\"background-color: #f0f7ff\"],\n  .upload-dialog [style*=\"background: #f0f7ff\"],\n  .upload-dialog [style*=\"background-color:#f0f7ff\"],\n  .upload-dialog [style*=\"background:#f0f7ff\"],\n  .upload-dialog [style*=\"background-color: #e3f2fd\"],\n  .upload-dialog [style*=\"background: #e3f2fd\"],\n  .upload-dialog [style*=\"background-color:#e3f2fd\"],\n  .upload-dialog [style*=\"background:#e3f2fd\"] {\n    background: rgba(30, 41, 59, 0.75) !important;\n    background-color: rgba(30, 41, 59, 0.75) !important;\n  }\n\n  .upload-dialog [style*=\"color: #333\"],\n  .upload-dialog [style*=\"color:#333\"],\n  .upload-dialog [style*=\"color: #666\"],\n  .upload-dialog [style*=\"color:#666\"] {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .price-section .price-toggle-row,\n  .price-section .price-toggle-row {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    label {\n      color: #f3f4f6 !important;\n    }\n  }\n\n  .upload-dialog .icon-circle,\n  .icon-circle {\n    background: #1f2937 !important;\n\n    mat-icon {\n      color: #7ab8e8 !important;\n    }\n  }\n\n  .upload-dialog .icon-button,\n  .icon-button {\n    background: #1f2937 !important;\n    color: #f3f4f6 !important;\n\n    &:hover {\n      background: #334155 !important;\n    }\n  }\n}\n\n/* Dark mode – Items section surfaces */\n:host-context(body.theme-dark) {\n  // Legacy upload form panel (Item Group / Name / Qty / Image / Add Item)\n  .upload-dialog .items-section .legacy-upload-section,\n  .items-section .legacy-upload-section {\n    background: #1e293b !important;\n    border-radius: 8px;\n  }\n\n  .upload-dialog .items-section .item-image-upload label,\n  .items-section .item-image-upload label {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .items-section .item-image-upload .upload-icon-btn,\n  .items-section .item-image-upload .upload-icon-btn {\n    background: #334155 !important;\n\n    &:hover {\n      background: #475569 !important;\n    }\n\n    mat-icon {\n      color: #7ab8e8 !important;\n    }\n  }\n\n  .upload-dialog .items-section .section-subtitle,\n  .items-section .section-subtitle {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .items-section .upload-hint,\n  .items-section .upload-hint {\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog .items-section .upload-multiple-section,\n  .items-section .upload-multiple-section {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.4) !important;\n  }\n\n  .upload-dialog .items-section .item-card .item-info strong,\n  .items-section .item-card .item-info strong {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .items-section .item-card .item-info span,\n  .items-section .item-card .item-info span {\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog .items-section .item-card .remove-item-btn:hover,\n  .items-section .item-card .remove-item-btn:hover {\n    background: rgba(239, 68, 68, 0.15) !important;\n  }\n}\n\n// Review Section - Matching Create Flow Style\n.flow-layout-container {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n\n  .flow-main-grid {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) 402px;\n    gap: 24px;\n    max-width: 100%;\n    margin: 0;\n    padding: 16px 24px;\n    background: #f6f7f9;\n\n    @media (min-width: 1920px) {\n      max-width: 1920px;\n      margin: 0 auto;\n      padding: 24px 48px;\n    }\n\n    @media (max-width: 1024px) {\n      grid-template-columns: 1fr;\n      gap: 16px;\n      padding: 16px;\n      background: transparent;\n    }\n\n    @media (max-width: 768px) {\n      padding: 12px;\n      gap: 12px;\n    }\n  }\n}\n\n.flow-main-content {\n  min-width: 0;\n\n  .flow-title-sticky {\n    background: #ffffff;\n    border-radius: 16px;\n    padding: 16px;\n    margin-bottom: 16px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    @media (max-width: 1024px) {\n      border-radius: 0;\n      box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);\n      border-bottom: 1px solid #e0e0e0;\n      padding: 16px 0 8px 0;\n      margin-bottom: 8px;\n    }\n\n    .video-title-sticky {\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 1.3;\n      color: #0f0f0f;\n      margin: 4px;\n      font-family: \"Raleway\", sans-serif;\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  .flow-info-panel {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    background: #ffffff;\n    border-radius: 16px;\n    margin-bottom: 16px;\n\n    @media (max-width: 1024px) {\n      background: #f9f9f9;\n      border-radius: 8px;\n    }\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n    scrollbar-color: #888 #f1f1f1;\n\n    &::-webkit-scrollbar {\n      height: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: #f1f1f1;\n      border-radius: 3px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: #888;\n      border-radius: 3px;\n\n      &:hover {\n        background: #555;\n      }\n    }\n\n    .info-badge {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      font-size: 13px;\n      font-weight: 500;\n      font-family: \"Raleway\", sans-serif;\n      color: #0f0f0f;\n      background: #fff;\n      border: 1px solid #e0e0e0;\n      border-radius: 16px;\n      padding: 4px 12px;\n      cursor: pointer;\n      transition: all 0.2s;\n      white-space: nowrap;\n      flex-shrink: 0;\n      min-width: fit-content;\n\n      &:hover {\n        background: #f5f5f5;\n        border-color: #5ea1d8;\n      }\n\n      &.active {\n        background: #5ea1d8;\n        color: #fff;\n        border-color: #5ea1d8;\n\n        .info-icon,\n        .info-label,\n        .info-step-title {\n          color: #fff;\n        }\n      }\n\n      .info-icon {\n        font-size: 14px;\n        flex-shrink: 0;\n        line-height: 1;\n      }\n\n      .info-label {\n        font-family: \"Raleway\", sans-serif;\n        flex-shrink: 0;\n        font-size: 13px;\n      }\n\n      .info-step-title {\n        font-size: 11px;\n        color: #606060;\n        margin-left: 4px;\n        max-width: 120px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        font-family: \"Raleway\", sans-serif;\n\n        @media (max-width: 768px) {\n          display: none;\n        }\n      }\n    }\n\n    @media (max-width: 768px) {\n      gap: 6px;\n      padding: 10px 12px;\n\n      .info-badge {\n        font-size: 12px;\n        padding: 3px 10px;\n        font-family: \"Raleway\", sans-serif;\n\n        .info-icon {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n\n  .video-player-section {\n    background: #000;\n    border-radius: 12px;\n    overflow: visible;\n    margin-bottom: 16px;\n    position: relative;\n\n    .img-wrap {\n      width: 100%;\n      position: relative;\n      padding-bottom: 56.25%; // 16:9 aspect ratio\n      height: 0;\n      overflow: hidden;\n      background: #000;\n\n      &.has-video-content {\n        padding-bottom: 0;\n        height: auto;\n        min-height: 200px;\n        aspect-ratio: 16 / 9;\n        overflow: visible;\n\n        .video-wrapper {\n          position: relative;\n          width: 100%;\n          height: 100%;\n          min-height: 200px;\n          aspect-ratio: 16 / 9;\n        }\n\n        .main-video-player {\n          position: relative;\n          top: auto;\n          left: auto;\n          width: 100%;\n          height: 100%;\n          min-height: 200px;\n          display: block;\n          object-fit: contain;\n          background: #000;\n        }\n      }\n\n      img,\n      video {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n        background: #000;\n      }\n\n      .video-wrapper {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: #000;\n      }\n\n      .main-video-player {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        object-fit: contain;\n        background: #000;\n      }\n\n      .media-missing-placeholder {\n        position: absolute;\n        inset: 0;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        padding: 16px;\n        text-align: center;\n        color: #e5e7eb;\n        background: #111827;\n\n        mat-icon {\n          font-size: 36px;\n          width: 36px;\n          height: 36px;\n          color: #94a3b8;\n        }\n\n        p {\n          margin: 0;\n          font-size: 13px;\n          line-height: 1.45;\n          max-width: 280px;\n        }\n      }\n    }\n\n    .step-clip-limit-toggle {\n      padding: 12px 16px;\n      background: #fff;\n      border-top: 1px solid #e4e8f0;\n    }\n\n    .item {\n      padding: 20px;\n      background: #fff;\n      width: 100%;\n      min-height: 400px;\n\n      .item-table {\n        .example-list {\n          .example-box {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            padding: 12px;\n            border-bottom: 1px solid #e4e8f0;\n\n            .item-value {\n              flex: 1;\n              color: #374151;\n            }\n          }\n        }\n      }\n    }\n\n    .clickarrow {\n      position: absolute;\n      top: 50%;\n      left: 0;\n      right: 0;\n      transform: translateY(-50%);\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 0 16px;\n      pointer-events: none;\n\n      .owl-prev,\n      .owl-next {\n        pointer-events: all;\n        background: rgba(0, 0, 0, 0.65);\n        color: #fff;\n        border: none;\n        border-radius: 50%;\n        width: 48px;\n        height: 48px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        transition: background 0.2s, transform 0.2s;\n        font-size: 26px;\n        font-weight: bold;\n        padding: 0;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n        margin: 0;\n\n        &:hover:not(:disabled) {\n          background: rgba(0, 0, 0, 0.8);\n          transform: translateY(-1px);\n        }\n\n        &:disabled,\n        &[hidden] {\n          display: none;\n        }\n\n        span {\n          font-size: 30px;\n          line-height: 1;\n          font-weight: bold;\n        }\n      }\n\n      .owl-prev {\n        margin-right: auto;\n        margin-left: 0;\n      }\n\n      .owl-next {\n        margin-left: auto;\n        margin-right: 0;\n      }\n    }\n  }\n\n  .summary-details-section {\n    margin-top: 16px;\n\n    .summary-description {\n      .summary-title {\n        font-size: 20px;\n        font-weight: 600;\n        color: #0f0f0f;\n        margin: 0 0 12px 0;\n        font-family: \"Raleway\", sans-serif;\n      }\n\n      .summary-info-pills {\n        display: flex;\n        gap: 8px;\n        flex-wrap: wrap;\n        margin-bottom: 16px;\n\n        .summary-pill {\n          display: inline-flex;\n          align-items: center;\n          gap: 6px;\n          padding: 4px 12px;\n          border-radius: 999px;\n          background: #f3f4f6;\n          color: #111827;\n          font-size: 13px;\n          font-weight: 500;\n        }\n      }\n\n      .summary-text {\n        font-size: 14px;\n        line-height: 1.6;\n        color: #374151;\n        margin: 0;\n        font-family: \"Raleway\", sans-serif;\n      }\n    }\n  }\n}\n\n// Video Metadata Section\n.video-metadata {\n  padding: 16px;\n  background: #ffffff;\n  border-radius: 16px;\n  margin-bottom: 16px;\n\n  .review-action-bar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 12px;\n  }\n\n  .review-action-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 8px 12px;\n    border: none;\n    border-radius: 8px;\n    background: #5ea1d8;\n    color: #fff;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n\n    &--secondary {\n      background: #f3f4f6;\n      color: #374151;\n      border: 1px solid #e5e7eb;\n    }\n  }\n\n  @media (max-width: 1024px) {\n    padding: 16px 0;\n    background: transparent;\n    border-radius: 0;\n    box-shadow: none;\n    border-bottom: 1px solid #e0e0e0;\n  }\n\n  .step-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 12px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    .step-header-main {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      flex: 1;\n      min-width: 0;\n    }\n\n    .s-num {\n      flex-shrink: 0;\n      width: 32px;\n      height: 32px;\n      border-radius: 50%;\n      background: #065fd4;\n      color: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-weight: 600;\n      font-size: 14px;\n    }\n\n    .video-title {\n      font-size: 20px;\n      font-weight: 500;\n      line-height: 28px;\n      color: #0f0f0f;\n      margin: 0;\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  .video-actions-bar {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n\n    &::-webkit-scrollbar {\n      height: 6px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: rgba(0, 0, 0, 0.2);\n      border-radius: 4px;\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      background: rgba(0, 0, 0, 0.3);\n    }\n\n    .action-buttons {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      flex-wrap: nowrap;\n      width: max-content;\n\n      .action-item {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        padding: 8px 16px;\n        border-radius: 18px;\n        cursor: pointer;\n        transition: background 0.2s;\n        background: #f2f2f2;\n        flex: 0 0 auto;\n\n        &:hover:not(.disabled) {\n          background: #e5e5e5;\n        }\n\n        &.disabled {\n          opacity: 0.5;\n          cursor: not-allowed;\n          pointer-events: none;\n        }\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n\n        span {\n          font-size: 14px;\n          color: #0f0f0f;\n        }\n      }\n    }\n  }\n}\n\n// Channel Info Section\n.channel-info-section {\n  padding: 16px;\n  background: #ffffff;\n  border-radius: 16px;\n  margin-bottom: 16px;\n\n  @media (max-width: 1024px) {\n    padding: 16px 0;\n    background: transparent;\n    border-radius: 0;\n    box-shadow: none;\n    border-bottom: 1px solid #e0e0e0;\n  }\n\n  .channel-header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n\n    .channel-avatar {\n      flex-shrink: 0;\n\n      img {\n        width: 48px;\n        height: 48px;\n        border-radius: 50%;\n        object-fit: cover;\n        cursor: pointer;\n\n        @media (max-width: 768px) {\n          width: 40px;\n          height: 40px;\n        }\n      }\n\n      .material-icons {\n        font-size: 48px;\n        width: 48px;\n        height: 48px;\n        color: #606060;\n        cursor: pointer;\n\n        @media (max-width: 768px) {\n          font-size: 40px;\n          width: 40px;\n          height: 40px;\n        }\n      }\n    }\n\n    .channel-details {\n      flex: 1;\n      min-width: 0;\n\n      .channel-name {\n        font-size: 16px;\n        font-weight: 500;\n        color: #0f0f0f;\n        cursor: pointer;\n        margin-bottom: 4px;\n\n        &:hover {\n          color: #606060;\n        }\n      }\n\n      .channel-meta {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        flex-wrap: wrap;\n        font-size: 14px;\n        color: #606060;\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n        }\n\n        .price-tag {\n          font-weight: 600;\n          color: #d32f2f;\n        }\n      }\n    }\n  }\n}\n\n// Description Section\n.description-section {\n  padding: 16px;\n  background: #ffffff;\n  border-radius: 16px;\n  margin-bottom: 16px;\n\n  @media (max-width: 1024px) {\n    background: #f9f9f9;\n    border-radius: 12px;\n    box-shadow: none;\n  }\n\n  .description-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: -16px !important;\n    position: relative;\n\n    h3 {\n      font-size: 16px;\n      font-weight: 500;\n      color: #0f0f0f;\n      margin: 0;\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      flex: 1;\n\n      .duration-timer {\n        display: inline-flex;\n        align-items: center;\n        gap: 4px;\n        font-size: 14px;\n        color: #606060;\n        white-space: nowrap;\n        margin-left: auto;\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n          display: inline-flex;\n          align-items: center;\n          vertical-align: middle;\n          margin: 0;\n          flex-shrink: 0;\n        }\n\n        @media (max-width: 768px) {\n          font-size: 13px;\n\n          mat-icon {\n            font-size: 14px;\n            width: 14px;\n            height: 14px;\n          }\n        }\n      }\n    }\n  }\n\n  .description-content {\n    font-size: 14px;\n    line-height: 20px;\n    color: #0f0f0f;\n    max-height: 60px;\n    overflow: hidden;\n    transition: max-height 0.3s ease;\n\n    &.expanded {\n      max-height: none;\n    }\n  }\n}\n\n// Sidebar - Matching Viewflow Style\n.flow-sidebar.summary-preview-sidebar {\n  width: 402px;\n  min-width: 402px;\n  max-width: 402px;\n  position: relative;\n  z-index: 10;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1024px) {\n    width: 100%;\n    min-width: 100%;\n    max-width: 100%;\n  }\n\n  .step-navigation {\n    margin-bottom: 24px;\n    flex: 0 0 auto;\n    min-height: 0;\n\n    .step-scroll {\n      max-height: calc((100vw - 48px - 402px - 24px) * 0.5625 + 80px);\n      \n      @media (min-width: 1920px) {\n        max-height: calc((1920px - 96px - 402px - 24px) * 0.5625 + 80px);\n      }\n\n      @media (max-width: 1024px) {\n        max-height: calc((100vw - 32px) * 0.5625);\n      }\n\n      overflow-y: auto;\n      overflow-x: hidden;\n      display: block;\n      width: 100%;\n      padding-right: 8px;\n\n      &::-webkit-scrollbar {\n        width: 8px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: #f1f1f1;\n        border-radius: 4px;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background: #888;\n        border-radius: 4px;\n\n        &:hover {\n          background: #555;\n        }\n      }\n    }\n\n    .steps-list {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      width: 100%;\n      align-items: stretch;\n    }\n\n    .step-btn {\n      padding-block: 1em;\n      padding-inline: 1.125em;\n      border: 1px solid #e0e0e0;\n      border-radius: 6px;\n      background: white;\n      cursor: pointer;\n      font-size: 13px;\n      font-weight: 500;\n      color: #0f0f0f;\n      text-align: left;\n      transition: all 0.2s;\n      display: flex;\n      flex-direction: row;\n      align-items: flex-start;\n      gap: 8px;\n      width: 100%;\n      height: auto;\n      min-height: auto;\n      white-space: normal;\n      word-break: break-word;\n      overflow: visible;\n\n      .step-text-block {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n        flex: 1 1 auto;\n        min-width: 0;\n      }\n\n      &:hover:not(.active) {\n        background: #f9f9f9;\n        border-color: #c0c0c0;\n      }\n\n      &.active {\n        background: #5ea1d8 !important;\n        color: #ffffff !important;\n        border: none !important;\n        outline: none !important;\n        box-shadow: none !important;\n        transition: none !important;\n\n        .step-number,\n        .step-title-text {\n          color: #ffffff !important;\n        }\n\n        &:hover {\n          background: #5ea1d8 !important;\n          border: none !important;\n        }\n      }\n\n      .step-number {\n        font-size: 13px;\n        font-weight: 600;\n        font-family: \"Raleway\", sans-serif;\n        flex-shrink: 0;\n      }\n\n      .step-title-text {\n        font-size: 13px;\n        font-weight: 400;\n        font-family: \"Raleway\", sans-serif;\n        line-height: 1.4;\n        word-wrap: break-word;\n        overflow: visible;\n        text-overflow: clip;\n        display: block;\n        flex: 1 1 auto;\n        white-space: normal;\n      }\n    }\n\n    .step-panel {\n      display: block;\n      width: 100%;\n    }\n\n    .step-panel .step-btn {\n      width: 100%;\n    }\n\n    .step-panel.active .step-btn {\n      background: #5ea1d8 !important;\n      color: #ffffff !important;\n      border: none !important;\n      outline: none !important;\n      box-shadow: none !important;\n      transition: none !important;\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n\n      .step-number,\n      .step-title-text {\n        color: #ffffff !important;\n      }\n\n      &:hover {\n        background: #5ea1d8 !important;\n        border: none !important;\n      }\n    }\n\n    .step-panel-body {\n      border: 1px solid #e0e0e0;\n      border-top: 0;\n      border-bottom-left-radius: 6px;\n      border-bottom-right-radius: 6px;\n      background: #ffffff;\n      padding: 12px;\n      margin-top: 0;\n      width: 100%;\n      box-sizing: border-box;\n    }\n\n    .step-panel.active .step-panel-body {\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n    }\n\n    .step-description {\n      font-size: 13px;\n      font-weight: 400;\n      font-family: \"Open Sans\", sans-serif;\n      line-height: 1.4;\n\n      :where(p, span, div) {\n        margin: 0;\n      }\n    }\n  }\n}\n\n// Mobile Responsive Styles\n@media (max-width: 1024px) {\n  .flow-main-grid {\n    grid-template-columns: 1fr !important;\n  }\n\n  .flow-sidebar.summary-preview-sidebar {\n    position: relative;\n    top: 0;\n    margin-top: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .video-metadata {\n    .step-header {\n      .step-header-main {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n\n      .s-num {\n        width: 28px;\n        height: 28px;\n        font-size: 12px;\n      }\n\n      .video-title {\n        font-size: 18px;\n      }\n    }\n\n    .video-actions-bar {\n      .action-buttons {\n        .action-item {\n          padding: 6px 12px;\n          font-size: 12px;\n\n          span {\n            display: none;\n          }\n        }\n      }\n    }\n  }\n\n  .channel-info-section {\n    .channel-header {\n      .channel-avatar .material-icons {\n        font-size: 40px;\n        width: 40px;\n        height: 40px;\n      }\n\n      .channel-details {\n        .channel-name {\n          font-size: 14px;\n        }\n\n        .channel-meta {\n          font-size: 12px;\n        }\n      }\n    }\n  }\n\n  .description-section {\n    padding: 12px;\n\n    &.mobile-instructions-collapsed {\n      padding: 8px 12px;\n      margin-bottom: 8px;\n    }\n\n    .description-header h3 {\n      font-size: 14px;\n    }\n\n    .description-content {\n      font-size: 13px;\n    }\n\n    .mobile-instructions-toggle {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      width: 100%;\n      padding: 8px 10px;\n      border: 1px solid #e0e0e0;\n      border-radius: 8px;\n      background: #fff;\n      cursor: pointer;\n      font-size: 14px;\n      font-weight: 500;\n      color: #0f0f0f;\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n        color: #5ea1d8;\n      }\n\n      .toggle-chevron {\n        margin-left: auto;\n        color: #606060;\n      }\n    }\n  }\n}\n\n// Footer Actions\n\n// Footer Actions\n.quick-create-footer {\n  padding: 20px 24px;\n  border-top: 1px solid #e4e8f0;\n  background: white;\n  display: flex !important; /* Override global `footer { display: none }` at ≤992px */\n  justify-content: flex-end;\n  gap: 12px;\n\n  .footer-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    .approval-hint {\n      font-size: 13px;\n      color: #6b7280;\n    }\n\n    .btn-primary,\n    .btn-secondary {\n      padding: 12px 24px;\n      border-radius: 8px;\n      font-size: 14px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      border: none;\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n\n    .btn-primary {\n      background: #5ea1d8;\n      color: white;\n\n      &:hover:not(:disabled) {\n        background: #4a8fc4;\n      }\n    }\n\n    .btn-secondary {\n      background: #f3f4f6;\n      color: #374151;\n\n      &:hover:not(:disabled) {\n        background: #e5e7eb;\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 12px 16px;\n    flex-direction: row;\n    justify-content: stretch;\n\n    .footer-actions {\n      flex-direction: row;\n      width: 100%;\n      gap: 8px;\n\n      button {\n        flex: 1;\n        min-width: 0;\n        width: auto;\n        padding: 10px 8px;\n        font-size: 13px;\n        white-space: nowrap;\n      }\n    }\n  }\n}\n\n.actions-section {\n  .action-buttons {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n    padding-top: 16px;\n\n    @media (max-width: 768px) {\n      flex-direction: column-reverse;\n\n      button {\n        width: 100%;\n      }\n    }\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    padding: 12px 24px;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: none;\n  }\n\n  .btn-primary {\n    background: #5ea1d8;\n    color: white;\n\n    &:hover {\n      background: #4a8fc4;\n    }\n  }\n\n  .btn-secondary {\n    background: #f3f4f6;\n    color: #374151;\n\n    &:hover {\n      background: #e5e7eb;\n    }\n  }\n}\n\n// Mobile Responsive\n@media (max-width: 768px) {\n  .quick-create-dialog {\n    width: 100%;\n    max-width: 100%;\n    height: 100vh;\n    height: 100dvh;\n    max-height: 100dvh;\n    border-radius: 0;\n  }\n\n  .smart-create-header {\n    padding: 12px 16px;\n    padding-top: calc(12px + env(safe-area-inset-top, 0));\n    align-items: flex-start;\n\n    .icon-circle {\n      width: 40px;\n      height: 40px;\n      border-radius: 12px;\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n      }\n    }\n\n    .title {\n      font-size: 15px;\n    }\n\n    .header-phase-badge {\n      font-size: 10px;\n      padding: 3px 8px;\n    }\n\n    .header-subtitle {\n      font-size: 13px;\n      -webkit-line-clamp: 3;\n    }\n\n    .icon-button {\n      width: 36px;\n      height: 36px;\n\n      mat-icon {\n        font-size: 20px;\n      }\n    }\n  }\n\n  .stage-banner {\n    padding: 0 12px;\n  }\n\n  .quick-create-body {\n    padding: 16px;\n    padding-bottom: calc(16px + env(safe-area-inset-bottom, 0));\n  }\n\n  .quick-create-footer {\n    padding: 12px 16px;\n    padding-bottom: calc(12px + env(safe-area-inset-bottom, 0));\n  }\n\n  .steps-grid {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr !important;\n\n    .flex-2 {\n      grid-column: span 1 !important;\n    }\n  }\n}\n\n/* Dark mode – buttons, chips, step nav, action pills (Quick Create Flow) */\n:host-context(body.theme-dark) {\n  // Info/nav badge chips\n  .upload-dialog .info-badge,\n  .info-badge {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n\n    &:hover {\n      background: #334155 !important;\n    }\n\n    .info-step-title {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .upload-dialog .action-item,\n  .action-item {\n    background: #1e293b !important;\n\n    &:hover:not(.disabled) {\n      background: #334155 !important;\n    }\n\n    span {\n      color: #f3f4f6 !important;\n    }\n\n    mat-icon {\n      color: #f3f4f6 !important;\n    }\n  }\n\n  // Sidebar step buttons\n  .upload-dialog .step-btn,\n  .step-btn {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    .step-number,\n    .step-title-text {\n      color: #f3f4f6 !important;\n    }\n\n    &:hover:not(.active) {\n      background: #334155 !important;\n      border-color: rgba(148, 163, 184, 0.5) !important;\n    }\n  }\n\n  // Summary review pills\n  .upload-dialog .summary-pill,\n  .summary-pill {\n    background: #1e293b !important;\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .summary-text,\n  .summary-text {\n    color: #cbd5e1 !important;\n  }\n\n  // Footer secondary buttons\n  .upload-dialog .quick-create-footer,\n  .quick-create-footer {\n    background: #111827 !important;\n    border-top-color: rgba(148, 163, 184, 0.28) !important;\n\n    .btn-secondary {\n      background: #1e293b !important;\n      color: #f3f4f6 !important;\n      border: 1px solid rgba(148, 163, 184, 0.35) !important;\n\n      &:hover:not(:disabled) {\n        background: #334155 !important;\n      }\n    }\n  }\n\n  // Channel info section\n  .upload-dialog .channel-info-section,\n  .channel-info-section {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .video-metadata .review-action-btn {\n    background: #5ea1d8 !important;\n    color: #fff !important;\n\n    &--secondary {\n      background: #1e293b !important;\n      color: #f3f4f6 !important;\n      border-color: rgba(148, 163, 184, 0.35) !important;\n    }\n  }\n\n  // Step connector bar (inactive)\n  .upload-dialog .step-connector,\n  .step-connector {\n    background: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  // Journey step inactive text\n  .upload-dialog .journey-step:not(.active):not(.complete),\n  .journey-step:not(.active):not(.complete) {\n    color: #64748b !important;\n  }\n}\n\n/* Dark mode – Added Items list, FAQ list, info-color fixes (Quick Create Flow) */\n:host-context(body.theme-dark) {\n  /* ── Item cards: distinct visible box ──────────────────────────────── */\n  .upload-dialog .item-card,\n  .items-section .item-card {\n    background: #1e293b !important;\n    border: 1px solid rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .upload-dialog .item-card .remove-item-btn:hover,\n  .items-section .item-card .remove-item-btn:hover {\n    background: rgba(239, 68, 68, 0.15) !important;\n  }\n\n  /* ── FAQ cards: fix white bg + inner chip + body text ──────────────── */\n  .upload-dialog .faq-card,\n  .faqs-section .faq-card {\n    background: #1e293b !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n    border-left-color: #5ea1d8 !important;\n  }\n\n  .upload-dialog .faq-card .faq-info span,\n  .faqs-section .faq-card .faq-info span {\n    background: #0f172a !important;\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog .faq-card .faq-info p,\n  .faqs-section .faq-card .faq-info p {\n    color: #94a3b8 !important;\n  }\n\n  .upload-dialog .faq-card .faq-info strong,\n  .faqs-section .faq-card .faq-info strong {\n    color: #f3f4f6 !important;\n  }\n\n  .upload-dialog .faq-card .remove-faq-btn:hover,\n  .faqs-section .faq-card .remove-faq-btn:hover {\n    background: rgba(239, 68, 68, 0.15) !important;\n  }\n\n  /* ── Inline #1d67a3 blue text (info banners, metadata) ─────────────── */\n  .upload-dialog [style*=\"color: #1d67a3\"],\n  .upload-dialog [style*=\"color:#1d67a3\"] {\n    color: #7ab8e8 !important;\n  }\n\n  /* ── strong tags with inline #1d67a3 color ─────────────────────────── */\n  .upload-dialog strong[style*=\"color: #1d67a3\"],\n  .upload-dialog strong[style*=\"color:#1d67a3\"] {\n    color: #7ab8e8 !important;\n  }\n\n  /* ── mat-icon inside inline-colored info banners ────────────────────── */\n  .upload-dialog [style*=\"color: #1d67a3\"] mat-icon,\n  .upload-dialog [style*=\"color:#1d67a3\"] mat-icon {\n    color: #7ab8e8 !important;\n  }\n}\n\n.duration-input-group {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  width: 100%;\n\n  .duration-unit-field {\n    width: 120px;\n    flex-shrink: 0;\n  }\n\n  .duration-value-field {\n    flex: 1;\n  }\n}\n\n.ai-processing-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10001;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.ai-processing-card {\n  background: #fff;\n  border-radius: 16px;\n  padding: 32px 40px;\n  max-width: 420px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\n\n  h3 {\n    margin: 12px 0 8px;\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  p {\n    margin: 0 0 20px;\n    color: #6b7280;\n    font-size: 14px;\n  }\n}\n\n.ai-spin-icon {\n  font-size: 48px;\n  width: 48px;\n  height: 48px;\n  color: #5ea1d8;\n  animation: ai-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes ai-pulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.7;\n    transform: scale(1.05);\n  }\n}\n\n.ai-progress-bar {\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.ai-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #5ea1d8, #3d7eb8);\n  transition: width 0.4s ease;\n}\n\n.ai-progress-text {\n  font-size: 13px;\n  color: #6b7280;\n  font-weight: 600;\n}\n\n.ai-icon-header {\n  background: linear-gradient(135deg, #eef6fc, #ede9fe) !important;\n\n  mat-icon {\n    color: #7c3aed !important;\n  }\n}\n\n.pieces-ai-fallback-banner {\n  margin: 0 24px 12px;\n  border-radius: 12px;\n  border: 1px solid #fcd34d;\n  background: #fffbeb;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 14px;\n\n  > mat-icon {\n    color: #d97706;\n    flex-shrink: 0;\n    margin-top: 2px;\n  }\n\n  .pieces-ai-fallback-title {\n    margin: 0 0 4px;\n    font-size: 14px;\n    font-weight: 700;\n    color: #92400e;\n  }\n\n  .pieces-ai-fallback-text {\n    margin: 0;\n    font-size: 13px;\n    line-height: 1.45;\n    color: #78350f;\n  }\n\n  .pieces-ai-generate-btn {\n    margin-left: auto;\n    flex-shrink: 0;\n  }\n\n  @media (max-width: 768px) {\n    margin: 0 12px 10px;\n    flex-wrap: wrap;\n\n    .pieces-ai-generate-btn {\n      margin-left: 0;\n      width: 100%;\n    }\n  }\n}\n\n.pieces-ai-banner {\n  margin: 0 24px 12px;\n  border-radius: 12px;\n  border: 1px solid #c7d2fe;\n  background: linear-gradient(135deg, #f8fbff 0%, #f5f3ff 100%);\n  overflow: hidden;\n\n  @media (max-width: 768px) {\n    margin: 0 12px 10px;\n  }\n}\n\n.pieces-ai-banner-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  min-height: 56px;\n\n  .pieces-ai-banner-title {\n    margin: 0;\n    font-size: 13px;\n    line-height: 1.35;\n  }\n}\n\n.pieces-ai-banner-summary {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n\n.pieces-ai-summary-icon {\n  color: #7c3aed;\n  flex-shrink: 0;\n}\n\n.pieces-ai-banner-details {\n  padding: 0 12px 12px;\n  max-height: min(38vh, 320px);\n  overflow-y: auto;\n  border-top: 1px solid rgba(199, 210, 254, 0.7);\n}\n\n.pieces-ai-banner-copy--inline {\n  min-width: 0;\n}\n\n.pieces-ai-banner-text--inline {\n  margin-bottom: 0 !important;\n  font-size: 12px !important;\n}\n\n.pieces-ai-banner-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 1px solid #c7d2fe;\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n  flex-shrink: 0;\n  margin: 0 !important;\n\n  mat-icon {\n    color: #7c3aed;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n/* Chevron rotation for expand/collapse panels */\n.pieces-ai-chevron {\n  transition: transform 0.3s ease;\n  \n  &.expanded {\n    transform: rotate(180deg);\n  }\n}\n\n/* Step preview button - centered eye icon overlay on step thumbnails */\n.step-preview-btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: rgba(94, 161, 216, 0.85);\n  color: white;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  z-index: 15;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n\n  &:hover {\n    background: #5ea1d8;\n    transform: translate(-50%, -50%) scale(1.1);\n  }\n\n  mat-icon {\n    font-size: 24px;\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.pieces-ai-banner-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  mat-icon {\n    color: #7c3aed;\n  }\n}\n\n.pieces-ai-banner-copy {\n  flex: 1;\n  min-width: 200px;\n}\n\n.pieces-ai-banner-title {\n  margin: 0 0 6px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #312e81;\n}\n\n.pieces-ai-banner-text {\n  margin: 0 0 10px;\n  font-size: 13px;\n  color: #4b5563;\n  line-height: 1.45;\n}\n\n.pieces-ai-audio-warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: 6px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #92400e;\n}\n\n.pieces-ai-consent-section {\n  margin-top: 4px;\n\n  &.consent-highlight {\n    margin-top: 10px;\n    padding: 12px;\n    border-radius: 10px;\n    border: 1px solid #f59e0b;\n    background: #fffbeb;\n    animation: pieces-ai-consent-pulse 1.2s ease-in-out 2;\n  }\n}\n\n@keyframes pieces-ai-consent-pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0);\n  }\n  50% {\n    box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.2);\n  }\n}\n\n.pieces-ai-consent {\n  display: flex;\n  gap: 8px;\n  align-items: flex-start;\n  font-size: 12px;\n  color: #374151;\n  margin-bottom: 8px;\n  cursor: pointer;\n\n  input {\n    margin-top: 2px;\n    flex-shrink: 0;\n  }\n\n  a {\n    color: #2563eb;\n    font-weight: 600;\n    text-decoration: underline;\n  }\n}\n\n.pieces-ai-notes {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 8px 10px;\n  font-size: 13px;\n  resize: vertical;\n  min-height: 52px;\n}\n\n.pieces-ai-reference-doc {\n  margin-bottom: 10px;\n}\n\n.pieces-ai-doc-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #312e81;\n  margin-bottom: 6px;\n}\n\n.pieces-ai-doc-picker {\n  position: relative;\n  border: 1px dashed #c7d2fe;\n  border-radius: 8px;\n  background: #fff;\n  overflow: hidden;\n\n  input[type=\"file\"] {\n    position: absolute;\n    inset: 0;\n    opacity: 0;\n    cursor: pointer;\n    z-index: 1;\n  }\n}\n\n.pieces-ai-doc-copy,\n.pieces-ai-doc-selected {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  font-size: 12px;\n  color: #4b5563;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    color: #7c3aed;\n    flex-shrink: 0;\n  }\n\n  span {\n    flex: 1;\n    min-width: 0;\n    word-break: break-word;\n  }\n}\n\n.pieces-ai-doc-selected {\n  background: #f5f3ff;\n}\n\n.pieces-ai-doc-clear {\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  position: relative;\n  z-index: 2;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    color: inherit;\n  }\n}\n\n.pieces-ai-doc-hint {\n  margin: 6px 0 0;\n  font-size: 11px;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.pieces-ai-doc-support {\n  margin-top: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n}\n\n.pieces-ai-generate-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  border-radius: 10px;\n  padding: 8px 12px;\n  background: #5ea1d8;\n  color: #fff;\n  font-weight: 600;\n  font-size: 12px;\n  cursor: pointer;\n  flex-shrink: 0;\n  white-space: nowrap;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  @media (max-width: 768px) {\n    .pieces-ai-generate-label {\n      display: none;\n    }\n\n    padding: 8px 10px;\n  }\n}\n\n.upload-all-placeholder.pieces-mode {\n  border-color: #c7d2fe;\n  background: #fafaff;\n}\n\n.ai-policy-banner {\n  margin: 0 24px 10px;\n  border: 1px solid #dbeafe;\n  border-radius: 12px;\n  background: #f0f7ff;\n  flex-shrink: 0;\n  overflow: hidden;\n\n  &.collapsed {\n    border-color: #dbeafe;\n  }\n\n  &.expanded {\n    .ai-policy-details {\n      border-top: 1px solid rgba(219, 234, 254, 0.9);\n    }\n  }\n\n  @media (max-width: 768px) {\n    margin: 0 12px 10px;\n  }\n}\n\n.ai-policy-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  min-height: 48px;\n}\n\n.ai-policy-summary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n  text-align: left;\n\n  .ai-policy-title {\n    margin: 0;\n    font-size: 13px;\n    font-weight: 600;\n    color: #1e40af;\n    line-height: 1.3;\n  }\n}\n\n.ai-policy-summary-hint {\n  margin-left: auto;\n  font-size: 11px;\n  color: #6b7280;\n  white-space: nowrap;\n  flex-shrink: 0;\n\n  @media (max-width: 480px) {\n    display: none;\n  }\n}\n\n.ai-policy-details {\n  padding: 0 12px 12px 44px;\n  max-height: min(32vh, 240px);\n  overflow-y: auto;\n}\n\n.ai-policy-chevron {\n  color: #1d4ed8;\n  transition: transform 0.25s ease;\n\n  &.expanded {\n    transform: rotate(180deg);\n  }\n}\n\n.ai-policy-toggle-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 1px solid #dbeafe;\n  border-radius: 8px;\n  background: #fff;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.ai-policy-icon {\n  color: #1d4ed8;\n  flex-shrink: 0;\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n}\n\n.ai-policy-copy {\n  flex: 1;\n  min-width: 0;\n}\n\n.ai-policy-title {\n  margin: 0 0 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e40af;\n}\n\n.ai-policy-list {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 12px;\n  color: #374151;\n  line-height: 1.45;\n\n  li + li {\n    margin-top: 4px;\n  }\n}\n\n.ai-policy-links {\n  margin: 8px 0 0;\n  font-size: 12px;\n\n  a {\n    color: #2563eb;\n    font-weight: 600;\n    text-decoration: underline;\n  }\n}\n\n.ai-policy-sep {\n  margin: 0 6px;\n  color: #9ca3af;\n}\n\n/* Dark mode – Smart Create AI surfaces (added after base light styles) */\n:host-context(body.theme-dark) {\n  .upload-header {\n    background: #111827 !important;\n    color: #f3f4f6 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.28) !important;\n\n    .header-copy p,\n    .header-copy .title {\n      color: #f3f4f6 !important;\n    }\n\n    .header-copy span,\n    .header-copy .header-subtitle {\n      color: #94a3b8 !important;\n    }\n\n    .header-phase-badge {\n      color: #e9d5ff !important;\n      background: linear-gradient(135deg, #1e293b 0%, #312e81 100%) !important;\n      border-color: rgba(167, 139, 250, 0.35) !important;\n    }\n  }\n\n  .section-title {\n    color: #f3f4f6 !important;\n  }\n\n  .section-hint {\n    color: #94a3b8 !important;\n  }\n\n  .upload-all-placeholder {\n    background: #1e293b !important;\n    border-color: rgba(94, 161, 216, 0.5) !important;\n\n    &:hover {\n      background: #334155 !important;\n    }\n\n    p {\n      color: #f3f4f6 !important;\n    }\n\n    .upload-hint {\n      color: #94a3b8 !important;\n    }\n\n    mat-icon {\n      color: #7ab8e8 !important;\n    }\n  }\n\n  .upload-all-placeholder.pieces-mode {\n    background: #1e293b !important;\n    border-color: rgba(167, 139, 250, 0.45) !important;\n  }\n\n  .journey-step {\n    color: #94a3b8 !important;\n\n    &.active {\n      color: #7ab8e8 !important;\n\n      .step-label {\n        background: rgba(94, 161, 216, 0.15) !important;\n        border-color: #5ea1d8 !important;\n        color: #7ab8e8 !important;\n      }\n    }\n\n    &.complete {\n      color: #4ade80 !important;\n\n      .step-label {\n        background: rgba(74, 222, 128, 0.12) !important;\n        border-color: #4ade80 !important;\n        color: #4ade80 !important;\n      }\n    }\n  }\n\n  .step-label.complete {\n    background: rgba(74, 222, 128, 0.12) !important;\n    border-color: #4ade80 !important;\n    color: #4ade80 !important;\n  }\n\n  .ai-processing-card {\n    background: #111827 !important;\n    color: #f3f4f6 !important;\n    border: 1px solid rgba(148, 163, 184, 0.28);\n\n    h3 {\n      color: #f3f4f6 !important;\n    }\n\n    p {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .ai-progress-bar {\n    background: #334155 !important;\n  }\n\n  .ai-progress-text {\n    color: #cbd5e1 !important;\n  }\n\n  .ai-icon-header {\n    background: linear-gradient(135deg, #1e293b, #312e81) !important;\n\n    mat-icon {\n      color: #a78bfa !important;\n    }\n  }\n\n  .pieces-ai-banner {\n    background: linear-gradient(135deg, #1e293b 0%, #312e81 100%) !important;\n    border-color: rgba(167, 139, 250, 0.35) !important;\n  }\n\n  .pieces-ai-banner-details {\n    border-top-color: rgba(167, 139, 250, 0.25) !important;\n  }\n\n  .pieces-ai-banner-toggle-btn {\n    background: #1e293b !important;\n    border-color: rgba(167, 139, 250, 0.35) !important;\n    margin: 0 !important;\n\n    mat-icon {\n      color: #a78bfa !important;\n    }\n  }\n\n  .pieces-ai-banner-icon {\n    background: #0f172a !important;\n\n    mat-icon {\n      color: #a78bfa !important;\n    }\n  }\n\n  .pieces-ai-banner-title {\n    color: #e9d5ff !important;\n  }\n\n  .pieces-ai-banner-text {\n    color: #cbd5e1 !important;\n  }\n\n  .pieces-ai-consent {\n    color: #e5e7eb !important;\n\n    a {\n      color: #93c5fd !important;\n    }\n  }\n\n  .pieces-ai-consent-section.consent-highlight {\n    background: rgba(120, 53, 15, 0.35) !important;\n    border-color: rgba(245, 158, 11, 0.55) !important;\n  }\n\n  .pieces-ai-notes {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n    color: #f9fafb !important;\n\n    &::placeholder {\n      color: #64748b;\n    }\n  }\n\n  .pieces-ai-doc-label {\n    color: #e9d5ff !important;\n  }\n\n  .pieces-ai-doc-picker {\n    border-color: rgba(167, 139, 250, 0.35) !important;\n    background: #111827 !important;\n  }\n\n  .pieces-ai-doc-copy,\n  .pieces-ai-doc-selected {\n    color: #cbd5e1 !important;\n\n    mat-icon {\n      color: #a78bfa !important;\n    }\n  }\n\n  .pieces-ai-doc-selected {\n    background: #1e293b !important;\n  }\n\n  .pieces-ai-doc-hint {\n    color: #94a3b8 !important;\n  }\n\n  .pieces-ai-doc-support {\n    background: #0f172a !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n  }\n\n  .pieces-ai-audio-warning {\n    background: rgba(120, 53, 15, 0.35) !important;\n    border-color: rgba(245, 158, 11, 0.55) !important;\n    color: #fde68a !important;\n\n    mat-icon {\n      color: #fbbf24 !important;\n    }\n\n    strong {\n      color: #fde68a !important;\n    }\n  }\n\n  .ai-policy-banner {\n    background: rgba(30, 58, 95, 0.65) !important;\n    border-color: rgba(94, 161, 216, 0.35) !important;\n  }\n\n  .ai-policy-toolbar {\n    background: transparent;\n  }\n\n  .ai-policy-summary .ai-policy-title {\n    color: #93c5fd !important;\n  }\n\n  .ai-policy-summary-hint {\n    color: #94a3b8 !important;\n  }\n\n  .ai-policy-details {\n    border-top-color: rgba(94, 161, 216, 0.25) !important;\n  }\n\n  .ai-policy-toggle-btn {\n    background: #1e293b !important;\n    border-color: rgba(94, 161, 216, 0.35) !important;\n  }\n\n  .ai-policy-chevron {\n    color: #7ab8e8 !important;\n  }\n\n  .ai-policy-icon {\n    color: #7ab8e8 !important;\n  }\n\n  .ai-policy-title {\n    color: #93c5fd !important;\n  }\n\n  .ai-policy-list {\n    color: #cbd5e1 !important;\n  }\n\n  .ai-policy-links a {\n    color: #93c5fd !important;\n  }\n\n  .ai-policy-sep {\n    color: #64748b !important;\n  }\n\n  .media-size-recommendation {\n    background: rgba(30, 58, 95, 0.55) !important;\n    border-left-color: #5ea1d8 !important;\n\n    strong,\n    div {\n      color: #e5e7eb !important;\n    }\n\n    mat-icon {\n      color: #7ab8e8 !important;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
